import React, { useState,useEffect , useRef} from "react";
import Sidebar from "../Sidebar";
import './Fcmt.style.css';
import { Form, Row, Col, Select, Card, InputNumber, Checkbox, Button, Spin, Tabs, Switch, Input, Radio, Space,  Table, Modal, Empty,DatePicker, TimePicker,Tooltip} from "antd";
import { FcmtSubmit } from "../Helper/FcmtHelper";
import { useSelector } from "react-redux";
import moment from 'moment';
import {
  FileSearchOutlined 
} from '@ant-design/icons';
import * as Plotly from 'plotly.js/dist/plotly';

import Plot from "react-plotly.js";
import PDFMakerFCMT from "./PDFMakerFCMT";
import generatePDF from "react-to-pdf";
import ProductData from "./product.js";
import ExportFile from "./ExportFile.js";
import calculateUAParameters from "./calculateUAParameters.js";
import EmissionMapModal from './EmissionMapModal.js';
import europegeo from './europeGeoJson'
import europedata from './europeData'
import usandata from "./usandata.js";
import usangeo from "./usangeo.js";
// import europegeo from "./eu.js";
import MapComponent from "./MapComponent.js";
import FieldInfoModal from './FieldInfoModal';
import {
  InfoCircleOutlined
} from '@ant-design/icons';

import { fieldInfo } from "./FieldinfoConst.js";



export default function Fcmt() {
  const [visibleModal, setVisibleModal] = useState(false);
  const [selectedTime, setSelectedTime] = useState(moment());
  const [selectedMonth, setSelectedMonth] = useState(0);
  const [selectedDate, setSelectedDate] = useState(1); 
  const [selectedHour, setSelectedHour] = useState(8); 
  const [selectedMinute, setSelectedMinute] = useState(0);
  const [selectedPeriod, setSelectedPeriod] = useState('AM');
  const [inputValue, setInputValue] = useState('January 1, 8 AM');
  const [dates, setDates] = useState(Array.from({ length: 31 }, (_, i) => i + 1));
  const [isModalVisible, setIsModalVisible] = useState(false);
  const products=ProductData();
  const [form] = Form.useForm();
  const { TabPane } = Tabs;
  const { Option } = Select;
  const resultRef = useRef(null);
  const btnRef = useRef(null);
  const ampTemp = useRef(null);
  const textData = [
    {
      label: "Age Corrected UA Factor",
      value: 160.77,
      unit: "Btu/(°F-h)",
    },
    {
      label: "Box Thermal Mass",
      value: 929000,
      unit: "Btu/°F",
    },
  ];
  const locationNorthAmerica =[
    "Albuquerque, NM",
    "Atlanta, GA",
    "Augusta, GA",
    "Bakersfield, CA",
    "Bangor, ME",
    "Barstow, CA",
    "Baton Rouge, LA",
    "Billings, MT",
    "Bismarck, ND",
    "Boise, ID",
    "Boston, MA",
    "Bridgeport, CT",
    "Brownsville, TX",
    "Calgary, AB",
    "Charleston, WV",
    "Charlotte, NC",
    "Cheyenne, WY",
    "Chicago, IL",
    "Cincinnati, OH",
    "Cleveland, OH",
    "Columbia, SC",
    "Columbus, OH",
    "Dallas, TX",
    "Dayton, OH",
    "Denver, CO",
    "Des Moines, IA",
    "Detroit, MI",
    "Duluth, MN",
    "Edmonton, AB",
    "El Paso, TX",
    "Eugene, OR",
    "Fargo, ND",
    "Fort Lauderdale, FL",
    "Harrisburg, PA",
    "Hartford, CT",
    "Houston, TX",
    "Indianapolis, IN",
    "International Falls, MN",
    "Jackson, MS",
    "Jacksonville, FL",
    "Kansas City, MO",
    "Lansing, MI",
    "Laredo, TX",
    "Las Vegas, NV",
    "Lincoln, NE",
    "Little Rock, AR",
    "Los Angeles, CA",
    "Louisville, KY",
    "Memphis, TN",
    "Miami, FL",
    "Minneapolis, MN",
    "Montgomery, AL",
    "Montpelier, VT",
    "Montreal",
    "Nashville, TN",
    "New Orleans, LA",
    "New York, NY",
    "Norfolk, VA",
    "Okalahoma City, OK",
    "Olympia, WA",
    "Oakland, CA",
    "Omaha, NE",
    "Orlando, FL",
    "Philadelphia, PA",
    "Phoenix, AZ",
    "Pierre, SD",
    "Portland, ME",
    "Portland, OR",
    "Providence, RI",
    "Raleigh, NC",
    "Rapid City, SD",
    "Reno, NV",
    "Richmond, VA",
    "Sacramento, CA",
    "Salinas, CA",
    "San Antonio, TX",
    "San Diego, CA",
    "San Francisco, CA",
    "San Jose, CA",
    "Salt Lake City, UT",
    "Santa Fe, NM",
    "Saskatoon, SK",
    "Savannah, GA",
    "Seattle, WA",
    "Shreveport, LA",
    "Sioux Falls, SD",
    "Spokane, WA",
    "Springfield, MO",
    "St Louis, MO",
    "Tallahasse, FL",
    "Tampa, FL",
    "Toronto, ON",
    "Tucson, AZ",
    "Vancouver, BC",
    "Washington DC",
    "Wichita, KS",
    "Wilmington, DE",
    "Winnipeg, MB"
] 

const locationEurope=[
  "Graz, AUT",
  "Innsbruck, AUT",
  "Linz, AUT",
  "Salzburg, AUT",
  "Vienna, AUT",
  "Brussels, BEL",
  "Oostende, BEL",
  "Saint Hubert, BEL",
  "Plovdiv, BGR",
  "Sofia, BGR",
  "Varna, BGR",
  "Banja Luka, BIH",
  "Minsk, BLR",
  "Geneva, CHE",
  "Larnaca, CYP",
  "Ostrava, CZE",
  "Prague, CZE",
  "Berlin, DEU",
  "Bremen, DEU",
  "Dusseldorf, DEU",
  "Frankfurt, DEU",
  "Hamburg, DEU",
  "Koln, DEU",
  "Mannheim, DEU",
  "Munich, DEU",
  "Stuttgart, DEU",
  "Copenhagen, DNK",
  "Barcelona, ESP",
  "Madrid, ESP",
  "Palma, ESP",
  "Santander, ESP",
  "Sevilla, ESP",
  "Valencia, ESP",
  "Helsinki, FIN",
  "Tampere, FIN",
  "Bordeaux, FRA",
  "Brest, FRA",
  "Clermont-Ferrand, FRA",
  "Dijon, FRA",
  "Lyon, FRA",
  "Marseille, FRA",
  "Montpellier, FRA",
  "Nancy, FRA",
  "Nantes, FRA",
  "Nice, FRA",
  "Paris, FRA",
  "Strasbourg, FRA",
  "Aberdeen, GBR",
  "Aughton, GBR",
  "Belfast, GBR",
  "Birmingham, GBR",
  "Finningley, GBR",
  "Hemsby, GBR",
  "Jersey/Channel Islands, GBR",
  "Leuchars, GBR",
  "London, GBR",
  "Oban, GBR",
  "Andravida, GRC",
  "Athens, GRC",
  "Thessaloniki, GRC",
  "Debrecen, HUN",
  "Szombathely, HUN",
  "Belmullet, IRL",
  "Birr, IRL",
  "Clones, IRL",
  "Dublin, IRL",
  "Kilkenny, IRL",
  "Malin, IRL",
  "Valentia, IRL",
  "Reykjavik, ISL",
  "Jerusalem, ISR",
  "Brindisi, ITA",
  "Genova, ITA",
  "Messina, ITA",
  "Milan, ITA",
  "Naples, ITA",
  "Palermo, ITA",
  "Pisa, ITA",
  "Rome, ITA",
  "Torino, ITA",
  "Venice, ITA",
  "Kaunas, LTU",
  "Amsterdam, NLD",
  "Beek, NLD",
  "Groningen, NLD",
  "Bergen, NOR",
  "Oslo, NOR",
  "Kolobrzeg, POL",
  "Krakow, POL",
  "Poznan, POL",
  "Warsaw, POL",
  "Braganca, PRT",
  "Coimbra, PRT",
  "Evora, PRT",
  "Faro, PRT",
  "Lajes, PRT",
  "Porto, PRT",
  "Bucharest, ROM",
  "Cluj-Napoca, ROM",
  "Constanta, ROM",
  "Craiova, ROM",
  "Galati, ROM",
  "Timisoara, ROM",
  "Arkhangel\\u0027sk, RUS",
  "Moscow, RUS",
  "Saint Petersburg, RUS",
  "Samara, RUS",
  "Belgrade, SRB",
  "Podgorica, SRB",
  "Bratislava, SVK",
  "Kosice, SVK",
  "Ljubljana, SVN",
  "Goteborg, SWE",
  "Karlstad, SWE",
  "Kiruna, SWE",
  "Ostersund, SWE",
  "Stockholm, SWE",
  "Damascus, SYR",
  "Ankara, TUR",
  "Istanbul, TUR",
  "Izmir, TUR",
  "Kiev, UKR",
  "Odessa, UKR"
]

const locationAsia =[
  "Dhaka, BGD",
  "Beijing, CHN",
  "Chongqing, CHN",
  "Guangzhou, CHN",
  "Shantou, CHN",
  "Shenzhen, CHN",
  "Harbin, CHN",
  "Hong kong, CHN",
  "Wuhan, CHN",
  "Nanjing, CHN",
  "Xuzhou, CHN",
  "Shenyang, CHN",
  "Xian, CHN",
  "Jinan, CHN",
  "Shanghai, CHN",
  "Chengdu, CHN",
  "Tianjin, CHN",
  "Hangzhou, CHN",
  "Ahmedabad, IND",
  "Bangalore, IND",
  "Bhopal, IND",
  "Chennai, IND",
  "Hyderabad, IND",
  "Indore, IND",
  "Jaipur, IND",
  "Kolkata, IND",
  "Lucknow, IND",
  "Mumbai, IND",
  "Nagpur, IND",
  "New delhi, IND",
  "Patna, IND",
  "Pune, IND",
  "Surat, IND",
  "Visakhapatnam, IND",
  "Tehran, IRN",
  "Nagoya, JPN",
  "Osaka, JPN",
  "Tokyo, JPN",
  "Inchon, KOR",
  "Kathmandu, NPL",
  "Karachi, PAK",
  "Bangkok, THA",
  "Taipei, TWN"
]
  const ipUnit = {
    feet: 'ft',
    inch: 'inch',
    btuFh: 'Btu/(°F-hr)',
    btuhrlb: 'Btu/hr-lb',
    BTM: 'Btu/°F',
    lb: 'lb',
    temp: '°F',
    percent: '%',
    speed: 'mph',
    rank: 'R',
    hr: 'hr',
    min: 'min',
    year: 'yr',
    mCube: 'ft3/min',
    mperSec: 'mph',
    pressure: 'psia',
    flux: 'Btu/hr-ft2',
    oneperhr: '1/hr',
    cfh:'cfh',
    heat: 'Btu/lb-°F',
    btuVal:'Btu/(h·ft²·°F)',
    co2einlb: (
      <span>
        lbCO<sub>2e</sub>/kWh
      </span>
    )  
  }
  const siUnit = {
    feet: 'm',
    inch: 'mm',
    btuFh: 'W/K',
    btuhrlb: 'W/kg',
    BTM: 'J/K',
    lb: 'kg',
    temp: '°C',
    rank: 'K',
    percent: '%',
    speed: 'mph',
    hr: 'hr',
    min: 'min',
    year: 'yr',
    mCube: 'm3/s',
    mperSec: 'm/s',
    pressure: 'Pa',
    flux: 'W/m2',
    oneperhr: '1/hr',
    cfh:'cfh',
    heat: 'J/kg-K',
    btuVal:'W/(m²·K)',
    co2einlb:  (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  
  }
  const standardUnit = {
    pressure: 'Pa',
    BTM: 'J/K',
    min: 's',
    feet: 'm',
    rank: 'K',
    temp: 'K',
    mperSec: 'm/s',
    flux: 'W/m2',
    btuFh: 'W/K',
    oneperhr: 'Hz',
    inch:'m',
    heat: 'J/kg-K',
    btuhrlb: 'W/kg',
    lb: 'kg',
    btuVal:'W/(m²·K)',
    co2einlb:"kgCO2e/kWh"  
    
  }
  const[isSIIP, setisSIIP]= useState('SI')
  const [currUnit, setCurrUnit] = useState(true)
  const [isDisabled, setIsDisabled] = useState(true)
  const [buttonloading, setButtonLoading] = useState(false);
  const [downloadLoading, setdownloadLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [value, setValue] = useState(6.8001); 
  const [value_width, setValueWidth] = useState(2.591);
  const [value_height, setValueHeight] = useState(2.642);
  const [value_roofsize, setValueRoofsize] = useState(76.2);
  const [value_roofselect, setValueRoofSelect] = useState('Polyurethane');
  const [value_floorselect, setValueFloorSelect] = useState('Polyurethane');
  const [value_frontselect, setValueFrontSelect] = useState('Polyurethane');
  const [value_rearselect, setValueRearSelect] = useState('Polyurethane');
  const [value_sidesselect, setValueSidesSelect] = useState('Polyurethane');
  const [value_floorsize, setValueFloorsize] = useState(76.2);
  const [value_frontsize, setValueFrontsize] = useState(76.2);
  const [value_rearsize, setValueRearsize] = useState(76.2);
  const [value_sidessize, setValueSidessize] = useState(76.2);
  const [value_init_weight, setValueInitWeight] = useState(4000);
  const [value_temp, setValuetemp] = useState(32);
  const [value_temp_set_point, setValueSetPoint] = useState(1.67);
  const [value_temp_set_point_zone, setValueSetPointZone] = useState(1.67);
  const [value_temp_set_point_ztwo, setValueSetPointZtwo] = useState(1.67);
  const [value_restart_band_for_cooling, setValueRestartBandForCooling] = useState(2.8);
  const [value_restart_band_for_heating, setValueRestartBandForHeating] = useState(1.9);
  const [value_restart_band_for_cooling_decimal, setValueRestartBandForCoolingDecimal] = useState(2.8000000000000007);
  const [value_restart_band_for_heating_decimal, setValueRestartBandForHeatingDecimal] = useState(1.94444);
  const [value_off_band, setValueOffBand] = useState(0);
  const [value_low_high_switch_point, setValueLowHighSwitchPoint] = useState(2);

  const [value_restart_band_for_cooling_zone, setValueRestartBandForCoolingZone] = useState(2.8);
  const [value_restart_band_for_heating_zone, setValueRestartBandForHeatingZone] = useState(1.9);
  const [value_restart_band_for_cooling_decimal_zone, setValueRestartBandForCoolingDecimalZone] = useState(2.8000000000000007);
  const [value_restart_band_for_heating_decimal_zone, setValueRestartBandForHeatingDecimalZone] = useState(1.94444);
  const [value_off_band_zone, setValueOffBandZone] = useState(0);
  const [value_low_high_switch_point_zone, setValueLowHighSwitchPointZone] = useState(2);

  const [value_restart_band_for_cooling_ztwo, setValueRestartBandForCoolingZtwo] = useState(2.8);
  const [value_restart_band_for_heating_ztwo, setValueRestartBandForHeatingZtwo] = useState(1.9);
  const [value_restart_band_for_cooling_decimal_ztwo, setValueRestartBandForCoolingDecimalZtwo] = useState(2.8000000000000007);
  const [value_restart_band_for_heating_decimal_ztwo, setValueRestartBandForHeatingDecimalZtwo] = useState(1.94444);
  const [value_off_band_ztwo, setValueOffBandZtwo] = useState(0);
  const [value_low_high_switch_point_ztwo, setValueLowHighSwitchPointZtwo] = useState(2);

  const [value_box_thermal_mass, setValueBoxThermalMass] = useState(929000);
  const [value_box_thermal_mass_decimal, setValueBoxThermalMassDecimal] = useState(929000);
  const [value_age_corrected_ua_factor, setValueAgeCorrectedUAFactor] = useState(40);
  const [value_altitude, setValueAltitude] = useState(669);
  const [value_temp_amb, setValuetempAmb] = useState(27);
  const [value_relative_humidity, setValuerelativehumidity] = useState(50);
  const [value_wind_speed, setValueWindSpeed] = useState(2.2352);
  const [value_precool, setValuePrecool] = useState(0);
  const [value_daily, setValueDaily] = useState(8);
  const [value_number_of_door_openings, setValueDoorOpening] = useState(0);
  const [value_average_duration_of_door_opening, setValueAverageDoorOpening] = useState(0);
  const [value_eco_pull_down, setValueEcoPullDown] = useState(false);
  const [value_fuel_saver, setValueFuelSaver] = useState(true);
  const [value_door_switch, setValueDoorSwitch] = useState(true);
  const [value_curtains, setValueCurtains] = useState(false);
  const [value_E_door, setValueEDoor] = useState(0);
  const [value_E_door_TwoZone, setValueEDoor_twoZone] = useState([0,0]);
  const [value_Unit, setValueUnit] = useState(siUnit);
  const [value_material, setValueMaterial] = useState('UA Factor');
  // const [value_material, setValueMaterial] = useState('Insulation Material');
  const [value_material_sides, setValueMaterialSides] = useState('equal');
  const partition = (value / 2).toFixed(1);
  const partition1_2 = (value / 3).toFixed(1);
  const partition2_3 = (value / (2 / 3)).toFixed(1);
  const [value_overall_ua, SetValueOverallUA] = useState(40);
  const [value_uValue, SetUValue] = useState(0.4);
  const [value_uValue_decimal, SetUValueDecimal] = useState(0.4);
  const [value_age_of_body, SetValueAgeOfBody] = useState(0);
  const [value_solar_absorptivity, SetValueSolarAbsorptivity] = useState(0.6);
  const [value_emissivity, setValueEmissivity] = useState(0.9);
  const [value_infiltration_flowrate, setValueInfiltrationFlowrate] = useState(0);
  const [Value_selectedZone, setSelectedZone] = useState("One Zone");
  const [value_vehicleType, setvehicleType] = useState("Truck");
  const [value_ModelSelect, setModelSelect] = useState("T_1090");
  const [value_partion, setPartition] = useState(partition);
  const [value_ua_partion, setUAPartition] = useState(40);
  const [value_C_partion, setCPartition] = useState(14);
  const [value_C_partion_decimal, setCPartitionDecimal] = useState(14);
  const [value_partion_1_2, setPartition1_2] = useState(partition1_2);
  const [value_partion_2_3, setPartition2_3] = useState(partition2_3);
  const [value_prod_weight, setProdWeight] = useState(5000);
  const [value_prod_weight_zone, setProdWeightZone] = useState(5000);
  const [value_prod_weight_ztwo, setProdWeightZtwo] = useState(5000);
  const [value_product_load_height, setProductLoadHeight] = useState('Full Height');
  const [value_product_load_height_zone, setProductLoadHeightZone] = useState('Full Height');
  const [value_product_load_height_ztwo, setProductLoadHeightZtwo] = useState('Full Height');
  const [value_heat_respiration, setHeatOfRespiration] = useState(0.006);
  const [value_heat_respiration_decimal, setHeatOfRespirationDecimal] = useState(0.006);
  const [value_heat_respiration_zone, setHeatOfRespirationZone] = useState(0.006);
  const [value_heat_respiration_decimal_zone, setHeatOfRespirationDecimalZone] = useState(0.006);
  const [value_heat_respiration_ztwo, setHeatOfRespirationZtwo] = useState(0.006);
  const [value_heat_respiration_decimal_ztwo, setHeatOfRespirationDecimalZtwo] = useState(0.006);
  const [value_specific_heat, setSpecificHeat] = useState(3710);
  const [value_specific_heat_zone, setSpecificHeatZone] = useState(3710);
  const [value_specific_heat_ztwo, setSpecificHeatZtwo] = useState(3710);
  const [value_include_product, setIncludeProduct] = useState('No');
  const [value_include_product_zone, setIncludeProductZone] = useState('No');
  const [value_include_product_ztwo, setIncludeProductZtwo] = useState('No');
  const [value_include_emission, setIncludeEmission] = useState('No');
  const [selectedEmissionValue, setSelectedEmissionValue] = useState(null);
  const [showEmissionModal, setShowEmissionModal] = useState(false);
  const [value_unit_electric_efficiency, setUnitElectricEmission] = useState(0.85);
  const [value_electric_grid_profile_option, setElectricGridProfileOption] = useState('Europe Avg');
  const [value_electric_grid_profile, setElectricGridProfile] = useState(0.21);
  const [value_hs_wait_time, setHSWaitTime] = useState(5);
  const [value_precool_wait_time, setPrecoolWaitTime] = useState(0.5);
  const [value_preheat_wait_time, setPreheatWaitTime] = useState(0.5);
  const [value_weather_profile, setWeatherProfile] = useState('Constant');
  const [value_landmass, setLandmass] = useState('North America');
  const [value_location, setLocation] = useState('Albuquerque, NM');
  const [currentLocation, setCurrentLocation] = useState(locationNorthAmerica);
  const [value_solar_flux, setSolarFlux] = useState(800);
  const [value_ambient_pressure, setAmbiantPressure] = useState(101325);
  const [value_ambient_pressure_decimal, setAmbiantPressureDecimal] = useState(101325);
  const [value_RH_amb, setRH_amb] = useState(0.3);
  const [value_sky_emissivity, setSkyEmissivity] = useState(0.85);
  const [value_route_profile, setRouteProfile] = useState('Daily Distribution');
  const [value_route_time, setRouteTime] = useState(8);
  const [value_precool_time, setprecoolTime] = useState(2);
  const [value_vehicle_speed, setVehicleSpeed] = useState(5);
  const [value_total_stops, setTotalStops] = useState(0);
  const [value_total_stops_multi_city, setTotalStopsMulticity] = useState(0);
  const [value_total_rows, setTotalRows] = useState(2);
  const [value_total_rows_multicity, setTotalRowsMultiCity] = useState(0);
  // const [value_road_grade, setRoadGrade] = useState(0);
  const [value_door_opening_frequency, setValueDoorOpeningFrequency] = useState(1);
  const [value_time_to_load, setTimeToLoad] = useState(30);
  const [value_door_open_time, setValueDoorOpenTime] = useState(15);
  const [value_product_fixed, setvalueProductFixed] = useState(0);
  const [value_door_fixed, setvalueDoorFixed] = useState(0);
  const [resultData, setResultData] = useState(null);
  const [columnsData, setColumnsData] = useState(null);
  const [tempData, setTempData] = useState(null);
  const [tempLayout, setTempLayout] = useState(null);
  const [engineRunData, setEngineRunData] = useState(null);
  const [engineRunLayout, setEngineRunLayout] = useState(null);
  const [standard_door_open_time, setStandardDoorOpenTime] = useState(0);
  const [standard_time_to_load, setStandardTimeToLoad] = useState(0);
  const [standard_C_partion, setStandardCPartition] = useState(14);
  const [standard_partion, setStandardPartition] = useState(partition);
  const [standard_partion_1_2, setStandardPartition1_2] = useState(partition1_2);
  const [standard_partion_2_3, setStandardPartition2_3] = useState(partition2_3);
  const [standard_value, setStandardValue] = useState(8.5);
  const [standard_width, setStandardValueWidth] = useState(2.5);
  const [standard_height, setStandardValueHeight] = useState(2.5);
  const [standard_box_thermal_mass, setStandardValueBoxThermalMass] = useState(929000);
  const [standard_temp_set_point, setStandardValueSetPoint] = useState(1.67);
  const [standard_restart_band_for_cooling, setStandardValueRestartBandForCooling] = useState(2.8);
  const [standard_restart_band_for_heating, setStandardValueRestartBandForHeating] = useState(1.9);
  const [standard_off_band, setStandardValueOffBand] = useState(0);
  const [standard_low_high_switch_point, setStandardValueLowHighSwitchPoint] = useState(2);
  const [standard_hs_wait_time, setStandardHSWaitTime] = useState(5);
  const [standard_precool_wait_time, setStandardPrecoolWaitTime] = useState(5);
  const [standard_preheat_wait_time, setStandardPreheatWaitTime] = useState(5);
  const [standard_temp_amb, setStandardValuetempAmb] = useState(27);
  const [standard_solar_flux, setStandardSolarFlux] = useState(0);
  const [standard_ambient_pressure, setStandardAmbiantPressure] = useState(100000);
  const [standar_wind_speed, setStandardValueWindSpeed] = useState(0);
  const [standard_vehicle_speed, setStandardVehicleSpeed] = useState(5);
  const [standard_overall_ua, SetStandardValueOverallUA] = useState(40);
  const [standard_ua_partion, setStandardUAPartition] = useState(40);
  const [xW_box, setxW_box]= useState();

  // const [start_route_time, setStartRouteTime] = useState(dayjs('02:00:', 'HH:mm'));
  const [start_route_time, setStartRouteTime] = useState(0);
  const [start_route_speed, setStartRouteSpeed] = useState('Urban');
  const [start_route_road, setStartRouteRoad] = useState(0);
  const [start_route_product, setStartRouteProduct] = useState(1);
  const [start_route_door, setStartRouteDoor] = useState('Closed');
  // const [end_route_time, setEndRouteTime] = useState(dayjs(`0${value_route_time}:00:`, 'HH:mm'));
  const [end_route_time, setEndRouteTime] = useState(value_route_time);
  const [end_route_speed, setEndRouteSpeed] = useState('Stop');
  const [end_route_road, setEndRouteRoad] = useState(0);
  const [end_route_product, setEndRouteProduct] = useState(0);
  const [end_route_door, setEndRouteDoor] = useState('Open');
  const [routeStartRows, setRouteStartRows] = useState([]);
  const [routeStartRows_multicity, setRouteStartRowsMulticity] = useState([]);

  const [start_route_multicity_time, setStartRouteMulticityTime] = useState(0);
  const [start_route_multicity_speed, setStartRouteMulticitySpeed] = useState('Urban');
  const [start_route_multicity_location, setStartRouteMulticityLocation] = useState('Albuquerque, NM');

  const [end_route_multicity_time, setEndRouteMulticityTime] = useState(value_route_time);
  const [end_route_multicity_speed, setEndRouteMulticitySpeed] = useState('Stop');
  const [end_route_multicity_location, setEndRouteMulticityLocation] = useState('Albuquerque, NM');
  
  const [weatherStartRows, setWeatherStartRows] = useState([]);

  const [value_weather_transient_time_start, setWeatherTransientTimeStart] = useState(-2);
  const [value_weather_transient_temp_start,setWeatherTransientTempStart] = useState(20);
  const [value_weather_transient_flux_start,setWeatherTransientFluxStart] = useState(0);
  const [value_weather_transient_pressure_start,setWeatherTransientPressureStart] = useState(value_ambient_pressure);
  const [value_weather_transient_relative_humidity_start,setWeatherTransientMassFractionStart] = useState(0);
  const [value_weather_transient_wind_speed_start,setWeatherTransientWindSpeedStart] = useState(0);
  const [value_weather_transient_sky_emissivity_start,setWeatherTransientSkyEmissivityStart] = useState(0);

  const [value_weather_transient_time_end, setWeatherTransientTimeEnd] = useState(8);
  const [value_weather_transient_temp_end,setWeatherTransientTempEnd] = useState(22);
  const [value_weather_transient_flux_end,setWeatherTransientFluxEnd] = useState(0);
  const [value_weather_transient_pressure_end,setWeatherTransientPressureEnd] = useState(value_ambient_pressure);
  const [value_weather_transient_relative_humidity_end,setWeatherTransientMassFractionEnd] = useState(0);
  const [value_weather_transient_wind_speed_end,setWeatherTransientWindSpeedEnd] = useState(0);
  const [value_weather_transient_sky_emissivity_end,setWeatherTransientSkyEmissivityEnd] = useState(0);

  const [value_weather_transient_pressure_start_decimal, setWeatherTransientPressureStartDecimal] = useState(value_ambient_pressure_decimal);
  const [value_weather_transient_pressure_end_decimal, setWeatherTransientPressureEndDecimal] = useState(value_ambient_pressure_decimal);
  const [value_product, setValueProduct] = useState('Chill');
  const [value_product_zone, setValueProductZone] = useState('Chill');
  const [value_product_ztwo, setValueProductZtwo] = useState('Chill');
  const [value_door_type, setValueDoorType] = useState('Swing Type');
  const [value_ua_door, setValueUADoor] = useState(0);
  
  //
const [pdfDownloadComponent, setPDFDownloadComponent] = useState(false);
// const [url, setURL] = useState();
// const [url1, setURL1] = useState();
const [inputtable, setinputtable] = useState();
const targetRef = useRef(null);
const [visible, setVisible] = useState(false);
const [visible1, setVisible1] = useState(false);
const [fileName, setFileName] = useState("ECoTRIP_Report.pdf");
const [Customer_name, setCustomer]= useState();
const [isLoading, setIsLoading] = useState(false);

  const [Comments, setcomments]= useState();
  const [payloadData, setPayloadData]= useState(null);

  // const [value_product, setValueProduct] = useState('Grapes');
  const handleClick = async () => {
    setIsLoading(true);
    //console.log(fileName,'filename')
    try {
      //console.log(fileName,'filename1')
      await generatePDF(targetRef, {filename: fileName});
    } catch (error) {
      console.error('Error generating PDF:', error);
    } finally {
      setIsLoading(false);
    }
  };
  function getTableValue(selectedProduct, products) {
    for (const product of products) {
        if (product.Product === selectedProduct) { // Match product by name
            return value_include_product === 'No'
                ? `${null}`
                : `${selectedProduct}, ${product.Setpoint}`;
        }
    }

    // Handle case where selected product is not found (optional)
    return `${selectedProduct}, Not Found`; // Example for informative message
}

const  joulesToKgPerKWh=(joules)=> {
  const joulesPerKWh = 3600000; // 1 kWh = 3,600,000 joules
  const electricEmission = ((joules * value_electric_grid_profile)/ (joulesPerKWh * value_unit_electric_efficiency));
  return electricEmission;
}

  const dataSetup=(testobj,param, item=false, curr)=>{
    let val =null;
    switch(item){
      case 'percent': val = (testobj[param][testobj[param].length-1]* 100).toFixed(2);
                      break;
      case 'time' : val =(testobj[param][testobj[param].length-1]/60).toFixed(2);
                    break;
      case 'consumption':

                    val = curr ?(testobj[param][testobj[param].length-1]* 1000).toFixed(4) : ((testobj[param][testobj[param].length-1]* 264.172)).toFixed(4);
                    break;
                    
      case 'rate':
                      
                      // val = curr ?(testobj[param][testobj[param].length-1]* 1000).toFixed(4) : (testobj[param][testobj[param].length-1]* 15850.32).toFixed(4);
                      val = curr ?(testobj[param][testobj[param].length-1]* 3600).toFixed(4) : (testobj[param][testobj[param].length-1]* 60).toFixed(4);
                    break;
      case 'electricEmission':
                      val = curr ?((joulesToKgPerKWh(testobj[param][testobj[param].length-1]))).toFixed(4) : ((((joulesToKgPerKWh(testobj[param][testobj[param].length-1]))))).toFixed(4);
                      break;
      case 'dieselEmission': 
                      val = curr ?((testobj[param][testobj[param].length-1]* 1000)* 2.68).toFixed(4) : (((testobj[param][testobj[param].length-1]* 1000)* 2.68)*2.20462).toFixed(4);
                      break;

    }
    return val;
  }


  useEffect(() => {
    inputTableDataSource();
  
  }, [inputtable, currUnit, xW_box]);

  const resultTab=(res, currVal=true)=>{
    // console.log('precool_Data: ', currVal)
    setxW_box(res['box.xW_box'])
      let fuelConsump = currVal ? '(L)':'(gal)' ;
      let fuelrate = currVal ? '(L/s)':'(gpm)' ;
      // let emissionUnit = currVal ?"(kgco2e/kwh)":"(lbCO2e/kWh)";
    const datas = [
      {
        key: '1',
        item: `Fuel Consumption ${fuelConsump}`,
        precool: dataSetup(res,'summary.E_precool','consumption',currVal),
        on_route: dataSetup(res,'summary.E_route','consumption',currVal),
        total: dataSetup(res,'summary.E','consumption',currVal),
      },
      {
        key: '2',
        item: `Average Fuel Rate ${fuelrate}`,
        precool: dataSetup(res,'summary.E_rate_avg_precool',"rate",currVal),
        on_route: dataSetup(res,'summary.E_rate_avg_route',"rate",currVal),
        total: dataSetup(res,'summary.E_rate_avg',"rate",currVal),
      },
      {
        key: '3',
        item: '% Engine On',
        precool: dataSetup(res,'summary.coolingOnRunTimeRatioPreCool', 'percent',currVal),
        on_route: dataSetup(res,'summary.coolingOnRunTimeRatioRoute', 'percent',currVal),
        total: dataSetup(res,'summary.coolingOnRunTimeRatio', 'percent',currVal),
      },
      {
        key: '4',
        item: '% Engine High Speed',
        precool: dataSetup(res,'summary.highSpeedRunTimeRatio_precool', 'percent',currVal),
        on_route: dataSetup(res,'summary.highSpeedRunTimeRatio_route', 'percent',currVal),
        total: dataSetup(res,'summary.highSpeedRunTimeRatio','percent',currVal),
      },
      {
        key: '5',
        item: '% Engine Low Speed',
        precool: dataSetup(res,'summary.lowSpeedRunTimeRatio_precool', 'percent',currVal),
        on_route: dataSetup(res,'summary.lowSpeedRunTimeRatio_route', 'percent',currVal),
        total: dataSetup(res,'summary.lowSpeedRunTimeRatio','percent',currVal),
      },
      {
        key: '6',
        item: '% Of Time In Cooling',
        precool: dataSetup(res,'summary.coolingOnRunTimeRatioPreCool', 'percent',currVal),
        on_route: dataSetup(res,'summary.coolingOnRunTimeRatioRoute', 'percent',currVal),
        total: dataSetup(res,'summary.coolingOnRunTimeRatio','percent',currVal),
      },
      {
        key: '7',
        item: '% Of Time In Heating',
        precool: dataSetup(res,'summary.heatingOnRunTimeRatioPreCool', 'percent',currVal),
        on_route: dataSetup(res,'summary.heatingOnRunTimeRatio_route', 'percent',currVal),
        total: dataSetup(res,'summary.heatingOnRunTimeRatio','percent',currVal),
      },
      {
        key: '8',
        item: 'Engine Run Time (min)',
        precool: dataSetup(res,'summary.coolingOnRunTime_precool','time',currVal),
        on_route: dataSetup(res,'summary.coolingOnRunTime_route','time',currVal),
        total: dataSetup(res,'summary.coolingOnRunTime','time',currVal),
      },
      {
        key: '9',
        item: 'High Speed Time (min)',
        precool: dataSetup(res,'summary.highSpeedRunTime_precool','time',currVal),
        on_route: dataSetup(res,'summary.highSpeedRunTime_route','time',currVal),
        total: dataSetup(res,'summary.highSpeedRunTime','time',currVal),
      },
      {
        key: '10',
        item: 'Low Speed Time (min)',
        precool: dataSetup(res,'summary.lowSpeedRunTime_precool','time',currVal),
        on_route: dataSetup(res,'summary.lowSpeedRunTime_route','time',currVal),
        total: dataSetup(res,'summary.lowSpeedRunTime','time',currVal),
      },
      {
        key: '11',
        item: 'Cooling Time (min)',
        precool: dataSetup(res,'summary.coolingOnRunTime_precool','time',currVal),
        on_route: dataSetup(res,'summary.coolingOnRunTime_route','time',currVal),
        total: dataSetup(res,'summary.coolingOnRunTime','time',currVal),
      },
      {
        key: '12',
        item: 'Heating Time (min)',
        precool: dataSetup(res,'summary.heatingOnRunTime_precool','time',currVal),
        on_route: dataSetup(res,'summary.heatingOnRunTime_route','time',currVal),
        total: dataSetup(res,'summary.heatingOnRunTime','time',currVal),
      },    
    ];
    if(value_include_emission === 'Yes'){
      const dieselPrecool = dataSetup(res,'summary.E_precool','dieselEmission',currVal);
      const dieselOnroue = dataSetup(res,'summary.E_route','dieselEmission',currVal);
      const dieselTotal = dataSetup(res,'summary.E','dieselEmission',currVal);

      const electricPrecool = dataSetup(res,'cumulative_engine_p_precool','electricEmission',currVal);
      const electricOnroute = dataSetup(res,'cumulative_engine_p_route','electricEmission',currVal);
      const electricTotal = dataSetup(res,'cumulative_engine_p_all','electricEmission',currVal);

    const includeEmissionData = [{
      key: '13',
      item: 
      (
        <span>
          Diesel engine emission{' '}
          {currVal ? (
            <span>
              kgCO<sub>2e</sub>
            </span>
          ) : (
            <span>
              lbCO<sub>2e</sub>
            </span>
          )}
        </span>
      ),
      precool: dieselPrecool,
      on_route: dieselOnroue,
      total: dieselTotal,
    },
    {
      key: '14',
      item:     (
        <span>
          Equivalent electric system emission{' '}
          {currVal ? (
            <span>
              kgCO<sub>2e</sub>
            </span>
          ) : (
            <span>
              lbCO<sub>2e</sub>
            </span>
          )}
        </span>
      ),
      precool: electricPrecool,
      on_route: electricOnroute,
      total: electricTotal,
    },
    {
      key: '15',
      item:    (
        <span>
          % Emission reductions
        </span>
      ),
      precool: (((dieselPrecool - electricPrecool)/dieselPrecool) *100).toFixed(2),
      on_route: (((dieselOnroue - electricOnroute)/dieselOnroue) *100).toFixed(2),
      total: (((dieselTotal - electricTotal)/dieselTotal) *100).toFixed(2)
    },];
   
      // datas= [...datas, ...includeEmission]
      datas.push(...includeEmissionData)
    }

    const columns = [
      {
        title: 'Item',
        dataIndex: 'item',
        key: 'item',
      },
      {
        title: 'Precool',
        dataIndex: 'precool',
        key: 'precool',
      },
      {
        title: 'On Route',
        dataIndex: 'on_route',
        key: 'on_route',
      },
      {
        title: 'Total',
        dataIndex: 'total',
        key: 'total',
      }
    ]
    const mins = (obj, engine= false)=>{
      let val = Math.min(...obj)
      return  val==0 ? 0 : (engine && val <=0)? 0 :(val-2.5) ;
    }
    const maxs = (obj)=>{
      let val = Math.max(...obj) + 2.5;
      return val;
    }
    // setColumnsData(columns);
    // setResultData(datas);
    // tabSwitch("2");
    dataFlow(columns,datas)
    let op_hr= res['time'].map(secToHr=>secToHr/3600);
    // console.log('testhr: ', op_hr)
    const airTemp = res['summary.T_sensor[1]']?.map(x=>{
      let ktoC = (x-273.15);
      let ktoF = (x -273.15) * 9/5 + 32; 
      return currVal ? ktoC : ktoF;
    }); 

    const ambientTemp = res['weather.T_ambient']?.map(x=>{
      let ktoC = (x-273.15);
      let ktoF = (x -273.15) * 9/5 + 32; 
      return currVal ? ktoC : ktoF;
    }); 
    const timeG = [0, 1, 2, 3, 4, 5, 6, 7, 8];
    const fuelConsumptionG = res['summary.E']?.map(x=>{
      let m3toL =x * 1000;
      let m3toGal =x * 264.172;
      return currVal ? m3toL : m3toGal
    }); 
    const speedG =Value_selectedZone === 'Two Zone' ?  res['compressorRPM'] : res['plant.engine.N']; 
    let AirnAmpTemp = currVal ? '(°C)':'(°F)' ;
    
 
    const minTemp = Math.min(mins(airTemp), mins(ambientTemp));
    const maxTemp = Math.max(maxs(airTemp), maxs(ambientTemp));
    const tempLayout1 = {
      title: 'Temperature Control',
      xaxis: {
        title: 'Operation Hour(h)',
        range: [mins(op_hr), maxs(op_hr)],
      },
      yaxis: {
        title: `Return Air Temperature ${AirnAmpTemp}`,
        side: 'left',
        range: [minTemp, maxTemp],
        color: Value_selectedZone === 'Two Zone'? "black": 'blue',
      },
      yaxis2: {
        title: `Ambient Temperature ${AirnAmpTemp}`,
        overlaying: 'y',
        side: 'right',
        range: [minTemp, maxTemp],
        color: 'red',
      },
      legend: {
        x: 0.5,
        xanchor: 'center',
        y: -0.5,
        orientation: "h",
        traceorder: 'normal',
      },
    };
    
    const tempData1 = [
      {
        x: op_hr,
        y: airTemp,
        type: 'scatter',
        mode: 'lines',
        name: Value_selectedZone === 'Two Zone' ? `Return Air Temperature Zone 1 ${AirnAmpTemp}` : `Return Air Temperature ${AirnAmpTemp}`,
        line: { color: 'blue' },
        yaxis: 'y1',
      },
      {
        x: op_hr,
        y: ambientTemp,
        type: 'scatter',
        mode: 'lines',
        name: `Ambient Temperature ${AirnAmpTemp}`,
        line: { color: 'red' },
        yaxis: 'y2',
      },

    ];
    
    
    

    if(Value_selectedZone === 'Two Zone'){
          const airTemp2 = res['summary.T_sensor[2]']?.map(x=>{
      let ktoC = (x-273.15);
      let ktoF = (x -273.15) * 9/5 + 32; 
      return currVal ? ktoC : ktoF;
    }); 
    const minTemp2 = Math.min(mins(airTemp2), mins(ambientTemp));
      tempData1[2]=       {
        x: op_hr,
        y: airTemp2,
        type: 'scatter',
        mode: 'lines',
        name: `Return Air Temperature Zone 2 ${AirnAmpTemp}`,
        line: { color: 'green' },
        yaxis: 'y3',
      }



     let layoutTwoZone= {
        overlaying: 'y',
        side: 'left',
        range: [Math.min(mins(airTemp), mins(airTemp2)), maxTemp],
        color: 'green',
        visible: false,
      };
     let annotations = [
        {
          text: `Return Air Temperature Zone 2 ${AirnAmpTemp}`,
          xref: 'paper',
          yref: 'paper',
          x: 0.5,
          y: 1.15,
          showarrow: false,
          font: {
            color: 'green',
            size: 14,
          },
          align: 'center',
        },
      ];
      tempLayout1.yaxis3 = layoutTwoZone;
      tempLayout1.yaxis.range = [Math.min(mins(airTemp), mins(airTemp2)), maxTemp];
      // tempLayout1.annotations = annotations;
    }

    const dataG = [
      {
        x: op_hr,
        y: fuelConsumptionG,
        type: 'scatter',
        mode: 'lines',
        name: `Fuel Consumption ${fuelConsump}`,
        line: { color: 'blue' },
        yaxis: 'y1',
      },
      {
        x: op_hr,
        // y: Array(fuelConsumptionG.length).fill(speedG),
        y: speedG,
        type: 'scatter',
        mode: 'lines',
        name: 'Engine speed(RPM)',
        line: { color: 'red' },
        yaxis: 'y2',
      },
    ];
   
    const layoutG = {
      title: 'Engine Run',
      xaxis: {
        title: 'Operation Hour(h)',
        range: [mins(op_hr),maxs(op_hr)],
      },
      yaxis: {
        title: `Fuel Consumption ${fuelConsump}`,
        side: 'left',
        range: [mins(fuelConsumptionG), maxs(fuelConsumptionG)],
        color: 'blue',
      },
      yaxis2: {
        title: 'Engine speed(RPM)',
        overlaying: 'y',
        side: 'right',
        range: [mins(speedG),maxs(speedG)],
        color: 'red',
        // list:{
        //   autorange:'reversed'
        // }
      },
      legend: {
        x: 0.5,
        xanchor: 'center',
        y: -0.5,
        orientation: "h",
        traceorder:'normal',
        // itemwidth: 150
      },
    };
    setEngineRunData(dataG);
    setEngineRunLayout(layoutG);
    setTempData(tempData1);
    setTempLayout(tempLayout1);
  }

  const dataFlow=(columns, datas)=>{
    setColumnsData(columns);
    setResultData(datas);
  }
  function calculateRH(temperature, p_ambient) {
      const temperatureInCelsius = temperature;
      let psat;
      let Pv;
      if (temperatureInCelsius < 0) {
        psat = 0.61078 * Math.exp((17.27 * temperatureInCelsius) / (temperatureInCelsius + 237.3));
        
      } else {
        psat = 0.61078 * Math.exp((21.875 * temperatureInCelsius) / (temperatureInCelsius + 265.5));
      }

      if (xW_box){
        Pv = xW_box[xW_box.length - 1] * (p_ambient/1000);
      }
      const RH = (Pv / psat)*100 ;
      return { RH }; // Return rh
    }
    const [datasource1, setdatasource1] = useState([]);
    const [columns1, setColumns1] = useState([]);
    // console.log(inputtable, "inptable");
    const inputTableDataSource = () => {
      if (inputtable !== undefined) {
        let rh_zone = 0;
        if(FCMT_RESULT){
          rh_zone= FCMT_RESULT["summary.RH_zone[1]"][FCMT_RESULT["summary.RH_zone[1]"].length-1];
        }
        setdatasource1([
          {
            key: "1",
            title: "Vehicle type",
            value: value_vehicleType,
          },
          {
            key: "2",
            title: "Compartment",
            value: inputtable.compartment,
          },
          {
            key: "3",
            title: "Unit",
            value: value_ModelSelect,
          },
          {
            key: "4",
            title: " Box Dimension",
            value: `${value} ${value_Unit.feet}(L) x ${value_width} ${value_Unit.feet}(W) x ${value_height} ${value_Unit.feet}(H)`,
          },
          {
            key: "5",
            title: `Age Corrected UA Factor (${value_Unit.btuFh})`, // (Btu/(°F-hr))
            value: `${value_overall_ua}`,
          },
          {
            key: "7",
            title: `Product & recommended set Point(${value_Unit.temp})`, //(°F)
            value: Value_selectedZone === 'Two Zone'
              ? (value_include_product_zone === 'Yes' || value_include_product_ztwo === 'Yes')
                ? `Zone1: ${value_include_product_zone === 'Yes' ? getTableValue(value_product_zone, products) : 'Empty'}, Zone2: ${value_include_product_ztwo === 'Yes' ? getTableValue(value_product_ztwo, products) : 'Empty'}`
                : 'Zone1: Empty, Zone2: Empty'
              : value_include_product === 'No'
                ? 'Empty'
                : getTableValue(value_product, products),
          },
          {
            key: "7",
            title: `Actual Set point (${value_Unit.temp})`,
            value: Value_selectedZone === 'Two Zone'
            ? `Zone1: ${value_temp_set_point_zone}, Zone2: ${value_temp_set_point_ztwo}`
            :  `${ value_temp_set_point} `,
          },
          {
            key: "8",
            title: "Control Mode",
            value: inputtable.algorithm,
          },
  
          {
            key: "10",
            title: "Weather Condition",
            value: "Fixed Ambient",
          },
          {
            key: "11",
            title: `Dry-Bulb Temperature (${value_Unit.temp})`,
            value: `${value_temp_amb} `,
          },
          {
            key: "12",
            title: `Wind Speed (${value_Unit.mperSec})`,
            value: `${value_overall_ua} `,
          },
          {
            key: "13",
            title: `Solar Radiation (W/m2)`,
            value: `${fluxConversion(value_solar_flux, 1, currUnit,true)}`,
          },
          {
            key: "14",
            title: "Relative Humidity(%)",
            // value: `${calculateRH(value_temp_amb, value_ambient_pressure).RH.toFixed(2)}`,
            value: `${rh_zone}`,
          },
          {
            key: "15",
            title:`Ambient Pressure (${value_Unit.pressure})`  ,
            value: `${value_ambient_pressure}`,
          },
          {
            key: "16",
            title: "Route Profile",
            value: inputtable.route_profile,
          },
          {
            key: "17",
            title: `Precool Time (${value_Unit.hr})`,
            value: `${value_precool_time} `,
          },
          {
            key: "18",
            title: `Route Time (${value_Unit.hr})`,
            value: `${value_route_time} `,
          },
          {
            key: "19",
            title: "Number of Door Openings",
            value: value_door_opening_frequency,
          },
          {
            key: "20",
            title: "Average Duration (min)",
            value: "Not Applicable",
          },
          {
            key: "21",
            title: "Operational City",
            value: "Not Applicable",
          },
        ]);
        setColumns1([
          {
            title: "Title",
            dataIndex: "title",
            key: "title",
          },
          {
            title: "Value",
            dataIndex: "value",
            key: "value",
          },
        ]);
      }
    };

  let FCMT_RESULT = useSelector((state) => state?.rangeForcasting?.FCMT);
  // console.log(FCMT_RESULT);

  useEffect(() => {
    if(FCMT_RESULT !== undefined){
      resultTab(FCMT_RESULT, currUnit);
      // setTrailTemp(true);
    }// This triggers a re-render and updates the count
  }, [FCMT_RESULT,value_temp_amb]);

  const updateUAandThermalMass = (currentMaterial, length=value,width=value_width,height=value_height, u_value=value_uValue_decimal, ageOfBody= value_age_of_body) => {
    const material = {
      Roof: [value_roofselect, currUnit ? value_roofsize : inchConversion(value_roofsize,1,currUnit)],
      Floor: [value_floorselect, currUnit ? value_floorsize : inchConversion(value_floorsize,1,currUnit)],
      Front: [value_frontselect, currUnit ? value_frontsize : inchConversion(value_frontsize,1,currUnit)],
      Rear: [value_rearselect, currUnit ? value_rearsize : inchConversion(value_rearsize,1,currUnit)],
      Sides: [value_sidesselect, currUnit ? value_sidessize : inchConversion(value_sidessize,1,currUnit)],
    };
    
    const { wallThermalMass, wallUANew } = currUnit ? calculateUAParameters(length, width, height, material) : calculateUAParameters(feetConversion(length,4,currUnit), feetConversion(width,4,currUnit), feetConversion(height,4,currUnit), material);
    if(currentMaterial && currentMaterial === 'Insulation Material'){
      let UANew =  currUnit ? wallUANew: btuFhConversion(wallUANew , 1, !currUnit);
      let ageCorrectedUA = UANew * Math.min(1.2, 1 + 0.05 * ageOfBody);
    SetValueOverallUA(ageCorrectedUA);
    setValueAgeCorrectedUAFactor(ageCorrectedUA);
    } else if(currentMaterial == 'U Value'){
      const hl = (height * length);
      const hw = (height * width);
      const lw = (length * width);
      const result_A = 2*(hl+hw+lw);
      const newUA= u_value? u_value * result_A : value_uValue_decimal * result_A;
      let UANew = newUA;
      let ageCorrectedUA = UANew * (1 + 0.05 * ageOfBody);
    SetValueOverallUA(ageCorrectedUA);
    setValueAgeCorrectedUAFactor(ageCorrectedUA);
    }

    setValueBoxThermalMass(currUnit ? wallThermalMass: BTMConversion(wallThermalMass,1,!currUnit));
  };
  useEffect(() => {
      updateUAandThermalMass(value_material,value,value_width, value_height, value_uValue_decimal);
  }, [value_roofselect, value_floorselect, value_frontselect, value_rearselect, value_sidesselect, value_roofsize, value_floorsize, value_frontsize, value_rearsize, value_sidessize]);
  const handleChangeDoorFixed = (newValue) => {
    setvalueDoorFixed(newValue)
  };
  const handleChangeProductFixed = (newValue) => {
    setvalueProductFixed(newValue)
  };
  const handleChangeRouteTime = (newValue) => {
    setRouteTime(newValue)
    form.setFields([{name:"route_transient_time_end",value:newValue}]);
    setEndRouteTime(newValue);
    setWeatherTransientTimeEnd(newValue);
    form.setFields([{name:"weather_transient_time_end",value:newValue}])
  };
  const handleChangePrecoolTime = (newValue) => {
    setprecoolTime(newValue)
    setWeatherTransientTimeStart(-newValue);
    form.setFields([{name:"weather_transient_time_start",value:-newValue}])
  };
  const handleChangeVehicleSpeed = (newValue) => {
    setVehicleSpeed(newValue)
    setStandardVehicleSpeed(newValue)
  };
  const handleChangeTotalStops = (newValue) => {
    setTotalStops(newValue)
    createRouteStartRows(newValue);
  };
  const handleChangeRoadGrade = (newValue) => {
    // setRoadGrade(newValue)
  };
  const handleChangeDoorOpeningFrequency = (newValue) => {
    setValueDoorOpeningFrequency(newValue)
  };
  const handleChangeDoorOpenTime = (newValue) => {
    setValueDoorOpenTime(newValue)
    setStandardDoorOpenTime(newValue)
  };
  const handleChangeTimeToLoad = (newValue) => {
    setTimeToLoad(newValue)
    setStandardTimeToLoad(newValue)
  };
  const handleChangeWeatherProfile = (newValue) => {
    setWeatherProfile(newValue)
  };
  const handleChangeLandmass = (newValue) => {
    setLandmass(newValue);
    let currentland = currentLocation;
    if(newValue == 'North America'){
      currentland =locationNorthAmerica;
    }else if(newValue == 'Europe'){
      currentland =locationEurope;
    }
    else if(newValue == 'ASIA'){
      currentland =locationAsia;
    }
    setCurrentLocation(currentland);
    setStartRouteMulticityLocation(currentland[0]);
    setEndRouteMulticityLocation(currentland[0]);
    form.setFields([{name:"route_multicity_location_start",value:currentland[0]}]);
    form.setFields([{name:"route_multicity_location_end",value:currentland[0]}]);
    setLocation(currentland[0]);
    createRouteStartRowsMulticity(value_total_stops_multi_city, currentland);
  };
  const handleChangeLocation = (newValue) => {
    setLocation(newValue);
    setStartRouteMulticityLocation(newValue);
    form.setFields([{name:"route_multicity_location_start",value:newValue}]);
  };
  const handleChangeRouteProfile = (newValue) => {
    setRouteProfile(newValue)
    if(newValue === 'Multi City Long Haul'){
      setWeatherProfile('TMY3');
      form.setFields([{name:"weather_profile",value:"TMY3"}]);
    }
  };

  const handleChangeSkyEmissivity = (newValue) => {
    setSkyEmissivity(newValue)
  };
  const handleChangeVaporMassFraction = (newValue) => {
    setRH_amb(newValue)
  };
  const handleChangeSolarFlux = (newValue) => {
    setSolarFlux(newValue)
    setStandardSolarFlux(newValue)
  };
  const handleChangeAmbiantPressure = (newValue) => {
    setAmbiantPressure(newValue)
    setAmbiantPressureDecimal(newValue)
    setStandardAmbiantPressure(newValue)
  };
  const handleChangeIncludeProduct = (newValue) => {
    setIncludeProduct(newValue.target.value)
    let matchProduct =products.find((x)=> {return x.Product==value_product});
    if(matchProduct){
      let tempSetPoint = currUnit ? matchProduct.Setpoint : tempConversion(matchProduct.Setpoint, 1, true, false);
      form.setFields([{name:"temp_set_point",value:tempSetPoint}]);
      setValueSetPoint(tempSetPoint);
    }
  };
  const handleChangeIncludeProductZone = (newValue) => {
    setIncludeProductZone(newValue.target.value)
    let matchProduct =products.find((x)=> {return x.Product==value_product_zone});
    if(matchProduct){
      let tempSetPoint = currUnit ? matchProduct.Setpoint : tempConversion(matchProduct.Setpoint, 1, true, false);
      form.setFields([{name:"temp_set_point_zone",value:tempSetPoint}]);
      setValueSetPointZone(tempSetPoint);
    }
  };
  const handleChangeIncludeProductZtwo = (newValue) => {
    setIncludeProductZtwo(newValue.target.value)
    let matchProduct =products.find((x)=> {return x.Product==value_product_ztwo});
    if(matchProduct){
      let tempSetPoint = currUnit ? matchProduct.Setpoint : tempConversion(matchProduct.Setpoint, 1, true, false);
      form.setFields([{name:"temp_set_point_ztwo",value:tempSetPoint}]);
      setValueSetPointZtwo(tempSetPoint);
    }
  };
  const handleChangeIncludeEmission = (newValue) => {
    setIncludeEmission(newValue.target.value)
    // let matchProduct =products.find((x)=> {return x.Product==value_product});
    // if(matchProduct){
    //   let tempSetPoint = currUnit ? matchProduct.Setpoint : tempConversion(matchProduct.Setpoint, 1, true, false);
    //   form.setFields([{name:"temp_set_point",value:tempSetPoint}]);
    //   setValueSetPoint(tempSetPoint);
    // }
  };
  const handleChangeUnitElectricEfficiency = (newValue) => {
    setUnitElectricEmission(newValue)
  }
  const handleEmissionlookup = (newValue) => {
    // setUnitElectricEmission(newValue)
    // console.log('get checkData:', newValue);
    setSelectedEmissionValue(newValue)
    setElectricGridProfile(newValue);
    form.setFields([{name:"electric_grid_profile",value:newValue}]);
  }
  const handleElectricGridProfileOption = (newValue) => {
    setElectricGridProfileOption(newValue);
    let electricvalue= value_electric_grid_profile;
    if(newValue=='Europe Avg'){
      electricvalue = 0.21;
    }else if(newValue == 'USA Avg' ){
      electricvalue= 0.373374;
    }
    setElectricGridProfile(electricvalue);
    form.setFields([{name:"electric_grid_profile",value:electricvalue}]);
  }
  const handleElectricGridProfile = (newValue) => {
    setElectricGridProfile(newValue)
  }
  const handleChangeHSWaitTime = (newValue) => {
    setHSWaitTime(newValue)
    setStandardHSWaitTime(newValue)
  };
  const handleChangePrecoolWaitTime = (newValue) => {
    setPrecoolWaitTime(newValue)
    setStandardPrecoolWaitTime(newValue)
  };
  const handleChangePreheatWaitTime = (newValue) => {
    setPreheatWaitTime(newValue)
    setStandardPreheatWaitTime(newValue)
  };

  const handleChangeHeatRespiration = (newValue) => {
    setHeatOfRespiration(newValue)
  };
  // const handleChangeHeatingController = (newValue) => {
  //   setHeatingController(newValue)
  // };
  // const handleChangeHeatingPlant = (newValue) => {
  //   setHeatingPlant(newValue)
  // };
  const handleChangeproduct = (newValue) => {
    setValueProduct(newValue)
    let matchProduct =products.find((x)=> {return x.Product==newValue});
  
    if(newValue == 'Empty'){
      form.setFields([{name:"prod_weight",value:0}]);
      setProdWeight(0);
    }
    if(matchProduct){
      let tempSetPoint = currUnit ? matchProduct.Setpoint : tempConversion(matchProduct.Setpoint, 1, true, false);
      form.setFields([{name:"temp_set_point",value:tempSetPoint}]);
      setValueSetPoint(tempSetPoint);
      setHeatOfRespiration(matchProduct.Heat_of_Respiration);
      setHeatOfRespirationDecimal(matchProduct.Heat_of_Respiration);
      setSpecificHeat(matchProduct.Specific_Heat);
    }
  };

  const handleChangeProdWeight = (newValue) => {
    setProdWeight(newValue)
  };
  const handleProductloadheight = (newValue) => {
    setProductLoadHeight(newValue);
    // updateProdWeight(newValue,currUnit, value);
  };
  const handleChangeproductZone = (newValue) => {
    setValueProductZone(newValue)
    let matchProduct =products.find((x)=> {return x.Product==newValue});
  
    if(newValue == 'Empty'){
      form.setFields([{name:"prod_weight_zone",value:0}]);
      setProdWeightZone(0);
    }
    if(matchProduct){
      let tempSetPoint = currUnit ? matchProduct.Setpoint : tempConversion(matchProduct.Setpoint, 1, true, false);
      form.setFields([{name:"temp_set_point_zone",value:tempSetPoint}]);
      setValueSetPointZone(tempSetPoint);
      setHeatOfRespirationZone(matchProduct.Heat_of_Respiration);
      setHeatOfRespirationDecimalZone(matchProduct.Heat_of_Respiration);
      setSpecificHeatZone(matchProduct.Specific_Heat);
    }
  };

  const handleChangeProdWeightZone = (newValue) => {
    setProdWeightZone(newValue)
  };
  const handleProductloadheightZone = (newValue) => {
    setProductLoadHeightZtwo(newValue);
  };
  const handleChangeproductZtwo = (newValue) => {
    setValueProductZtwo(newValue)
    let matchProduct =products.find((x)=> {return x.Product==newValue});
  
    if(newValue == 'Empty'){
      form.setFields([{name:"prod_weight_ztwo",value:0}]);
      setProdWeightZtwo(0);
    }
    if(matchProduct){
      let tempSetPoint = currUnit ? matchProduct.Setpoint : tempConversion(matchProduct.Setpoint, 1, true, false);
      form.setFields([{name:"temp_set_point_ztwo",value:tempSetPoint}]);
      setValueSetPointZtwo(tempSetPoint);
      setHeatOfRespirationZtwo(matchProduct.Heat_of_Respiration);
      setHeatOfRespirationDecimalZtwo(matchProduct.Heat_of_Respiration);
      setSpecificHeatZtwo(matchProduct.Specific_Heat);
    }
  };

  const handleChangeProdWeightZtwo = (newValue) => {
    setProdWeightZone(newValue)
  };
  const handleProductloadheightZtwo = (newValue) => {
    setProductLoadHeightZtwo(newValue);
  };
  // const updateProdWeight =(newValue,currUnit,length=0) =>{

  //   let lengthval = length > 0? length : value;
  //   let pWeight = currUnit ?  lengthval/16*20000 : Number(lbConversion((lengthval/(16*3.28084)*20000),1, !currUnit));

  // switch(newValue){
  //   case 'Full Height':setProdWeight(pWeight)
  //                     break;
  //   case 'Half Height':setProdWeight(pWeight/2);
  //                     break;
  //   case 'Manual':
  //     default: setProdWeight(value_prod_weight);
   
  // }
    
  // }
  const handleChangePartition = (newValue) => {
    setPartition(newValue)
    setStandardPartition(newValue)
  };
  const handleChangePartition12 = (newValue) => {
    setPartition1_2(newValue)
    setStandardPartition1_2(newValue)
  };
  const handleChangePartition23 = (newValue) => {
    setPartition2_3(newValue)
    setStandardPartition2_3(newValue)
  };
  const handleChangeUAPartition = (newValue) => {
    setUAPartition(newValue)
    setStandardUAPartition(newValue)
  };
  const handleChangeCPartition = (newValue) => {
    setCPartition(newValue)
    setCPartitionDecimal(newValue)
    setStandardCPartition(newValue)
  };
  const handleZoneChange = (newValue) => {
    setSelectedZone(newValue);
    if(newValue == 'Two Zone'){
      form.setFields([{name:"Model_sel",value:"T1200R_S3_S3"}])
    }
  };

  const handleChange = (newValue) => {
    // form.setFieldsValue({Length:newValue});
    // console.log('newValue: ', newValue)
    setValue(newValue);
    // updateProdWeight(value_product_load_height,currUnit, newValue);
    setStandardValue(newValue);
    handlePartitionChange(newValue);
    updateUAandThermalMass(value_material,newValue,value_width, value_height,value_uValue_decimal);
  };

  const handlePartitionChange = (val) => {
    setPartition(round((val / 2), 1));
    setPartition1_2(round((val / 3), 1));
    setPartition2_3(round((val / (2 / 3)), 1));
  }
  const handleChangeOverallUA = (newValue) => {
    SetValueOverallUA(newValue);
    setValueAgeCorrectedUAFactor(newValue)
    SetStandardValueOverallUA(newValue);
  }
  const handleChangeUValue = (newValue) => {
    SetUValue(newValue);
    SetUValueDecimal(newValue);
    updateUAandThermalMass(value_material,value,value_width,value_height, newValue);
  }
  const handleChangeInfiltrationFlowrate = (newValue) => {
    setValueInfiltrationFlowrate(newValue);
  }
  const handleChangeEmissivity = (newValue) => {
    setValueEmissivity(newValue);
  }
  const handleChangeSolarAbsorptivity = (newValue) => {
    SetValueSolarAbsorptivity(newValue);
  }
  const handleChangeAgeOfBody = (newValue) => {
    SetValueAgeOfBody(newValue);

    if(value_material && value_material === 'Insulation Material'){
      updateUAandThermalMass(value_material,value,value_width, value_height,value_uValue_decimal, newValue);
    }
  }

  const handleChangeWidth = (newValue) => {
    setValueWidth(newValue);
    setStandardValueWidth(newValue);
    updateUAandThermalMass(value_material,value, newValue,value_height,value_uValue_decimal);
  };

  const handleChangeHeight = (newValue) => {
    setValueHeight(newValue);
    setStandardValueHeight(newValue);
    updateUAandThermalMass(value_material,value,value_width, newValue,value_uValue_decimal);
  };

  const handleChangeRoofSize = (newValue) => {
    setValueRoofsize(newValue);
    if(value_material_sides =='equal'){
      setValueFloorsize(newValue);
      setValueFrontsize(newValue);
      setValueRearsize(newValue);
      setValueSidessize(newValue);
      form.setFields([{name:"floorsize",value:newValue}])
      form.setFields([{name:"frontsize",value:newValue}])
      form.setFields([{name:"rearsize",value:newValue}])
      form.setFields([{name:"sidessize",value:newValue}])
          }
  };
  const handleChangeRoofSelect = (newValue) => {
    setValueRoofSelect(newValue);
    if(value_material_sides =='equal'){
      setValueFloorSelect(newValue);
      setValueFrontSelect(newValue);
      setValueRearSelect(newValue);
      setValueSidesSelect(newValue);
      form.setFields([{name:"floor",value:newValue}])
      form.setFields([{name:"front",value:newValue}])
      form.setFields([{name:"rear",value:newValue}])
      form.setFields([{name:"sides",value:newValue}])
    }
  };

  const handleChangeFloorSelect = (newValue) => {
    setValueFloorSelect(newValue);
  };

  const handleChangeFrontSelect = (newValue) => {
    setValueFrontSelect(newValue);
  };

  const handleChangeRearSelect = (newValue) => {
    setValueRearSelect(newValue);
  };

  const handleChangeSidesSelect = (newValue) => {
    setValueSidesSelect(newValue);
  };

  const handleChangeFloorSize = (newValue) => {
    setValueFloorsize(newValue);
  };

  const handleChangeFrontSize = (newValue) => {
    setValueFrontsize(newValue);
  };

  const handleChangeRearSize = (newValue) => {
    setValueRearsize(newValue);
  };

  const handleChangeSidesSize = (newValue) => {
    setValueSidessize(newValue);
  };
  const handleChangeBoxThermalMass = (newValue) => {
    setValueBoxThermalMass(newValue);
    setValueBoxThermalMassDecimal(newValue);
    setStandardValueBoxThermalMass(newValue);
  };
  const handleChangeAgeCorrectedUAFactor = (newValue) => {
    setValueAgeCorrectedUAFactor(newValue);
  };

  const handleChangeInitWeight = (newValue) => {
    setValueInitWeight(newValue);
  };

  const handleChangeTemp = (newValue) => {
    setValuetemp(newValue);
  };

  const handleChangeTempSetPoint = (newValue) => {
    setValueSetPoint(newValue);
    setStandardValueSetPoint(newValue);
  };

  const handleChangeRestartBandForCooling = (newValue) => {
    setValueRestartBandForCooling(newValue);
    setStandardValueRestartBandForCooling(newValue);
  };
  const handleChangeRestartBandForHeating = (newValue) => {
    setValueRestartBandForHeating(newValue);
    setStandardValueRestartBandForHeating(newValue);
  };

  const handleChangeOffBand = (newValue) => {
    setValueOffBand(newValue);
    setStandardValueOffBand(newValue);
  };
  const handleChangeLowHighSwitchPoint = (newValue) => {
    setValueLowHighSwitchPoint(newValue);
    setStandardValueLowHighSwitchPoint(newValue);
  };
  const handleChangeTempSetPointZone = (newValue) => {
    setValueSetPointZone(newValue);
    // setStandardValueSetPointZone(newValue);
  };

  const handleChangeRestartBandForCoolingZone = (newValue) => {
    setValueRestartBandForCoolingZone(newValue);
    // setStandardValueRestartBandForCoolingZone(newValue);
  };
  const handleChangeRestartBandForHeatingZone = (newValue) => {
    setValueRestartBandForHeatingZone(newValue);
    // setStandardValueRestartBandForHeatingZone(newValue);
  };

  const handleChangeOffBandZone = (newValue) => {
    setValueOffBandZone(newValue);
    // setStandardValueOffBandZone(newValue);
  };
  const handleChangeLowHighSwitchPointZone = (newValue) => {
    setValueLowHighSwitchPointZone(newValue);
    // setStandardValueLowHighSwitchPointZone(newValue);
  };

  const handleChangeTempSetPointZtwo = (newValue) => {
    setValueSetPointZtwo(newValue);
    // setStandardValueSetPointZtwo(newValue);
  };

  const handleChangeRestartBandForCoolingZtwo = (newValue) => {
    setValueRestartBandForCoolingZtwo(newValue);
    // setStandardValueRestartBandForCoolingZtwo(newValue);
  };
  const handleChangeRestartBandForHeatingZtwo = (newValue) => {
    setValueRestartBandForHeatingZtwo(newValue);
    // setStandardValueRestartBandForHeatingZtwo(newValue);
  };

  const handleChangeOffBandZtwo = (newValue) => {
    setValueOffBandZtwo(newValue);
    // setStandardValueOffBandZtwo(newValue);
  };
  const handleChangeLowHighSwitchPointZtwo = (newValue) => {
    setValueLowHighSwitchPointZtwo(newValue);
    // setStandardValueLowHighSwitchPointZtwo(newValue);
  };

  const handleChangeAltitude = (newValue) => {
    setValueAltitude(newValue);
  };

  const handleChangeTempAmb = (newValue) => {
    setValuetempAmb(newValue);
    setStandardValuetempAmb(newValue);
  };

  const handleChangeRelativeHumidity = (newValue) => {
    setValuerelativehumidity(newValue);
  };

  const handleChangeWindSpeed = (newValue) => {
    setValueWindSpeed(newValue);
    setStandardValueWindSpeed(newValue);
  };

  const handleChangePrecool = (newValue) => {
    setValuePrecool(newValue);
  };
  const handleChangeDaily = (newValue) => {
    setValueDaily(newValue);
  };
  const handleChangeDoorOpenings = (newValue) => {
    setValueDoorOpening(newValue);
  };
  const handleChangeAverageDoorOpening = (newValue) => {
    setValueAverageDoorOpening(newValue);
  };
  const handleChangeEcopullDown = (newValue) => {
    setValueEcoPullDown(newValue.target.checked);
  };
  const handleChangeFuelSaver = (newValue) => {
    setValueFuelSaver(newValue.target.checked);
  };
  const handleChangeDoorSwitch = (newValue) => {
    setValueDoorSwitch(newValue.target.checked);
  };
  const handleChangeCurtains = (newValue) => {
    setValueCurtains(newValue.target.checked);
    if(newValue.target.checked){
      setValueEDoor(0.8);
    }else{
      setValueEDoor(0);
    }
  };
  const handleChangeMaterial = (newValue) => {
    setValueMaterial(newValue);
      updateUAandThermalMass(newValue,value,value_width, value_height,value_uValue_decimal);

  };
  const handleChangeDoorType = (newValue) => {
    setValueDoorType(newValue);
    // console.log('current doorType: ', currUnit);
    if(newValue == 'Roll Up'){
      setValueUADoor(currUnit? 5.2753 : 10)
    }else{
      setValueUADoor(0)
    }
      // updateUAandThermalMass(newValue);

  };
  const handleChangeMaterialSides = (e) => {
    let newValue =e.target.value;

    setValueMaterialSides(newValue);
    if(newValue == 'equal'){
      setIsDisabled(true);
      setValueRearSelect(value_roofselect);
      setValueFloorSelect(value_roofselect);
      setValueFrontSelect(value_roofselect);
      setValueSidesSelect(value_roofselect);

      setValueFloorsize(value_roofsize)
      setValueFrontsize(value_roofsize)
      setValueRearsize(value_roofsize)
      setValueSidessize(value_roofsize)
      form.setFields([{name:"floor",value:value_roofselect}])
      form.setFields([{name:"front",value:value_roofselect}])
      form.setFields([{name:"rear",value:value_roofselect}])
      form.setFields([{name:"sides",value:value_roofselect}])
      form.setFields([{name:"floorsize",value:value_roofsize}])
      form.setFields([{name:"frontsize",value:value_roofsize}])
      form.setFields([{name:"rearsize",value:value_roofsize}])
      form.setFields([{name:"sidessize",value:value_roofsize}])
    }else{
      setIsDisabled(false)
    }
  };
  const handleChangeUnit = (newValue) => {
   
    if (newValue) {
      setValueUnit(siUnit);
      setisSIIP('SI')
    } else {
      setValueUnit(ipUnit);
      setisSIIP('IP')
    }
    setCurrUnit(newValue);
    handleSIIPConversion(!newValue, value_material, value_uValue_decimal);
    if (FCMT_RESULT) {
      resultTab(FCMT_RESULT, newValue);
    }
  };
  // const handleGetChartImage = (graphData) => {
  //   Plotly.newPlot("graph", graphData.data, graphData.layout).then(
  //     (graphData) => {
  //       return Plotly.toImage(graphData).then((url) => {
  //         setURL(url);
  //         setchartImage((previousImage) => [...previousImage, url]);
  //       });
  //     }
  //   );
  // };
  // const handleGetChartImage1 = (graphData) => {
  //   Plotly.newPlot("graph1", graphData.data, graphData.layout).then(
  //     (graphData) => {
  //       return Plotly.toImage(graphData).then((url) => {
  //         setURL1(url);
  //         setchartImage((previousImage) => [...previousImage, url]);
  //       });
  //     }
  //   );
  // };
  const handleChangeInputCustomer = (event) => {
    setCustomer(event.target.value);
  };
  const handleChangeInputComment = (event) => {
    setcomments(event.target.value);
  };

  const handleFormSubmit = async (newValue) => {
    // const val = form.getFieldValue();
    setLoader(true);
    setButtonLoading(true);
    setinputtable(newValue);
    // standardConversion(currUnit);
    const materialList = {
      floor_size: `${inchConversion(value_floorsize, 1, currUnit, true)} ${standardUnit.inch}`,
      front_size: `${inchConversion(value_frontsize, 1, currUnit, true)} ${standardUnit.inch}`,
      rear_size: `${inchConversion(value_rearsize, 1, currUnit, true)} ${standardUnit.inch}`,
      roof_size: `${inchConversion(value_roofsize, 1, currUnit, true)} ${standardUnit.inch}`,
      sides_size: `${inchConversion(value_sidessize, 1, currUnit, true)} ${standardUnit.inch}`,
      // roof_material: value_roofselect,
      // floor_material: value_floorselect,
      // front_material: value_frontselect,
      // rear_material: value_rearselect,
      // sides_material: value_sidesselect,
    };
    const distributionList = {
      door_opening_frequency: `${oneperhrConversion(value_door_opening_frequency, 4, currUnit, true)} ${standardUnit.oneperhr}`,
      door_open_time: `${minConversion(value_door_open_time, 1, currUnit, true)} ${standardUnit.min}`,
    }
    const constantProfileList = {
      product_fixed: value_product_fixed,
      door_fixed: value_door_fixed,
    }
    const distAndLongHaul = {
      time_to_load_product: `${minConversion(value_time_to_load, 1, currUnit, true)} ${standardUnit.min}`,
    }
    const includeProd = {
      prod_weight: `${lbConversion(value_prod_weight, 1, currUnit,true)} ${standardUnit.lb}`,
      heat_respiration: `${btuhrlbConversion(value_heat_respiration_decimal, 1, currUnit,true)} ${standardUnit.btuhrlb}`,
      specific_heat: `${heatConversion(value_specific_heat, 1, currUnit,true)} ${standardUnit.heat}`,
      product: `${value_product}`,
    }
    const prodZone = {
      ua_partition: `${btuFhConversion(value_ua_partion, 1, currUnit,true)}  ${standardUnit.btuFh}`,
      c_partition: `${BTMConversion(value_C_partion_decimal, 1, currUnit,true)}  ${standardUnit.BTM}`,
    }
    const twoZone = {
      partition: `${feetConversion(value_partion, 1, currUnit, true)}  ${standardUnit.feet}`,
    }
    const threeZone = {
      partition_1_2: `${feetConversion(value_partion_1_2, 1, currUnit, true)}  ${standardUnit.feet}`,
      partition_2_3: `${feetConversion(value_partion_2_3, 1, currUnit, true)}  ${standardUnit.feet}`,
    }
    const boxUA = {
      overall_ua: `${btuFhConversion(value_overall_ua, 1, currUnit,true)} ${standardUnit.btuFh}`,
      box_thermal_mass: `${BTMConversion(value_box_thermal_mass_decimal, 1, currUnit,true)} ${standardUnit.BTM}`,
    }
    const boxU = {
      u_value: `${btUConversion(value_uValue_decimal, 1, currUnit,true)} ${standardUnit.btuVal}`
    }
    const tmy3 = { 
    location: `${value_location}`,
    date_and_time: `${inputValue}` 
    
    }
    const includeEmission= {
      // unit_electric_efficiency: value_unit_electric_efficiency,
      // electric_grid_profile: `${co2eConversion(value_electric_grid_profile, 1, currUnit,true)} ${standardUnit.co2einlb}`
      // electric_grid_profile: `${lbConversion(value_electric_grid_profile, 1, currUnit,true)} ${standardUnit.co2einlb}`,
      // electric_grid_profile_option: value_electric_grid_profile_option,
      // include_emission: value_include_emission
    }
    const producZoneOne={
    product_load_height: value_product_load_height_zone,
    prod_weight: `${lbConversion(value_prod_weight_zone, 1, currUnit,true)} ${standardUnit.lb}`,
    heat_respiration: `${btuhrlbConversion(value_heat_respiration_decimal_zone, 1, currUnit,true)} ${standardUnit.btuhrlb}`,
    specific_heat: `${heatConversion(value_specific_heat_zone, 1, currUnit,true)} ${standardUnit.heat}`,
    product: `${value_product_zone}`,
    }
    const producZoneTwo={
      product_load_height: value_product_load_height_ztwo,
      prod_weight: `${lbConversion(value_prod_weight_ztwo, 1, currUnit,true)} ${standardUnit.lb}`,
      heat_respiration: `${btuhrlbConversion(value_heat_respiration_decimal_ztwo, 1, currUnit,true)} ${standardUnit.btuhrlb}`,
      specific_heat: `${heatConversion(value_specific_heat_ztwo, 1, currUnit,true)} ${standardUnit.heat}`,
      product: `${value_product_ztwo}`,
    }

    newValue = {
      ...newValue,

      length: `${feetConversion(value, 4, currUnit,true)} ${standardUnit.feet}`,
      height: `${feetConversion(value_height, 4, currUnit,true)} ${standardUnit.feet}`,
      width: `${feetConversion(value_width, 4, currUnit,true)} ${standardUnit.feet}`,
      overall_ua: `${btuFhConversion(value_overall_ua, 1, currUnit,true)} ${standardUnit.btuFh}`,
      age_corrected_ua_factor: `${btuFhConversion(value_overall_ua, 1, currUnit,true)+ btuFhConversion(value_ua_door, 4, currUnit,true)} ${standardUnit.btuFh}`,


      age_of_body: `${value_age_of_body} ${value_Unit.year}`,
      box_thermal_mass: `${BTMConversion(value_box_thermal_mass_decimal, 1, currUnit,true)} ${standardUnit.BTM}`,
      solar_absorptivity: value_solar_absorptivity,
      emissivity: value_emissivity,
      infiltration_flowrate: `${value_infiltration_flowrate} ${value_Unit.cfh}`,
      include_product: value_include_product,
      include_emission : value_include_emission,
      temp_set_point: `${tempConversion(value_temp_set_point, 1, currUnit,true)} ${standardUnit.temp}`,
      restart_band_for_cooling: `${rankConversion(value_restart_band_for_cooling_decimal, 1, currUnit,true)} ${standardUnit.rank}`,
      restart_band_for_heating: `${rankConversion(value_restart_band_for_heating_decimal, 1, currUnit,true)} ${standardUnit.rank}`,
      off_band: `${rankConversion(value_off_band, 1, currUnit,true)}  ${standardUnit.rank}`,
      low_high_switch_point: `${rankConversion(value_low_high_switch_point, 1, currUnit,true)}  ${standardUnit.rank}`,
      hs_wait_time: `${minConversion(value_hs_wait_time, 1, currUnit, true)} ${standardUnit.min}`,
      // precool_wait_time: `${minConversion(value_precool_wait_time, 1, currUnit, true)} ${standardUnit.min}`,
      // preheat_wait_time: `${minConversion(value_preheat_wait_time, 1, currUnit, true)} ${standardUnit.min}`,
      temp_amb: `${tempConversion(value_temp_amb, 1, currUnit,true)} ${standardUnit.temp}`,
      solar_flux: `${fluxConversion(value_solar_flux, 1, currUnit,true)} ${standardUnit.flux}`,
      ambient_pressure: `${pressureConversion(value_ambient_pressure_decimal, 1, currUnit,true)} ${standardUnit.pressure}`,
      RH_amb: value_RH_amb,
      wind_speed: `${mperSecConversion(value_wind_speed,  1, currUnit,true)} ${standardUnit.mperSec}`,
      sky_emissivity: value_sky_emissivity,
      route_time: `${value_route_time*3600} ${standardUnit.min}`,
      precool_time: `${value_precool_time*3600} ${standardUnit.min}`,
      vehicle_speed: `${mperSecConversion(value_vehicle_speed,  1, currUnit,true)} ${standardUnit.mperSec}`,
      road_grade: 0,
      door_type:value_door_type,
      route_profile: value_route_profile,
      eco_pulldown:value_eco_pull_down,
      fuel_saver_II:value_fuel_saver,
      weather_profile: value_weather_profile,
      E_door: Value_selectedZone === 'Two Zone' ? value_E_door_TwoZone : value_E_door,
      enableDoorSwitch: value_door_switch,
      curtains: value_curtains
    }
    if (value_route_profile == 'Daily Distribution') {
      Object.assign(newValue, distributionList);
    }
    if (value_material == 'Insulation Material') {
      Object.assign(newValue, materialList);
    }else{
      
    }


    // if (value_material == 'U Value') {
    //   Object.assign(newValue, boxU);
    // }
    if (value_route_profile == 'Constant Profile') {
      Object.assign(newValue, constantProfileList);
    }
    if (value_route_profile == 'Daily Distribution' || value_route_profile == 'Long Haul' || value_route_profile =="Transient Profile" || value_route_profile == 'Multi City Long Haul') {
      Object.assign(newValue, distAndLongHaul);
    }
    if (value_include_product === 'Yes') {
      Object.assign(newValue, includeProd);
    }
    if (value_include_emission === 'Yes') {
      delete newValue.include_emission
      delete newValue.electric_grid_profile_option
      delete newValue.electric_grid_profile
      delete newValue.unit_electric_efficiency
      // Object.assign(newValue, includeEmission);
    }else{
      delete newValue.include_emission
    }
    if (Value_selectedZone == 'Two Zone') {
      Object.assign(newValue, twoZone);
      if(value_include_product_zone == 'Yes' && value_include_product_ztwo == 'Yes'){
        newValue.productsZone = [producZoneOne, producZoneTwo];
      }else if(value_include_product_zone == 'Yes'){
        newValue.productsZone = [producZoneOne];
        
      }else if(value_include_product_ztwo=='Yes'){
        newValue.productsZone = [producZoneTwo];
      }
      newValue.system_controller=[
        {
          temp_set_point: `${tempConversion(value_temp_set_point_zone, 1, currUnit,true)} ${standardUnit.temp}`,
          restart_band_for_cooling: `${rankConversion(value_restart_band_for_cooling_decimal_zone, 1, currUnit,true)} ${standardUnit.rank}`,
          restart_band_for_heating: `${rankConversion(value_restart_band_for_heating_decimal_zone, 1, currUnit,true)} ${standardUnit.rank}`,
          off_band: `${rankConversion(value_off_band_zone, 1, currUnit,true)}  ${standardUnit.rank}`,
          low_high_switch_point: `${rankConversion(value_low_high_switch_point_zone, 1, currUnit,true)}  ${standardUnit.rank}`,
        },
        {
          temp_set_point: `${tempConversion(value_temp_set_point_ztwo, 1, currUnit,true)} ${standardUnit.temp}`,
          restart_band_for_cooling: `${rankConversion(value_restart_band_for_cooling_decimal_ztwo, 1, currUnit,true)} ${standardUnit.rank}`,
          restart_band_for_heating: `${rankConversion(value_restart_band_for_heating_decimal_ztwo, 1, currUnit,true)} ${standardUnit.rank}`,
          off_band: `${rankConversion(value_off_band_ztwo, 1, currUnit,true)}  ${standardUnit.rank}`,
          low_high_switch_point: `${rankConversion(value_low_high_switch_point_ztwo, 1, currUnit,true)}  ${standardUnit.rank}`,
        },
        
      ]
      newValue.include_product= [value_include_product_zone, value_include_product_ztwo];
      delete newValue.temp_set_point;
      delete newValue.restart_band_for_cooling;
      delete newValue.restart_band_for_heating;
      delete newValue.off_band;
      delete newValue.low_high_switch_point;
      delete newValue.temp_set_point_zone;
      delete newValue.temp_set_point_ztwo;
      delete newValue.product_load_height_zone;
      delete newValue.product_load_height_ztwo;
      delete newValue.prod_weight;
      delete newValue.include_product_zTwo;
      delete newValue.include_product_zOne;
      delete newValue.product
      delete newValue.specific_heat
      delete newValue.heat_respiration
      // delete newValue.temp_set_point
    }
    if (Value_selectedZone == 'Three Zone') {
      Object.assign(newValue, threeZone);
    }
    if (Value_selectedZone == 'Three Zone' || Value_selectedZone == 'Two Zone') {
      Object.assign(newValue, prodZone);
    }
    if(value_weather_profile =="TMY3"){
      Object.assign(newValue, tmy3);
    }
    if(value_route_profile =="Transient Profile"){
      newValue.route_transient = handleRouteTransient(); 
      delete newValue.route_transient_door_fixed_start
      delete newValue.route_transient_door_fixed_end
      delete newValue.route_transient_product_fixed_end
      delete newValue.route_transient_product_fixed_start
      delete newValue.route_transient_road_grade_end
      delete newValue.route_transient_road_grade_start
      delete newValue.route_transient_time_start
      delete newValue.route_transient_time_end
      delete newValue.route_transient_vehicle_speed_end
      delete newValue.route_transient_vehicle_speed_start
    }
    if(value_route_profile =="Multi City Long Haul"){
      newValue.route_multicity = handleRouteMuticity(); 
      delete newValue.route_multicity_location_end
      delete newValue.route_multicity_location_start
      delete newValue.route_multicity_time_start
      delete newValue.route_multicity_time_end
      delete newValue.route_multicity_vehicle_speed_end
      delete newValue.route_multicity_vehicle_speed_start
    }

    if(value_weather_profile =="Transient Profile"){
      newValue.weather_transient = handleWeatherTransient(); 
      delete newValue.weather_transient_time_start
    delete newValue.weather_transient_Temperature_start
    delete newValue.weather_transient_solar_flux_start
    delete newValue.weather_transient_pressure_start
    delete newValue.weather_transient_wind_speed_start
    delete newValue.weather_transient_relative_humidity_start
    delete newValue.weather_transient_sky_emissivity_start
    delete newValue.weather_transient_time_end
    delete newValue.weather_transient_Temperature_end
    delete newValue.weather_transient_solar_flux_end
    delete newValue.weather_transient_pressure_end
    delete newValue.weather_transient_wind_speed_end
    delete newValue.weather_transient_relative_humidity_end
    delete newValue.weather_transient_sky_emissivity_end
    }
    if (newValue?.u_value !== undefined) {
      delete newValue.u_value;
    }
    setLoader(true);
    setButtonLoading(true);
    setPayloadData(newValue);
    let resp = await FcmtSubmit(newValue);
    if (resp) {
      setButtonLoading(false);
      setLoader(false);
    }
  };

  const initialValues = {
    length: value,
    width: value_width,
    height: value_height,
    vehicle_type: "Truck",
    compartment: "One Zone",
    Model_sel: "T_1090",
    specify_insu: "UA Factor",
    value_include_product: "No",
    value_heat_respiration: 0,
    algorithm: 'Cycle Sentry',
    weather_profile: 'Constant Profile',
    route_profile: 'Daily Distribution',
    landmass:'North America',
    location: 'Albuquerque, NM',
    roof:'Polyurethane',
    floor:'Polyurethane',
    front:'Polyurethane',
    rear:'Polyurethane',
    sides:'Polyurethane',
    route_multicity_time_start: start_route_multicity_time,
    route_multicity_location_start: start_route_multicity_location,
    route_multicity_vehicle_speed_start: start_route_multicity_speed,
    route_multicity_time_end: end_route_multicity_time,
    route_multicity_location_end: end_route_multicity_location,
    route_multicity_vehicle_speed_end: end_route_multicity_speed,
    route_transient_time_start: start_route_time,
    route_transient_vehicle_speed_start: start_route_speed,
    // route_transient_road_grade_start: start_route_road,
    route_transient_product_fixed_start: start_route_product,
    route_transient_door_fixed_start: start_route_door,
    route_transient_time_end: end_route_time,
    route_transient_vehicle_speed_end: end_route_speed,
    // route_transient_road_grade_end: end_route_road,
    route_transient_product_fixed_end: end_route_product,
    route_transient_door_fixed_end: end_route_door,
    // weather_transient_time_start: value_weather_transient_time_start,
    weather_transient_time_start: -value_precool_time,
    weather_transient_Temperature_start: value_weather_transient_temp_start,
    weather_transient_solar_flux_start: value_weather_transient_flux_start,
    weather_transient_pressure_start: value_weather_transient_pressure_start_decimal,
    weather_transient_wind_speed_start: value_weather_transient_temp_start,
    weather_transient_relative_humidity_start: value_weather_transient_relative_humidity_start,
    weather_transient_sky_emissivity_start: value_weather_transient_sky_emissivity_start,
    // weather_transient_time_end: value_weather_transient_time_end,
    weather_transient_time_end: value_route_time,
    weather_transient_Temperature_end: value_weather_transient_temp_end,
    weather_transient_solar_flux_end: value_weather_transient_flux_end,
    weather_transient_pressure_end: value_weather_transient_pressure_end_decimal,
    weather_transient_wind_speed_end: value_weather_transient_temp_end,
    weather_transient_relative_humidity_end: value_weather_transient_relative_humidity_end,
    weather_transient_sky_emissivity_end: value_weather_transient_sky_emissivity_end,
    product_load_height:value_product_load_height,
    product_load_height_zone:value_product_load_height_zone,
    product_load_height_ztwo:value_product_load_height_ztwo,
    eco_pulldown:value_eco_pull_down,
    fuel_saver_II:value_fuel_saver,
    door_type:value_door_type,
    electric_grid_profile_option: value_electric_grid_profile_option
  }
const defaultBoxSize= (vehicleType)=>{
  if(vehicleType=='Truck'){
    setValue(currUnit ? 6.8001: 22.31);
    setValueWidth(currUnit ? 2.591:8.5007);
    setValueHeight(currUnit ?2.642:8.668);
  }else{
    setValue(currUnit ?16.1544 : 53);
    setValueWidth(currUnit ? 2.591:8.5007);
    setValueHeight(currUnit ? 2.921:9.5833);
  }
}
  const handleVehicleType = (newValue) => {
    setvehicleType(newValue);
    defaultBoxSize(newValue);
    if(newValue == 'Truck'){
      form.setFields([{name:"Model_sel",value:"T_1000M"}])      
    }else{
      form.setFields([{name:"Model_sel",value:"Precedent_C600"}])
    }
  };
  const handleModelSelect = (newValue) => {
    setModelSelect(newValue);
  }
  const handleSIIPConversion = (currentUnit, material=value_material, uVal=value_uValue_decimal) => {
    // console.log(' curr: ', currentUnit);
    const decplaces = 1;
    const decplacesBoxsize= 4;
    if(value_door_type =='Roll Up'){
      setValueUADoor(currentUnit ? 10:5.2753);
    }
    setValue(feetConversion(value, decplacesBoxsize, currentUnit));
    setValueWidth(feetConversion(value_width, decplacesBoxsize, currentUnit));
    setValueHeight(feetConversion(value_height, decplacesBoxsize, currentUnit));
    setPartition(feetConversion(value_partion, decplaces, currentUnit));
    setPartition1_2(feetConversion(value_partion_1_2, decplaces, currentUnit));
    setPartition2_3(feetConversion(value_partion_2_3, decplaces, currentUnit));
    
    SetValueOverallUA(btuFhConversion(value_overall_ua, decplaces, currentUnit));
    setValueAgeCorrectedUAFactor(btuFhConversion(value_overall_ua, decplaces, currentUnit));
    setUAPartition(btuFhConversion(value_ua_partion, decplaces, currentUnit));
    
    
    SetUValue(btUConversion(value_uValue_decimal, decplaces, currentUnit));
    SetUValueDecimal(btUConversion(value_uValue_decimal, decplaces, currentUnit, false, true));
    setCPartition(BTMConversion(value_C_partion, decplaces, currentUnit));
    setValueBoxThermalMass(BTMConversion(value_box_thermal_mass, decplaces, currentUnit));
    setCPartitionDecimal(BTMConversion(value_C_partion_decimal, decplaces, currentUnit,false,true));
    setValueBoxThermalMassDecimal(BTMConversion(value_box_thermal_mass_decimal, decplaces, currentUnit,false,true));
    
    setProdWeight(lbConversion(value_prod_weight, decplaces, currentUnit));

    setProdWeightZone(lbConversion(value_prod_weight_zone, decplaces, currentUnit));
    setProdWeightZtwo(lbConversion(value_prod_weight_ztwo, decplaces, currentUnit));
    
    setHeatOfRespiration(btuhrlbConversion(value_heat_respiration_decimal, decplaces, currentUnit));
    setHeatOfRespirationDecimal(btuhrlbConversion(value_heat_respiration_decimal, decplaces, currentUnit,false, true));
    setSpecificHeat(heatConversion(value_specific_heat, decplaces, currentUnit));

    setHeatOfRespirationZone(btuhrlbConversion(value_heat_respiration_decimal_zone, decplaces, currentUnit));
    setHeatOfRespirationDecimalZone(btuhrlbConversion(value_heat_respiration_decimal_zone, decplaces, currentUnit,false, true));
    setSpecificHeatZone(heatConversion(value_specific_heat_zone, decplaces, currentUnit));

    setHeatOfRespirationZtwo(btuhrlbConversion(value_heat_respiration_decimal_ztwo, decplaces, currentUnit));
    setHeatOfRespirationDecimalZtwo(btuhrlbConversion(value_heat_respiration_decimal_ztwo, decplaces, currentUnit,false, true));
    setSpecificHeatZtwo(heatConversion(value_specific_heat_ztwo, decplaces, currentUnit));
    
    setValueSetPoint(tempConversion(value_temp_set_point, decplaces, currentUnit));
    setValuetempAmb(tempConversion(value_temp_amb, decplaces, currentUnit));
    
    setValueRestartBandForCooling(rankConversion(value_restart_band_for_cooling_decimal, decplaces, currentUnit));
    setValueRestartBandForHeating(rankConversion(value_restart_band_for_heating_decimal, decplaces, currentUnit));
    setValueRestartBandForCoolingDecimal(rankConversion(value_restart_band_for_cooling_decimal, decplaces, currentUnit,false,true));
    setValueRestartBandForHeatingDecimal(rankConversion(value_restart_band_for_heating_decimal, decplaces, currentUnit,false,true));
    setValueOffBand(rankConversion(value_off_band, decplaces, currentUnit));
    setValueLowHighSwitchPoint(rankConversion(value_low_high_switch_point, decplaces, currentUnit));
    
    // SetValueSolarAbsorptivity(fluxConversion(value_solar_absorptivity, decplaces, currentUnit));
    setSolarFlux(fluxConversion(value_solar_flux, decplaces, currentUnit));
   
    setAmbiantPressure(pressureConversion(value_ambient_pressure_decimal, decplaces, currentUnit));
    setAmbiantPressureDecimal(pressureConversion(value_ambient_pressure_decimal, decplaces, currentUnit, false,true));
   
    // setValueInfiltrationFlowrate(mCubeConversion(value_infiltration_flowrate, decplaces, currentUnit));
    setValueWindSpeed(mperSecConversion(value_wind_speed, decplaces, currentUnit));
    setVehicleSpeed(mperSecConversion(value_vehicle_speed, decplaces, currentUnit));
    
    //route transient Profile
    setValueRoofsize(inchConversion(value_roofsize, decplaces, currentUnit))
    setValueFloorsize(inchConversion(value_floorsize, decplaces, currentUnit))
    setValueRearsize(inchConversion(value_rearsize, decplaces, currentUnit))
    setValueFrontsize(inchConversion(value_frontsize, decplaces, currentUnit))
    setValueSidessize(inchConversion(value_sidessize, decplaces, currentUnit))

    //weather transient Profile
    
    setWeatherTransientTempStart(tempConversion(value_weather_transient_temp_start, decplaces, currentUnit));
    setWeatherTransientTempEnd(tempConversion(value_weather_transient_temp_end, decplaces, currentUnit));
    setWeatherTransientFluxStart(fluxConversion(value_weather_transient_flux_start, decplaces, currentUnit));
    setWeatherTransientFluxEnd(fluxConversion(value_weather_transient_flux_end, decplaces, currentUnit));
    setWeatherTransientWindSpeedStart(mperSecConversion(value_weather_transient_wind_speed_start, decplaces, currentUnit));
    setWeatherTransientWindSpeedEnd(mperSecConversion(value_weather_transient_wind_speed_end, decplaces, currentUnit));

    setWeatherTransientPressureStart(pressureConversion(value_weather_transient_pressure_start_decimal, decplaces, currentUnit));
    setWeatherTransientPressureStartDecimal(pressureConversion(value_weather_transient_pressure_start_decimal, decplaces, currentUnit, false,true));
    setWeatherTransientPressureEnd(pressureConversion(value_weather_transient_pressure_end_decimal, decplaces, currentUnit));
    setWeatherTransientPressureEndDecimal(pressureConversion(value_weather_transient_pressure_end_decimal, decplaces, currentUnit, false,true));
    form.setFields([{name:"weather_transient_Temperature_start",value:tempConversion(value_weather_transient_temp_start, decplaces, currentUnit)}])
    form.setFields([{name:"weather_transient_Temperature_end",value:tempConversion(value_weather_transient_temp_end, decplaces, currentUnit)}])
    form.setFields([{name:"weather_transient_solar_flux_start",value:fluxConversion(value_weather_transient_flux_start, decplaces, currentUnit)}])
    form.setFields([{name:"weather_transient_solar_flux_end",value:fluxConversion(value_weather_transient_flux_end, decplaces, currentUnit)}])
    form.setFields([{name:"weather_transient_pressure_start",value:pressureConversion(value_weather_transient_pressure_start_decimal, decplaces, currentUnit, false,true)}])
    form.setFields([{name:"weather_transient_pressure_end",value:pressureConversion(value_weather_transient_pressure_end_decimal, decplaces, currentUnit, false,true)}])
    form.setFields([{name:"weather_transient_wind_speed_start",value:mperSecConversion(value_weather_transient_wind_speed_start, decplaces, currentUnit)}])
    form.setFields([{name:"weather_transient_wind_speed_end",value:mperSecConversion(value_weather_transient_wind_speed_end, decplaces, currentUnit)}])
    
    weatherStartRows.map(x=>{
      x.weatherTemperature= tempConversion(x.weatherTemperature, decplaces, currentUnit);
      x.weatherSolarFlux= fluxConversion(x.weatherSolarFlux, decplaces, currentUnit);
      x.weatherWindSpeed= mperSecConversion(x.weatherWindSpeed, decplaces, currentUnit);
      x.weatherPressure = pressureConversion(x.weatherPressure, decplaces, currentUnit, false,true);
    })
    setElectricGridProfile(lbConversion(value_electric_grid_profile, decplaces, currentUnit));
  }
  // const standardConversion =(currentUnit,e)=>{
  //   const decplaces = 1;
  //   console.log(' curr: ', currentUnit);
  //   setStandardValue(feetConversion(value, decplaces, currentUnit,true));
  //   setStandardValueWidth(feetConversion(value_width, decplaces, currentUnit,true));
  //   setStandardValueHeight(feetConversion(value_height, decplaces, currentUnit,true));
  //   setStandardPartition(feetConversion(value_partion, decplaces, currentUnit, true));
  //   setStandardPartition1_2(feetConversion(value_partion_1_2, decplaces, currentUnit, true));
  //   setStandardPartition2_3(feetConversion(value_partion_2_3, decplaces, currentUnit, true));
    
  //   setStandardDoorOpenTime(minConversion(value_door_open_time, decplaces, currentUnit, true));
  //   setStandardTimeToLoad(minConversion(value_time_to_load, decplaces, currentUnit, true));
  //   setStandardHSWaitTime(minConversion(value_hs_wait_time, decplaces, currentUnit, true));
  //   SetStandardValueOverallUA(btuFhConversion(value_overall_ua, decplaces, currentUnit,true));
  //   setStandardUAPartition(btuFhConversion(value_ua_partion, decplaces, currentUnit,true));
  //   setStandardCPartition(BTMConversion(value_C_partion, decplaces, currentUnit,true));
  //   setStandardValueBoxThermalMass(BTMConversion(value_box_thermal_mass, decplaces, currentUnit,true));
  //   setStandardValueSetPoint(tempConversion(value_temp_set_point, decplaces, currentUnit,true));
  //   setStandardValuetempAmb(tempConversion(value_temp_amb, decplaces, currentUnit,true));
  //   setStandardValueRestartBandForCooling(rankConversion(value_restart_band_for_cooling, decplaces, currentUnit,true));
  //   setStandardValueOffBand(rankConversion(value_off_band, decplaces, currentUnit,true));
  //   setStandardSolarFlux(fluxConversion(value_solar_flux, decplaces, currentUnit,true));
  //   setStandardAmbiantPressure(pressureConversion(value_ambient_pressure, decplaces, currentUnit,true));
  //   setStandardValueWindSpeed(mperSecConversion(value_wind_speed, decplaces, currentUnit,true));
  //   setStandardVehicleSpeed(mperSecConversion(value_vehicle_speed, decplaces, currentUnit,true));
  //   handleFormSubmit(e);
  //   console.log('set ambient pressure: ', standard_ambient_pressure, pressureConversion(value_ambient_pressure, decplaces, currentUnit,true));
  // }
  const round = (number, x) => {
    return Math.round(number * Math.pow(10, x)) / Math.pow(10, x);
  }
    const oneperhrConversion = (val, x, currentUnit, standard=false) => {
    return currentUnit ? (val / 3600) : (val / 3600);
  }
  const minConversion = (val, x, currentUnit, standard= false) => {
    return currentUnit ? round(((val * 60)), x) : round(((val * 60)), x);
  }

  const conversionlb =(mapData, curUnit)=>{
    // console.log('findData', curUnit, mapData)
    const updatedUsandata = mapData?.map(item => ({
      ...item,
      value: curUnit?  item.value.toFixed(4) : (item.value * 2.20462 ).toFixed(4),
    }));
    return updatedUsandata;
  }

  const inchConversion = (val, x, currentUnit, standard= false) => {
    // console.clear();
    // console.log('currentUnit', currUnit, val)
    if(standard){
      return currentUnit ? ((val)/1000) : (round(((val * 25.4)), x)/1000);
    }else{

      return currentUnit ? round(((val / 25.4)), x) : round(((val * 25.4)), x);
    }
  }//done
  const feetConversion = (val, x, currentUnit, standard= false) => {
    if(standard){
      return currentUnit ? val : round(((val / 3.28084)), x);
    }else{

      return currentUnit ? round(((val * 3.28084)), x) : round(((val / 3.28084)), x);
    }
  }//done
  // const co2eConversion= (){
  //   return currentUnit ? round(((val *  0.1761101838)), x) : round(((val * 5.678263)), x);
  // }
  const btUConversion = (val, x, currentUnit, standard= false, decimal=false) => {
    if(standard){
      return currentUnit ? val:  (val * 5.678263);
    }
    else if(decimal){
      return currentUnit ? (val *  0.1761101838): (val * 5.678263);
    }else{
      return currentUnit ? round(((val *  0.1761101838)), x) : round(((val * 5.678263)), x);// wat to btu or si to ip
    }

    }
  const btuFhConversion = (val, x, currentUnit, standard= false,uaDoor=false) => {
    if(standard){
      return currentUnit ? val: uaDoor? (val / 1.895634): round(((val / 1.895634)), x);
    }else{
      return currentUnit ? round(((val * 1.895634)), x) : round(((val / 1.895634)), x);
    }

    }
  const BTMConversion = (val, x, currentUnit, standard= false, decimal=false) => {
    if(standard){
      return currentUnit ? val: (val * 1889.101);
    }else if(decimal){
      return currentUnit ? (val / 1889.101): (val * 1889.101);
    }else{
      return currentUnit ? round(((val / 1889.101)), x) : round(((val * 1889.101)), x);
    }
  }//done
  const lbConversion = (val, x, currentUnit, standard= false) => {
    if(standard){
      return currentUnit ? val : round(((val / 2.20462)), x);
    }else{
    return currentUnit ? round(((val * 2.20462)), x) : round(((val / 2.20462)), x);
    }
  }//done
  const heatConversion = (val, x, currentUnit, standard= false) => {
    if(standard){
      return currentUnit ? val : round(((val *((0.000947817*(1/2.20462)*1.8)))), x) ;
    }else{
    return currentUnit ? round(((val *(((1/0.000947817)*(2.20462)*(1/1.8))))), x) : round(((val *((0.000947817*(1/2.20462)*1.8)))), x);
    }
  }//done
  const btuhrlbConversion = (val, x, currentUnit, standard= false, decimal=false) => {
    if(standard){
      return currentUnit ? val : ((val / 1.548));
    }else if(decimal){
      return currentUnit ? (val * 1.548): (val / 1.548);
    }else{
    return currentUnit ? round(((val * 1.548)), x) : round(((val / 1.548)), x);
    }
  }//done
  const tempConversion = (val, x, currentUnit, standard= false) => {
    if(standard){
      return currentUnit ? round((val + 273.15), x) : round((((val - 32) * (5 / 9))+273.15), x);
    }else{
      return currentUnit ? round(((val * (9 / 5)) + 32), x) : round(((val - 32) * (5 / 9)), x);
    }
  }//done
  const rankConversion = (val, x, currentUnit, standard= false, decimal=false) => {
    if(standard){
      return currentUnit ? val : (val * (5 / 9));
    }else if(decimal){
      return currentUnit ? (val * (9 / 5)): (val * (5 / 9));
    }else{
      return currentUnit ? round((val * (9 / 5)), x) : round((val * (5 / 9)), x);
    }
  }
  const fluxConversion = (val, x, currentUnit, standard= false) => {
    if(standard){
      return currentUnit ? val : round((val * 3.154591), x);
    }else{

      return currentUnit ? round((val / 3.154591), x) : round((val * 3.154591), x);
    }
  }// done
  const pressureConversion = (val, x, currentUnit, standard= false, decimal=false) => {
    if(standard){
      // return currentUnit ? round((val * 6895), x) :  round((val / 6895), x);
      return currentUnit ? val : (val * 6895);
    }else if(decimal){
      return currentUnit ? (val / 6895) : (val * 6895);
    }else{
      return currentUnit ? round((val / 6895), x) : round((val * 6895), x);
    }
  }
  const mCubeConversion = (val, x, currentUnit) => {
    return currentUnit ? round((val * 2118.88), x) : round((val / 2118.88), x);
  }//done
  const mperSecConversion = (val, x, currentUnit, standard= false) => {
    if(standard){
      return currentUnit ? val : round((val / 2.236936), x);
    }else{

      return currentUnit ? round((val * 2.236936), x) : round((val / 2.236936), x);
    }
  }//done

  const handleChangeStartTimeMulticity = (newValue) => {
    setStartRouteMulticityTime(newValue);
  };
  const handleChangeRouteMulticityStartSpeed = (newValue) => {
    setStartRouteMulticitySpeed(newValue);
  };
  const handleChangeRouteMulticityStartLocation = (newValue) => {
    setStartRouteMulticityLocation(newValue);
    setLocation(newValue);
  };
  const handleChangeMulticityEndTime = (newValue) => {
    setEndRouteMulticityTime(newValue);
    setRouteTime(newValue);
  };
  const handleChangeRouteMulticityEndSpeed = (newValue) => {
    setEndRouteMulticitySpeed(newValue);
  };
  const handleChangeRouteMulticityEndLocation = (newValue) => {
    setEndRouteMulticityLocation(newValue);
  };

  const handleChangeTotalStopsMultiCity = (newValue) => {
    setTotalStopsMulticity(newValue)
    createRouteStartRowsMulticity(newValue);
  };

  const handleChangeStartTime = (newValue) => {
    setStartRouteTime(newValue);
  };
  const handleChangeRoutestartSpeed = (newValue) => {
    setStartRouteSpeed(newValue);
  };
  const handleChangeRouteStartRoad = (newValue) => {
    setStartRouteRoad(newValue);
  };
  const handleChangeRouteStartProduct = (newValue) => {
    setStartRouteProduct(newValue);
  };
  const handleChangeRouteStartdoor = (newValue) => {
    setStartRouteDoor(newValue);
  };
  const handleChangeEndTime = (newValue) => {
    setEndRouteTime(newValue);
  };
  const handleChangeRouteEndSpeed = (newValue) => {
    setEndRouteSpeed(newValue);
  };
  const handleChangeRouteEndRoad = (newValue) => {
    setEndRouteRoad(newValue);
  };
  const handleChangeRouteEndProduct = (newValue) => {
    setEndRouteProduct(newValue);
  };
  const handleChangeRouteEndDoor = (newValue) => {
    setEndRouteDoor(newValue);
  };
  const handleChangeTotalRows = (newValue) => {
      setTotalRows(newValue);
      createWeatherStartRows(newValue)
  };

  const createRouteStartRows = (count) => {
    const newRows = [];
    for (let i = 0; i < count; i++) {
      // const routeStartDoor = i % 2 === 0 ? 'Open' : 'Closed'; // Alternating door values
      const newRow = {
        // routeStartTime: dayjs('00:00:', 'HH:mm'),
        routeStartTime: 0,
        routeStartSpeed: 'Stop',
        routeStartRoad: 0,
        routeStartProduct: 1,
        routeStartDoor: 'Open',
        routeEndTime: 0,
        routeEndSpeed: 'Highway',
        routeEndRoad: 0,
        routeEndProduct: 1,
        routeEndDoor: 'Closed'
      };
      newRows.push(newRow);
    }
    setRouteStartRows(newRows);
  };
  const createRouteStartRowsMulticity = (count, currentloc = currentLocation) => {
    const newRows = [];
    for (let i = 0; i < count; i++) {
      const newRow = {
        // routeStartTime: dayjs('00:00:', 'HH:mm'),
        routeMulticityTime: 0,
        // routeMulticityLocation: 'Albuquerque, NM',
        routeMulticityLocation: currentloc ? currentloc[0]: value_location,
        routeMulticitySpeed: 'Stop',
      };
      newRows.push(newRow);
    }
    setRouteStartRowsMulticity(newRows);
  };
  const createWeatherStartRows = (count) => {
    const newRows = [];
    for (let i = 2; i < count; i++) {
      // const routeStartDoor = i % 2 === 0 ? 'Open' : 'Closed'; // Alternating door values
      const newRow = {
        // routeStartTime: dayjs('00:00:', 'HH:mm'),
        weatherTripTime: value_precool_time,
        weatherTemperature: 22,
        weatherSolarFlux: 0,
        weatherPressure: value_ambient_pressure,
        weatherRelativeHumidity: 0,
        weatherWindSpeed: 0,
        weatherSkyEmissivity: 0
      };
      newRows.push(newRow);
    }
    setWeatherStartRows(newRows);
  };
  const handleRowInputChange = (index, field, value) => {
    const updatedRows = [...routeStartRows];
    updatedRows[index][field] = value;
    if(field=='routeStartProduct'){
      updatedRows[index]['routeEndProduct'] = value;
    }
    setRouteStartRows(updatedRows);
  };
  const handleRowInputChangeMulticity = (index, field, value) => {
    const updatedRows = [...routeStartRows_multicity];
    updatedRows[index][field] = value;
    setRouteStartRowsMulticity(updatedRows);
  };
  const handleWeatherRowInputChange = (index, field, value) => {
    const updatedRows = [...weatherStartRows];
      updatedRows[index][field] = value;
    setWeatherStartRows(updatedRows);
  };
  const speedchecks= (val)=>{
    return val === 'Highway'? 26.8224: val === 'Urban'? 13.4112: 0; // 60mph to 26.8224 m/sec , 30mph to 13.4112 m/sec
  }
  const doorOperation = (val)=>{
    return val === 'Open' ? 1: 0;
  }
  const hrTosec =(val)=>{
    return val*3600;
  }
  const handleRouteTransient = () => {
    let routeInitial= {
      routeStartTime: hrTosec(start_route_time),
      routeStartSpeed: speedchecks(start_route_speed),
      routeStartRoad: start_route_road,
      routeStartProduct: start_route_product,
      routeStartDoor: doorOperation(start_route_door),
      routeEndTime: hrTosec(end_route_time),
      routeEndSpeed: speedchecks(end_route_speed),
      routeEndRoad: end_route_road,
      routeEndProduct: end_route_product,
      routeEndDoor: doorOperation(end_route_door),
    }
    const updatedRowVals= JSON.parse(JSON.stringify(routeStartRows)).map(x=>{
      x.routeStartDoor= doorOperation(x.routeStartDoor);
      x.routeEndDoor= doorOperation(x.routeEndDoor);
      x.routeStartSpeed= speedchecks(x.routeStartSpeed);
      x.routeEndSpeed= speedchecks(x.routeEndSpeed);
      x.routeStartTime = hrTosec(x.routeStartTime);
      x.routeEndTime = hrTosec(x.routeEndTime);
     return x;
    });

    const resultObj = [routeInitial,...updatedRowVals];
    const shiftedData = JSON.parse(JSON.stringify(resultObj)).map((item, index, array) => {
        let newobj; 
        if(index == 0){
          newobj = {
          routeStartTime: array[index].routeStartTime,
          routeStartSpeed: array[index].routeStartSpeed,
          routeStartRoad: array[index].routeStartRoad,
          routeStartProduct: array[index].routeStartProduct,
          routeStartDoor: array[index].routeStartDoor
          }
        }else{
          newobj = {
            routeStartTime: array[index].routeEndTime,
        routeStartSpeed: array[index].routeEndSpeed,
        routeStartRoad: array[index].routeEndRoad,
        routeStartProduct: array[index].routeEndProduct,
        routeStartDoor: array[index].routeEndDoor
        
        }
    }
    if(index < array.length-1){
      newobj.routeEndTime= array[index + 1].routeStartTime;
      newobj.routeEndSpeed= array[index + 1].routeStartSpeed;
      newobj.routeEndRoad= array[index + 1].routeStartRoad;
      newobj.routeEndProduct= array[index + 1].routeStartProduct;
      newobj.routeEndDoor= array[index + 1].routeStartDoor;
    }else{
      newobj.routeEndTime= array[0].routeEndTime;
      newobj.routeEndSpeed= array[0].routeEndSpeed;
      newobj.routeEndRoad= array[0].routeEndRoad;
      newobj.routeEndProduct= array[0].routeEndProduct;
      newobj.routeEndDoor= array[0].routeEndDoor;
    }
    return newobj;
  }
      )
      return resultObj.length > 1 ? shiftedData : resultObj;
  };
  const handleRouteMuticity = () => {
    let multicityInitial= {
      routeMulticityTime: hrTosec(start_route_multicity_time),
      routeMulticityLocation: start_route_multicity_location,
      routeMulticitySpeed: speedchecks(start_route_multicity_speed),
    }
    const updatedRowVals= JSON.parse(JSON.stringify(routeStartRows_multicity)).map(x=>{
      x.routeMulticityTime = hrTosec(x.routeMulticityTime);
      x.routeMulticityLocation= x.routeMulticityLocation;
      x.routeMulticitySpeed= speedchecks(x.routeMulticitySpeed);
      return x;
    });
    let multicityEnd= {
      routeMulticityTime: hrTosec(end_route_multicity_time),
      routeMulticityLocation: end_route_multicity_location,
      routeMulticitySpeed: speedchecks(end_route_multicity_speed),
    }

    const resultObj = [multicityInitial,...updatedRowVals,multicityEnd];

      return resultObj;
  };

  const handleWeatherTransient =() =>{
      const startWeather ={
        weatherTripTime : `${value_weather_transient_time_start * 3600} ${standardUnit.min}`,
        weatherTemperature: `${tempConversion(value_weather_transient_temp_start, 1, currUnit,true)} ${standardUnit.temp}`,
        weatherSolarFlux:`${fluxConversion(value_weather_transient_flux_start, 1, currUnit,true)} ${standardUnit.flux}`,
        weatherPressure: `${pressureConversion(value_weather_transient_pressure_start_decimal, 1, currUnit,true)} ${standardUnit.pressure}`,
        weatherRelativeHumidity: value_weather_transient_relative_humidity_start,
        weatherWindSpeed: `${mperSecConversion(value_weather_transient_wind_speed_start,  1, currUnit,true)} ${standardUnit.mperSec}`,
        weatherSkyEmissivity: value_weather_transient_sky_emissivity_start
      }
      const endWeather ={
        weatherTripTime : `${value_weather_transient_time_end * 3600} ${standardUnit.min}`,
        weatherTemperature: `${tempConversion(value_weather_transient_temp_end, 1, currUnit,true)} ${standardUnit.temp}`,
        weatherSolarFlux:`${fluxConversion(value_weather_transient_flux_end, 1, currUnit,true)} ${standardUnit.flux}`,
        weatherPressure: `${pressureConversion(value_weather_transient_pressure_end_decimal, 1, currUnit,true)} ${standardUnit.pressure}`,
        weatherRelativeHumidity: value_weather_transient_relative_humidity_end,
        weatherWindSpeed: `${mperSecConversion(value_weather_transient_wind_speed_end,  1, currUnit,true)} ${standardUnit.mperSec}`,
        weatherSkyEmissivity: value_weather_transient_sky_emissivity_end
      }
      const updatedDynamicRow= JSON.parse(JSON.stringify(weatherStartRows)).map(x=>{
        x.weatherTripTime = `${x.weatherTripTime * 3600} ${standardUnit.min}`;
       x.weatherTemperature= `${tempConversion(x.weatherTemperature, 1, currUnit,true)} ${standardUnit.temp}`;
        x.weatherSolarFlux=`${fluxConversion(x.weatherSolarFlux, 1, currUnit,true)} ${standardUnit.flux}`;
        x.weatherPressure= `${pressureConversion(x.weatherPressure, 1, currUnit,true)} ${standardUnit.pressure}`;
        x.weatherRelativeHumidity= x.weatherRelativeHumidity;
        x.weatherWindSpeed= `${mperSecConversion(x.weatherWindSpeed,  1, currUnit,true)} ${standardUnit.mperSec}`;
        x.weatherSkyEmissivit= x.weatherSkyEmissivit;
       return x;
      });
      let weatherResultObj = [startWeather, ...updatedDynamicRow,endWeather];
      return weatherResultObj;
  }

  // const handleChangeWeatherTimeStart = (newValue) => {
  //   setWeatherTransientTimeStart(newValue);
  // };
  const handleChangeWeatherTransientTempStart = (newValue) => {
    setWeatherTransientTempStart(newValue);
  };
  const handleChangeWeatherTransientFluxStart = (newValue) => {
    setWeatherTransientFluxStart(newValue);
  };
  const handleChangeWeatherTransientPressureStart = (newValue) => {
    setWeatherTransientPressureStart(newValue);
    setWeatherTransientPressureStartDecimal(newValue)
  };
  const handleChangeWeatherTransientMassFractionStart = (newValue) => {
    setWeatherTransientMassFractionStart(newValue);
  };
  const handleChangeWeatherTransientWindSpeedStart = (newValue) => {
    setWeatherTransientWindSpeedStart(newValue);
  };
  const handleChangeWeatherTransientSkyEmissivityStart= (newValue) => {
    setWeatherTransientSkyEmissivityStart(newValue);
  };

  // const handleChangeWeatherTimeEnd = (newValue) => {
  //   setWeatherTransientTimeEnd(newValue);
  // };
  const handleChangeWeatherTransientTempEnd = (newValue) => {
    setWeatherTransientTempEnd(newValue);
  };
  const handleChangeWeatherTransientFluxEnd = (newValue) => {
    setWeatherTransientFluxEnd(newValue);
  };
  const handleChangeWeatherTransientPressureEnd = (newValue) => {
    setWeatherTransientPressureEnd(newValue);
    setWeatherTransientPressureEndDecimal(newValue);
  };
  const handleChangeWeatherTransientMassFractionEnd = (newValue) => {
    setWeatherTransientMassFractionEnd(newValue);
  };
  const handleChangeWeatherTransientWindSpeedEnd = (newValue) => {
    setWeatherTransientWindSpeedEnd(newValue);
  };
  const handleChangeWeatherTransientSkyEmissivityEnd= (newValue) => {
    setWeatherTransientSkyEmissivityEnd(newValue);
  };
  const showModal = () => {
    setVisibleModal(true);
  };

  const handleOk = () => {
    const combinedDateTime = moment()
    // .month(selectedMonth)
    // .date(selectedDate)
    //   .set({
    //     hour: selectedTime.hour(),
    //     minute: selectedTime.minute(),
    //   })
    .month(selectedMonth)
    .date(selectedDate)
    .hour(selectedPeriod === 'AM' ? selectedHour % 12 : (selectedHour % 12) + 12)
    .minute(selectedMinute)
      .format('MMMM D, h A');
    setInputValue(combinedDateTime);
    setVisibleModal(false);
  };

  const handleCancel = () => {
    setVisibleModal(false);
  };
  const handleMonthChange = (month) => {
    setSelectedMonth(month);
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleTimeChange = (time) => {
    // console.log('after time', time);
    if (time) {
      setSelectedTime(time);
    }
  };
  const handleHourChange = (hour) => {
    setSelectedHour(hour);
  };

  const handlePeriodChange = (period) => {
    setSelectedPeriod(period);
  };
  const handleToday = () => {
    const now = moment();
    setSelectedMonth(now.month());
    setSelectedDate(now.date());
    setSelectedHour(now.hour() % 12 || 12);
    setSelectedMinute(now.minute());
    setSelectedPeriod(now.format('A'));
    updateDates(now.month());

  }
  const updateDates = (month) => {
    let daysInMonth;
    if (month === 1) { // February
      daysInMonth = 28;
    } else if ([3, 5, 8, 10].includes(month)) { // April, June, September, November
      daysInMonth = 30;
    } else { // January, March, May, July, August, October, December
      daysInMonth = 31;
    }
    setDates(Array.from({ length: daysInMonth }, (_, i) => i + 1));
    if (selectedDate > daysInMonth) {
      setSelectedDate(daysInMonth);
    }
  };

  useEffect(() => {
    updateDates(selectedMonth);
  }, [selectedMonth]);

  const months = moment.months();
  const hours = Array.from({ length: 12 }, (_, i) => i + 1);
  const periods = ['AM', 'PM'];

  // const fieldInfo = [
  //   {
  //     name: 'vehicle_type',
  //     label: 'Vehicle Type',
  //     tooltip:'Choose a Vehicle Type from Two Available Options: Truck and Trailer'
  //   },
  //   {
  //     name: 'compartment',
  //     label: 'Compartment',
  //     tooltip:'Number of Zone in the Box'
  //   },
  //   {
  //     name: 'Model_sel',
  //     label: 'Model Selection',
  //     tooltip:'Choose a Refrigerantion Unit'
  //   },
  //   {
  //     name: 'length',
  //     label: 'Length',
  //     tooltip:'Specify Box Length'
  //   },    
  //   {
  //     name: 'width',
  //     label: 'Width',
  //     tooltip:'Specify Box Width'
  //   },    
  //   {
  //     name: 'height',
  //     label: 'Height',
  //     tooltip:'Specify Box Height'
  //   },
  //   {
  //     name: 'specify_insu',
  //     label: 'Wall UA Calculation Method',
  //     tooltip: 'Method to Calculate Wall Properties',
  //     children: [
  //       {
  //         name: 'overall_ua',
  //         label: 'UA Factor',
  //         tooltip: 'Measured Overall UA',
  //       },
  //       {
  //         name: 'Insulation Material',
  //         label: 'Insulation Material',
  //         tooltip: 'Specifify Insulation Material and thickness',
  //         children: [
  //           {
  //             name: 'material',
  //             label: 'Material',
  //             tooltip: 'Insulation Material'
  //           },
  //           {
  //             name: 'thickness',
  //             label: 'Thickness',
  //             tooltip: 'Insulation Thickness'
  //           }
  //         ]
  //       },
  //       {
  //         name: 'u_value',
  //         label: 'U Value',
  //         tooltip: 'Wall U Value'
  //       }
  //     ]
  //   },
  //   {
  //     name: 'age_of_body',
  //     label: 'Age Of Body',
  //     tooltip:'Box Age in Years'
  //   },
  //   {
  //     name: 'age_of_body',
  //     label: 'Age Of Body',
  //     tooltip:'Box Age in Years'
  //   },
  //   {
  //     name: 'door_type',
  //     label: 'Door Type',
  //     tooltip: 'There are two options in this field: Swing Type and Roll Up. With the different choice, the UA factor of the door is different. Therefore, the corrected UA Factor is calculated and shown at the bottom of this category.',
  //     children: [
  //       {
  //         name: 'swing_type',
  //         label: 'Swing Type',
  //         tooltip: 'Swing Type: This is a type of door that swings open.',
  //         children: [
  //           {
  //             name: 'hinge_type',
  //             label: 'Hinge Type',
  //             tooltip: 'Hinge Type: This specifies the type of hinge used in the swing door.'
  //           }
  //         ]
  //       },
  //       {
  //         name: 'roll_up',
  //         label: 'Roll Up',
  //         tooltip: 'Roll Up: This is a type of door that rolls up.'
  //       }
  //     ]
  //   },
  //   {
  //     name: 'solar_absorptivity',
  //     label: 'Solar Absorptivity',
  //     tooltip:'Shortwave Absorptivity of Opaque Surfaces'
  //   },
  //   {
  //     name: 'emissivity',
  //     label: 'Emissivity',
  //     tooltip:'Longwave Emissivity for all surfaces'
  //   },
  //   {
  //     name: 'infiltration_flowrate',
  //     label: 'Infiltration Flowrate',
  //     tooltip:'Infiltration flowrate (in CFH) at 0.5 inch of water'
  //   },
  //   {
  //     name: 'box_thermal_mass',
  //     label: 'Box Thermal Mass',
  //     tooltip:'Thermal Mass of the Box'
  //   },
  //   {
  //     name: 'emissivity',
  //     label: 'Emissivity',
  //     tooltip:'Box Age in Years'
  //   },
  //   {
  //     name: 'emissivity',
  //     label: 'Emissivity',
  //     tooltip:'Box Age in Years'
  //   },
  //   {
  //     name: 'emissivity',
  //     label: 'Emissivity',
  //     tooltip:'Box Age in Years'
  //   },
  //   // Add more field information here
  // ];
  const showInfoModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseInfoModal = () => {
    setIsModalVisible(false);
  };  


  return (
    <div className="ecotrip">
      <Sidebar>
        <h1>
        ECoTRIP Form{" "}
        </h1>
            <div className='fcmtContainer page' ref={resultRef}  >
              <Form
                layout="vertical"
                form={form}
                onFinish={handleFormSubmit}
                initialValues={initialValues}
              >
                <div className="toggleUnit" style={{
                  display: "flex",
                  padding: "10px",
                  gap: "1rem",
                  alignItems: "center",
                }}>
                  <label style={{ fontWeight: "600" }}>Unit: </label>
                  <Switch checkedChildren="SI" unCheckedChildren="IP" defaultChecked onChange={handleChangeUnit} />
                  <label style={{ fontWeight: "600" }}>Info: </label>
                  <InfoCircleOutlined style={{color:'#a079e4'}} onClick={showInfoModal}/>
                </div>
                <Card className="custom-card">
                  <Row span={24}>
                    <Col span={7} className="card-title">
                      <h3>
                      Vehicle Type: Please specify vehicle information
                      </h3>
                    </Col>
                    <Col span={17} style={{ padding: '1rem' }}>
                      <Row>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="vehicle_type" label="Vehicle Type" tooltip={fieldInfo[0]?.tooltip}>
                            <Select placeholder="Vehicle Type"  value={value_vehicleType} showSearch onChange={handleVehicleType}>
                              <Option value="Truck">Truck</Option>
                              <Option value="Trailer">Trailer</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="compartment" label="Compartment" tooltip={fieldInfo[0]?.children[0]?.tooltip}>
                            <Select placeholder="Compartment" value={Value_selectedZone} showSearch onChange={handleZoneChange}>
                              <Option value="One Zone">One Zone</Option>
                              { value_vehicleType == 'Truck' && <>
                              <Option value="Two Zone">Two Zone</Option>

                              {/* <Option value="Three Zone">Three Zone</Option> */}
                              </>
                              }
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="Model_sel" label="Model Selection"  tooltip={fieldInfo[0]?.children[1]?.tooltip}>
                            <Select placeholder="Model Selection" showSearch onChange={handleModelSelect}>
                            {value_vehicleType == 'Truck' ? Value_selectedZone == 'Two Zone' ? <Option value="T1200R_S3_S3">T1200R_S3_S3</Option> : (
                              <>
                              <Option value="T_1000M">T_1000M</Option>
                              <Option value="T_1000R">T_1000R</Option>
                              <Option value="T_1080R">T_1080R</Option>
                              <Option value="T_1080S">T_1080S</Option>
                              <Option value="T_1090">T_1090</Option>
                              <Option value="T_1090_MAX">T_1090_MAX</Option>
                              <Option value="T_1200R">T_1200R</Option>
                              <Option value="T_580R">T_580R</Option>
                              <Option value="T_590">T_590</Option>
                              <Option value="T_600R">T_600R</Option>
                              <Option value="T_680R">T_680R</Option>
                              <Option value="T_680S">T_680S</Option>
                              <Option value="T_690">T_690</Option>
                              <Option value="T_690_MAX">T_690_MAX</Option>
                              <Option value="T_800M">T_800M</Option>
                              <Option value="T_800R">T_800R</Option>
                              <Option value="T_880R">T_880R</Option>
                              <Option value="T_880S">T_880S</Option>
                              <Option value="T_890">T_890</Option>
                              </>
                            ) : (
                              <>
                              <Option value="Precedent_C600">Precedent_C600</Option>
                              <Option value="Precedent_S600">Precedent_S600</Option>
                              <Option value="SB230_Base">SB230_Base</Option>
                              <Option value="SB230_ETV">SB230_ETV</Option>
                              <Option value="SB330">SB330</Option>
                              <Option value="SLX_200">SLX_200</Option>
                              <Option value="SLX_300">SLX_300</Option>
                              <Option value="SLX_400">SLX_400</Option>
                              </>
                            )}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card>
                <Card className="custom-card">
                  <Row span={24}>
                    <Col span={7} className="card-title">
                      <h3>
                      Outer Box Dimensions - Please specify your outer box dimensions
                      </h3>
                    </Col>
                    <Col span={17} style={{ padding: '1rem' }}>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="length" label="Length" tooltip={fieldInfo[1]?.children[0]?.tooltip}>
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber  value={value} onChange={handleChange} />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.feet}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="width" label="Width" tooltip={fieldInfo[1]?.children[1]?.tooltip}>
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber  value={value_width} onChange={handleChangeWidth} />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.feet}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="height" label="Height" tooltip={fieldInfo[1]?.children[2]?.tooltip}>
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber  value={value_height} onChange={handleChangeHeight} />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.feet}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card>
                <Card className="custom-card">
                  <Row span={24}>
                    <Col span={7} className="card-title">
                      <h3>
                        Vehicle Insulation - Please specify your vehicle insulation
                      </h3>
                    </Col>
                    <Col span={17} style={{ padding: '1rem' }}>
                      <Row>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="specify_insu"
                            label="Wall UA Calculation Method"
                            tooltip={fieldInfo[2]?.children[0]?.tooltip}
                          >
                            <Select placeholder="Wall UA Calculation Method" onChange={handleChangeMaterial} showSearch>
                              <Option value="UA Factor">
                                UA Factor
                              </Option>
                              <Option value="Insulation Material">
                                Insulation Material
                              </Option>
                              <Option value="U Value">
                                U Value
                              </Option>
                              {/* <Option value="Test Material">
                          Test Material
                        </Option> */}
                            </Select>
                          </Form.Item>
                        </Col>
                        {/* <Col span={1} />
                  <Col span={23}>
                    {value_material && value_material === 'Insulation Material' && (
                      <Form.Item form={Form} name="ageofbody" label="Age of Body">
                        <Select placeholder="Age of Body" showSearch>
                          <Option value="0 Years">0 Years</Option>
                        </Select>
                      </Form.Item>
                    )}
                    {value_material !== 'Insulation Material' && (
                      <Form.Item form={Form} name="age_corrected_ua_factor" label="Age Corrected UA Factor">
                        <div style={{ display: "flex" }} className = "InputContainer">
                          <div>
                            <InputNumber
                              
                              value={value_age_corrected_ua_factor}
                              onChange={handleChangeAgeCorrectedUAFactor}
                            />
                          </div>
                          <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.ACUF}</div>
                        </div>
                      </Form.Item>
                    )}

                  </Col> */}
                      </Row>
                    
                {value_material && value_material === 'Insulation Material' && (     
                  <>
                  <Row span={24} style={{color:"#655bb4"}}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item layout='horizontal' form={Form} name="material_sides" style={{textAlign:"center" ,marginBottom:"10px", color:"#655bb4"}} >
                    
                            <Radio.Group onChange={handleChangeMaterialSides} value={value_material_sides} defaultValue={value_material_sides} style={{color:"#655bb4"}}>
                              <Radio value="equal" style={{color:"#655bb4"}}>Equal Sides</Radio>
                              <Radio value="variable" style={{color:"#655bb4"}}>Variable Sides</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                  </Row>
                  <Row span={24} style={{marginBottom:"10px", color:"#655bb4"}}>
                        <Col span={1} />
                        <Col span={7}>
                          <div>Location</div>
                        </Col>
                        <Col span={8} style={{textAlign:'center'}}>
                        <Form.Item className="onlyForLabel matLabel" form={form} label='Material'  tooltip={fieldInfo[2]?.children[0]?.children[1]?.children[0]?.tooltip}>
                        </Form.Item>
                        </Col>
                        <Col span={2} />
                        <Col span={6}>
                          {/* <div>Thickness</div> */}
                          <Form.Item className="onlyForLabel" form={form} label='Thickness'  tooltip={fieldInfo[2]?.children[0]?.children[1]?.children[1]?.tooltip}>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                      <Col span={1} />
                      <Col span={7} style={{color:"#655bb4"}}>
                          <div>Roof</div>
                        </Col>
                      <Col span={8}>
                       <Form.Item form={Form} name="roof">
                          <Select placeholder="Roof" showSearch value={value_roofselect} onChange={handleChangeRoofSelect}>
                            <Option value="Polyurethane">Polyurethane</Option>
                            <Option value="Styrofoam">Styrofoam</Option>
                            <Option value="Fiberglass">Fiberglass</Option>
                            <Option value="Plywood">Plywood</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={2} />
                      <Col span={6}>
                        <Form.Item form={Form} name="roof_size">
                          <div style={{ display: "flex" }} className = "InputContainer">
                            <div>
                              <InputNumber
                                
                                value={value_roofsize}
                                onChange={handleChangeRoofSize}
                              />
                            </div>
                            <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.inch}</div>
                          </div>
                        </Form.Item>
                      </Col>
                    </Row>
                      <Row span={24}>
                      <Col span={1} />
                      <Col span={7} style={{color:"#655bb4"}}>
                          <div>Floor</div>
                        </Col>
                      <Col span={8}>
                       <Form.Item form={Form} name="floor">
                          <Select placeholder="Floor" disabled={isDisabled} showSearch value={value_floorselect} onChange={handleChangeFloorSelect}>
                            <Option value="Polyurethane">Polyurethane</Option>
                            <Option value="Styrofoam">Styrofoam</Option>
                            <Option value="Fiberglass">Fiberglass</Option>
                            <Option value="Plywood">Plywood</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={2} />
                      <Col span={6}>
                        <Form.Item form={Form} name="floor_size">
                          <div style={{ display: "flex" }} className = "InputContainer">
                            <div>
                              <InputNumber
                                disabled={isDisabled}
                                value={value_floorsize}
                                onChange={handleChangeFloorSize}
                              />
                            </div>
                            <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.inch}</div>
                          </div>
                        </Form.Item>
                      </Col>
                    </Row>
                      <Row span={24}>
                      <Col span={1} />
                      <Col span={7} style={{color:"#655bb4"}}>
                          <div>Front</div>
                        </Col>
                      <Col span={8}>
                       <Form.Item form={Form} name="front">
                          <Select placeholder="Front" disabled={isDisabled} showSearch value={value_frontselect} onChange={handleChangeFrontSelect}>
                            <Option value="Polyurethane">Polyurethane</Option>
                            <Option value="Styrofoam">Styrofoam</Option>
                            <Option value="Fiberglass">Fiberglass</Option>
                            <Option value="Plywood">Plywood</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={2} />
                      <Col span={6}>
                        <Form.Item form={Form} name="front_size">
                          <div style={{ display: "flex" }} className = "InputContainer">
                            <div>
                              <InputNumber
                                disabled={isDisabled}
                                value={value_frontsize}
                                onChange={handleChangeFrontSize}
                              />
                            </div>
                            <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.inch}</div>
                          </div>
                        </Form.Item>
                      </Col>
                    </Row>
                      <Row span={24}>
                      <Col span={1} />
                      <Col span={7} style={{color:"#655bb4"}}>
                          <div>Rear</div>
                        </Col>
                      <Col span={8}>
                       <Form.Item form={Form} name="rear">
                          <Select placeholder="Rear" disabled={isDisabled} showSearch value={value_rearselect} onChange={handleChangeRearSelect}>
                            <Option value="Polyurethane">Polyurethane</Option>
                            <Option value="Styrofoam">Styrofoam</Option>
                            <Option value="Fiberglass">Fiberglass</Option>
                            <Option value="Plywood">Plywood</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={2} />
                      <Col span={6}>
                        <Form.Item form={Form} name="rear_size">
                          <div style={{ display: "flex" }} className = "InputContainer">
                            <div>
                              <InputNumber
                                disabled={isDisabled}
                                value={value_rearsize}
                                onChange={handleChangeRearSize}
                              />
                            </div>
                            <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.inch}</div>
                          </div>
                        </Form.Item>
                      </Col>
                    </Row>
                      <Row span={24}>
                      <Col span={1} />
                      <Col span={7} style={{color:"#655bb4"}}>
                          <div>Sides</div>
                        </Col>
                      <Col span={8}>
                       <Form.Item form={Form} name="sides">
                          <Select placeholder="Sides" disabled={isDisabled} showSearch value={value_sidesselect} onChange={handleChangeSidesSelect}>
                            <Option value="Polyurethane">Polyurethane</Option>
                            <Option value="Styrofoam">Styrofoam</Option>
                            <Option value="Fiberglass">Fiberglass</Option>
                            <Option value="Plywood">Plywood</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={2} />
                      <Col span={6}>
                        <Form.Item form={Form} name="sides_size">
                          <div style={{ display: "flex" }} className = "InputContainer">
                            <div>
                              <InputNumber
                                disabled={isDisabled} 
                                value={value_sidessize}
                                onChange={handleChangeSidesSize}
                              />
                            </div>
                            <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.inch}</div>
                          </div>
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}     
                {value_material && (value_material !== 'Insulation Material' && value_material !== 'U Value') && (    
         
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="overall_ua"
                            label="UA Factor"
                            tooltip={fieldInfo[2]?.children[0]?.children[0]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_overall_ua.toFixed(2)}
                                  onChange={handleChangeOverallUA}
                                  disabled = {(value_material && value_material == 'Insulation Material') ? true : false}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.btuFh}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>

                )}
                {value_material && (value_material !== 'Insulation Material' && value_material !== 'UA Factor') && (    
         
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="u_value"
                            label="U Value"
                            tooltip={fieldInfo[2]?.children[0]?.children[2]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  value={value_uValue?.toFixed(2)}
                                  onChange={handleChangeUValue}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.btuVal}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>

                )}
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="age_of_body"
                            label="Age Of Body"
                            tooltip={fieldInfo[2]?.children[1]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_age_of_body}
                                  onChange={handleChangeAgeOfBody}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.year}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="door_type"
                            label="Door Type"
                            tooltip={fieldInfo[2]?.children[2]?.tooltip}
                            >
                            
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                              <Select placeholder="Door Type" value={value_door_type} onChange={handleChangeDoorType} showSearch>
                              <Option value="Swing Type">
                              Swing Type
                              </Option>
                              <Option value="Roll Up">
                              Roll Up
                              </Option>
                            </Select>
                            </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                            </div>
                            {/* </div> */}
                              <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                            {/* </div> */}
                          </Form.Item>
                        </Col>
                      </Row>

                      {/* {value_material && value_material !== 'Insulation Material' && (   */}
           
                      {/* )} */}
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="solar_absorptivity"
                            label="Solar Absorptivity"
                            tooltip={fieldInfo[2]?.children[3]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_solar_absorptivity}
                                  onChange={handleChangeSolarAbsorptivity}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="emissivity"
                            label="Emissivity"
                            tooltip={fieldInfo[2]?.children[4]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_emissivity}
                                  onChange={handleChangeEmissivity}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{''}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="infiltration_flowrate"
                            label="Infiltration Flowrate"
                            tooltip={fieldInfo[2]?.children[5]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_infiltration_flowrate}
                                  onChange={handleChangeInfiltrationFlowrate}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.cfh}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>

                        <Col span={24} />
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="age_corrected_ua_factor" label="Age Corrected UA Factor" >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber

                                  value={(value_age_corrected_ua_factor + value_ua_door).toFixed(2)}

                                  disabled = {true}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.btuFh}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={24} />
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="box_thermal_mass" label="Box Thermal Mass" tooltip={fieldInfo[2]?.children[6]?.tooltip}>
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_box_thermal_mass.toFixed(2)}
                                  onChange={handleChangeBoxThermalMass}
                                  disabled = {true}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.BTM}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
         
                    </Col>
                  </Row>
                </Card>
                {(Value_selectedZone == 'Two Zone' || Value_selectedZone == 'Three Zone') && (
                  <Card className="custom-card">
                    <Row span={24}>
                      <Col span={7} className="card-title">
                        <h3>Partition </h3>
                      </Col>
                      <Col span={17} style={{ padding: '1rem' }}>
                        {Value_selectedZone == 'Two Zone' && (
                          <Row>
                            <Col span={1} />
                            <Col span={23}>
                              <Form.Item
                                form={Form}
                                name="partition"
                                label="Partition"
                                tooltip="Location of partition from the front of box"
                              >

                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <InputNumber
                                      
                                      value={value_partion}
                                      onChange={handleChangePartition}
                                    />
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.feet}</div>
                                </div>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                        {Value_selectedZone == 'Three Zone' && (
                          <>
                            <Row>
                              <Col span={1} />
                              <Col span={23}>
                                <Form.Item
                                  form={Form}
                                  name="partition_1_2"
                                  label="Partition 1-2"
                                  tooltip='Location of partition between zones 1 and 2'
                                >

                                  <div style={{ display: "flex" }} className="InputContainer">
                                    <div>
                                      <InputNumber
                                        
                                        value={value_partion_1_2}
                                        onChange={handleChangePartition12}
                                      />
                                    </div>
                                    <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.feet}</div>
                                  </div>

                                </Form.Item>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={1} />
                              <Col span={23}>
                                <Form.Item
                                  form={Form}
                                  name="partition_2_3"
                                  label="Partition 2-3"
                                  tooltip='Location of partition between zones 2 and 3'
                                >

                                  <div style={{ display: "flex" }} className="InputContainer">
                                    <div>
                                      <InputNumber
                                        
                                        value={value_partion_2_3}
                                        onChange={handleChangePartition23}
                                      />
                                    </div>
                                    <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.feet}</div>
                                  </div>

                                </Form.Item>
                              </Col>
                            </Row>
                          </>

                        )}

                        <>
                          <Row>

                            <Col span={1} />
                            <Col span={23}>
                              <Form.Item
                                form={Form}
                                name="ua_partition"
                                label="UA Partition"
                              >

                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <InputNumber
                                      
                                      value={value_ua_partion}
                                      onChange={handleChangeUAPartition}
                                    />
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.btuFh}</div>
                                </div>
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={1} />
                            <Col span={23}>
                              <Form.Item
                                form={Form}
                                name="c_partition"
                                label="C Partition"
                              >

                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <InputNumber
                                      
                                      value={value_C_partion}
                                      onChange={handleChangeCPartition}
                                    />
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.BTM}</div>
                                </div>
                              </Form.Item>
                            </Col>
                          </Row>
                        </>
                      </Col>
                    </Row>
                  </Card>
                )}

                <Card className="custom-card">
                  <Row span={24}>
                    <Col span={7} className="card-title">
                      <h3>Product - Please specify your typical product</h3>
                    </Col>
                    {Value_selectedZone === 'Two Zone' && (
                      <>
                      <Col span={17} style={{ padding: '1rem' }}>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={11}>
                        <h5 className="card-title" style={{borderRadius:"8px"}}>Zone 1</h5>
                        </Col>
                        <Col span={1} />
                        <Col span={11}>
                        <h5 className="card-title" style={{borderRadius:"8px"}}>Zone 2</h5>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={11}>
                          <Form.Item layout='horizontal' form={Form} name="include_product_zOne" label="Include Product">
                            <Radio.Group onChange={handleChangeIncludeProductZone} value={value_include_product_zone} defaultValue={value_include_product_zone}>
                              <Radio value="Yes">Yes</Radio>
                              <Radio value="No">No</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                        <Col span={1} />
                        <Col span={11}>
                          <Form.Item layout='horizontal' form={Form} name="include_product_zTwo" label="Include Product">
                            <Radio.Group onChange={handleChangeIncludeProductZtwo} value={value_include_product_ztwo} defaultValue={value_include_product_ztwo}>
                              <Radio value="Yes">Yes</Radio>
                              <Radio value="No">No</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                      </Row>
                      {(value_include_product_zone === 'Yes' || value_include_product_ztwo === 'Yes') && (
                        <>
                        <Row>
                        <Col span={1} />
                        {value_include_product_zone === 'Yes' ? (
                        <Col span={11}>
                          <Form.Item form={Form} name="product_load_height_zone" label="Product Load Height" tooltip={fieldInfo[3]?.children[0]?.tooltip}>
                            <Select value={value_product_load_height_zone} showSearch onChange={handleProductloadheightZone}>
                              <Option value="Full Height">Full Height</Option>
                              <Option value="Half Height">Half Height</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        ):(
                        <Col span={11}>
                        </Col>
                        )}
                        <Col span={1} />
                        {value_include_product_ztwo === 'Yes' && (
                        <Col span={11}>
                          <Form.Item form={Form} name="product_load_height_ztwo" label="Product Load Height" tooltip={fieldInfo[3]?.children[0]?.tooltip}>
                            <Select value={value_product_load_height_ztwo} showSearch onChange={handleProductloadheightZtwo}>
                              <Option value="Full Height">Full Height</Option>
                              <Option value="Half Height">Half Height</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        )}
                        </Row>
                          <Row span={24}>
                            <Col span={1} />
                            {value_include_product_zone === 'Yes' ? (
                            <Col span={11}>
                              <Form.Item form={Form} name="prod_weight_zone" label="Product Weight" tooltip={fieldInfo[3]?.children[1]?.tooltip}>
                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <InputNumber  value={value_prod_weight_zone} onChange={handleChangeProdWeightZone}/>
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.lb}</div>
                                </div>
                              </Form.Item>
                            </Col>
                            ):(
                        <Col span={11}>
                        </Col>
                        )}
                            <Col span={1} />
                            {value_include_product_ztwo === 'Yes' && (
                            <Col span={11}>
                              <Form.Item form={Form} name="prod_weight_ztwo" label="Product Weight" tooltip={fieldInfo[3]?.children[1]?.tooltip}>
                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <InputNumber  value={value_prod_weight_ztwo} onChange={handleChangeProdWeightZtwo}/>
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.lb}</div>
                                </div>
                              </Form.Item>
                            </Col>
                            )}
                          </Row>
                          <Row span={24}>
                            <Col span={1} />
                            {value_include_product_zone === 'Yes' ? (
                            <Col span={11}>
                              <Form.Item form={Form} name="products_zone" label="Product" tooltip={fieldInfo[3]?.children[2]?.tooltip}>
                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <Select value={value_product_zone} showSearch onChange={handleChangeproductZone}>
                                    {products && products.map((x,i)=>(
                                    <Option key={i} value={x.Product}>{x.Product}</Option>
                                    ))

                                    }
                                    
                                  </Select>
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                                </div>
                              </Form.Item>
                            </Col>
                          ):(
                        <Col span={11}>
                        </Col>
                        )}
                            <Col span={1} />
                            {value_include_product_ztwo === 'Yes' && (
                            <Col span={11}>
                              <Form.Item form={Form} name="products_ztwo" label="Product" tooltip={fieldInfo[3]?.children[2]?.tooltip}>
                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <Select value={value_product_ztwo} showSearch onChange={handleChangeproductZtwo}>
                                    {products && products.map((x,i)=>(
                                    <Option key={i} value={x.Product}>{x.Product}</Option>
                                    ))
                                    }
                                    
                                  </Select>
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                                </div>
                              </Form.Item>
                            </Col>
                            )}
                          </Row>
                        </>
                      )}
                    </Col>
                        
                      </>

                    )}
                    {Value_selectedZone === 'One Zone' && (
                      <>
                      <Col span={17} style={{ padding: '1rem' }}>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item layout='horizontal' form={Form} name="include_product" label="Include Product">
                            {/* <Select placeholder="Product Type and Recom'd Set Point" value={value_include_product} showSearch onChange={handleChangeIncludeProduct}>
                          <Option value="Yes">Yes</Option>
                          <Option value="No">No</Option>
                        </Select> */}
                            <Radio.Group onChange={handleChangeIncludeProduct} value={value_include_product} defaultValue={value_include_product}>
                              <Radio value="Yes">Yes</Radio>
                              <Radio value="No">No</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                      </Row>
                      {value_include_product === 'Yes' && (
                        <>
                        <Row>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="product_load_height" label="Product Load Height" tooltip={fieldInfo[3]?.children[0]?.tooltip}>
                            <Select value={value_product_load_height} showSearch onChange={handleProductloadheight}>
                              <Option value="Full Height">Full Height</Option>
                              <Option value="Half Height">Half Height</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                          <Row span={24}>
                            <Col span={1} />
                            <Col span={23}>
                              <Form.Item form={Form} name="prod_weight" label="Product Weight" tooltip={fieldInfo[3]?.children[1]?.tooltip}>
                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <InputNumber  value={value_prod_weight} onChange={handleChangeProdWeight}/>
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.lb}</div>
                                </div>
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row span={24}>
                            <Col span={1} />
                            <Col span={23}>
                              <Form.Item form={Form} name="products" label="Product" tooltip={fieldInfo[3]?.children[2]?.tooltip}>
                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <Select value={value_product} showSearch onChange={handleChangeproduct}>
                                    {products && products.map((x,i)=>(
                                    <Option key={i} value={x.Product}>{x.Product}</Option>
                                    ))

                                    }
                                    
                                  </Select>
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                                </div>
                              </Form.Item>
                            </Col>
                          </Row>
                        </>
                      )}
                    </Col>

                      </>
                    )}
       
                  </Row>
                </Card>
                <Card className="custom-card">
                  <Row span={24}>
                    <Col span={7} className="card-title">
                      <h3>System Control - Please specify your system controller</h3>
                    </Col>
                    <Col span={17} style={{ padding: '1rem' }}>
                      <Row>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="algorithm" label="Algorithm" tooltip={fieldInfo[4]?.children[0]?.tooltip}>
                            <Select placeholder="Running Mode" showSearch>
                              <Option value="Cycle Sentry">Cycle Sentry</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={1} />
                        <Col span={23}>
                          <div className="checkbox-group">
          
                         <Form.Item
                            form={Form}
                            name="eco_pulldown"
                            
                          >
                        <Checkbox  checked={value_eco_pull_down} onChange={handleChangeEcopullDown}>Eco Pulldown</Checkbox>
                        </Form.Item>
                         <Form.Item
                            form={Form}
                            name="fuel_saver_II"
                          >
                        <Checkbox  checked={value_fuel_saver} onChange={handleChangeFuelSaver}>Fuel Saver II</Checkbox>
                        </Form.Item>
                        </div>
                        </Col>
                      </Row>
                      { Value_selectedZone =='Two Zone' && (
                        <>
                        {/* <Row span={24}>
                        <Col span={17} style={{ padding: '1rem' }}> */}
                            <Row span={24}>
                              <Col span={1} />
                              <Col span={11}>
                              <h5 className="card-title" style={{borderRadius:"8px"}}>Zone 1</h5>
                              </Col>
                              <Col span={1} />
                              <Col span={11}>
                              <h5 className="card-title" style={{borderRadius:"8px"}}>Zone 2</h5>
                              </Col>
                          </Row>

                      <Row span={24}>
                        <Col span={1} />
                        <Col span={11}>
                          <Form.Item form={Form} name="temp_set_point_zone" label="Temperature Set Point" tooltip={fieldInfo[4]?.children[1]?.tooltip}>
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_temp_set_point_zone}
                                  onChange={handleChangeTempSetPointZone}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.temp}</div>
                            </div>
                          </Form.Item>
                        </Col>
                        <Col span={1} />
                        <Col span={11}>
                          <Form.Item form={Form} name="temp_set_point_ztwo" label="Temperature Set Point" tooltip={fieldInfo[4]?.children[1]?.tooltip}>
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_temp_set_point_ztwo}
                                  onChange={handleChangeTempSetPointZtwo}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.temp}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={11}>
                          <Form.Item
                            form={Form}
                            name="restart_band_for_cooling_zone"
                            label="Restart Band for cooling"
                            tooltip={fieldInfo[4]?.children[2]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_restart_band_for_cooling_zone}
                                  onChange={handleChangeRestartBandForCoolingZone}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.rank}</div>
                            </div>
                          </Form.Item>
                        </Col>
                        <Col span={1} />
                        <Col span={11}>
                          <Form.Item
                            form={Form}
                            name="restart_band_for_cooling_ztwo"
                            label="Restart Band for cooling"
                            tooltip={fieldInfo[4]?.children[2]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_restart_band_for_cooling_ztwo}
                                  onChange={handleChangeRestartBandForCoolingZtwo}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.rank}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={11}>
                          <Form.Item
                            form={Form}
                            name="restart_band_for_heating_zone"
                            label="Restart Band for heating"
                            tooltip={fieldInfo[4]?.children[3]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_restart_band_for_heating_zone}
                                  onChange={handleChangeRestartBandForHeatingZone}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.rank}</div>
                            </div>
                          </Form.Item>
                        </Col>
                        <Col span={1} />
                        <Col span={11}>
                          <Form.Item
                            form={Form}
                            name="restart_band_for_heating_ztwo"
                            label="Restart Band for heating"
                            tooltip={fieldInfo[4]?.children[3]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_restart_band_for_heating_ztwo}
                                  onChange={handleChangeRestartBandForHeatingZtwo}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.rank}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={11}>
                          <Form.Item
                            form={Form}
                            name="off_band_zone"
                            label="Off Band"
                            tooltip={fieldInfo[4]?.children[4]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_off_band_zone}
                                  onChange={handleChangeOffBandZone}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.rank}</div>
                            </div>
                          </Form.Item>
                        </Col>
                        <Col span={1} />
                        <Col span={11}>
                          <Form.Item
                            form={Form}
                            name="off_band_ztwo"
                            label="Off Band"
                            tooltip={fieldInfo[4]?.children[4]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_off_band_ztwo}
                                  onChange={handleChangeOffBandZtwo}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.rank}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={11}>
                          <Form.Item
                            form={Form}
                            name="low_high_switch_point_zone"
                            label="Low High Switch Point"
                            tooltip={fieldInfo[4]?.children[5]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_low_high_switch_point_zone}
                                  onChange={handleChangeLowHighSwitchPointZone}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.rank}</div>
                            </div>
                          </Form.Item>
                        </Col>
                        <Col span={1} />
                        <Col span={11}>
                          <Form.Item
                            form={Form}
                            name="low_high_switch_point_ztwo"
                            label="Low High Switch Point"
                            tooltip={fieldInfo[4]?.children[5]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_low_high_switch_point_ztwo}
                                  onChange={handleChangeLowHighSwitchPointZtwo}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.rank}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>


                      </>
                      )}
                      { Value_selectedZone =='One Zone' && (
                        <>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="temp_set_point" label="Temperature Set Point" tooltip={fieldInfo[4]?.children[1]?.tooltip}>
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_temp_set_point}
                                  onChange={handleChangeTempSetPoint}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.temp}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="restart_band_for_cooling"
                            label="Restart Band for cooling"
                            tooltip={fieldInfo[4]?.children[2]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_restart_band_for_cooling}
                                  onChange={handleChangeRestartBandForCooling}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.rank}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="restart_band_for_heating"
                            label="Restart Band for heating"
                            tooltip={fieldInfo[4]?.children[3]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_restart_band_for_heating}
                                  onChange={handleChangeRestartBandForHeating}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.rank}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          {/* <Form.Item
                      form={Form}
                      name="off_band"
                      label="Heat Null Restart Temp."
                    >
                      <div style={{ display: "flex" }} className="InputContainer">
                        <div>
                          <InputNumber
                            
                            value={value_off_band}
                            onChange={handleChangeOffBand}
                          />
                        </div>
                        <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.temp}</div>
                      </div>
                    </Form.Item> */}
                          <Form.Item
                            form={Form}
                            name="off_band"
                            label="Off Band"
                            tooltip={fieldInfo[4]?.children[4]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_off_band}
                                  onChange={handleChangeOffBand}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.rank}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="low_high_switch_point"
                            label="Low High Switch Point"
                            tooltip={fieldInfo[4]?.children[5]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_low_high_switch_point}
                                  onChange={handleChangeLowHighSwitchPoint}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.rank}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      </>
                      )}
                    
                          {/* <Form.Item form={Form} name="controller" label="Controller">
                      <Select placeholder="Controller" showSearch>
                        <Option value="Eco Pull Down">Eco Pull Down</Option>
                        <Option value="Fuel Saver 2">Fuel Saver 2</Option>
                      </Select>
                    </Form.Item> */}
                    <Row>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="hs_wait_time"
                            label="HS Wait Time"
                            tooltip={fieldInfo[4]?.children[6]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_hs_wait_time}
                                  onChange={handleChangeHSWaitTime}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.min}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      {/* <Row>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="precool_wait_time"
                            label="Precool Wait Time"
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_precool_wait_time}
                                  onChange={handleChangePrecoolWaitTime}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.min}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="preheat_wait_time"
                            label="Preheat Wait Time"
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_preheat_wait_time}
                                  onChange={handleChangePreheatWaitTime}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.min}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row> */}
                    </Col>
                  </Row>
                </Card>
                <Card className="custom-card">
                  <Row span={24}>
                    <Col span={7} className="card-title">
                      <h3>
                        Schedule - Please specify your Route
                      </h3>
                    </Col>
                    <Col span={17} style={{ padding: '1rem' }}>
                    <Row span={24}>
                          <Col span={1} />
                          <Col span={23}>
                            <Form.Item form={Form} name="route_time" label="Route Time" tooltip={fieldInfo[5]?.children[0]?.tooltip}>
                              <div style={{ display: "flex" }} className="InputContainer">
                                <div>
                                  <InputNumber
                                    
                                    value={value_route_time}
                                    onChange={handleChangeRouteTime}
                                    disabled = {value_route_profile =='Multi City Long Haul' ? true: false }
                                  />
                                </div>
                                <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.hr}</div>
                              </div>
                            </Form.Item>
                          </Col>
                        </Row>
                    <Row span={24}>
                          <Col span={1} />
                          <Col span={23}>
                            <Form.Item form={Form} name="precool_time" label="Precool Time" tooltip={fieldInfo[5]?.children[1]?.tooltip}>
                              <div style={{ display: "flex" }} className="InputContainer">
                                <div>
                                  <InputNumber
                                    
                                    value={value_precool_time}
                                    onChange={handleChangePrecoolTime}
                                  />
                                </div>
                                <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.hr}</div>
                              </div>
                            </Form.Item>
                          </Col>
                        </Row>
       
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          {/* <Form.Item
                          form={Form}
                          name="distribution_method"
                          label="Distribution Method"
                        >
                          <Select placeholder="Distribution Method" showSearch>
                            <Option value="Daily Distribution">Daily Distribution</Option>
                          </Select>
                        </Form.Item> */}
                          <Form.Item form={Form} name="route_profile" label="Route Profile" tooltip={fieldInfo[5]?.children[2]?.tooltip}>
                          <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                            <Select value={value_route_profile} showSearch onChange={handleChangeRouteProfile}>
                              <Option value="Daily Distribution">Daily Distribution</Option>
                              <Option value="Constant Profile">Constant</Option>
                              <Option value="Long Haul">Long Haul</Option>
                              <Option value="Transient Profile">Transient</Option>
                              <Option value="Multi City Long Haul">Multi City Long Haul</Option>
                            </Select>
                            </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      {/* {(value_route_profile == 'Daily Distribution' || value_route_profile == 'Long Haul') && (
          
                      )} */}
                      {(value_route_profile == 'Daily Distribution' || value_route_profile == 'Multi City Long Haul' || value_route_profile == 'Long Haul' || value_route_profile == 'Transient Profile') && (
                        <>
                          <Row span={24}>
                            <Col span={1} />
                            <Col span={23}>
                              <Form.Item form={Form} name="time_to_load_product" label="Time to Load Product" tooltip={fieldInfo[5]?.children[3]?.tooltip}>
                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <InputNumber
                                      
                                      value={value_time_to_load}
                                      onChange={handleChangeTimeToLoad}
                                    />
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.min}</div>
                                </div>

                              </Form.Item>
                            </Col>
                          </Row>
                        </>
                      )}
                      { value_route_profile == 'Multi City Long Haul' && (
                        <>
                        <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                        <Form.Item form={Form} name="total_stops_multi_city" label="Number of stops" >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  min ={0}
                                  value={value_total_stops_multi_city}
                                  onChange={handleChangeTotalStopsMultiCity}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                       <Col span={1} />
                        <Col span={7} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="route_multicity_time"
                            label='Time (hr)'
                            style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                          >
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                         <Col span={7} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="route_multicity_location"
                            label='Location'
                            style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                          >
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        <Col span={7} style={{color:"#655bb4"}}>
                        <Form.Item
                            // form={Form}
                            name="route_multiCity_vehicle_speed"
                            tooltip='Urban = 30 mph, Highway = 60 mph'
                            label='Vehicle Speed'
                            style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                          >
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                       <Col span={1} />
                        <Col span={7} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="route_multicity_time_start"
                          >
                          {/* <TimePicker value={start_route_time} defaultValue={start_route_time} format={'HH:mm'} disabled onChange={handleChangeStartTime}/> */}
                          <InputNumber defaultValue={start_route_multicity_time} style={{width:'100%'}} value={start_route_multicity_time} disabled onChange={handleChangeStartTimeMulticity}/>
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        <Col span={7} style={{color:"#655bb4"}}>
                        <Form.Item
                            // form={Form}
                            name="route_multicity_location_start"
                          >
                            {/* <Select value={start_route_multicity_location} showSearch onChange={handleChangeRouteMulticityStartLocation}>
                              <Option value="Urban">Urban</Option>
                              <Option value="Highway">Highway</Option>
                            </Select> */}
                            <Select value={start_route_multicity_location} style={{width:'100%'}} showSearch onChange={handleChangeRouteMulticityStartLocation}>
                            {currentLocation && currentLocation.map((loc,i)=>(
                                    <Option key={i} value={loc}>{loc}</Option>
                                    ))

                                    }
                            </Select>
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        <Col span={7} style={{color:"#655bb4"}}>
                        <Form.Item
                            // form={Form}
                            name="route_multicity_vehicle_speed_start"
                          >
                            <Select value={start_route_multicity_speed} showSearch onChange={handleChangeRouteMulticityStartSpeed}>
                              <Option value="Urban">Urban</Option>
                              <Option value="Highway">Highway</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row> 
                      {routeStartRows_multicity.map((row, index) => (
                        <>
        <Row key={index} style={{marginBottom:"24px"}}>
        <Col span={1} />
                        <Col span={7} style={{color:"#655bb4"}}>
            <InputNumber
              defaultValue={row.routeMulticityTime}
              min={0}
            max={end_route_multicity_time}
            style={{width:'100%'}}
              onChange={(time) => handleRowInputChangeMulticity(index, 'routeMulticityTime', time)}
            />
          </Col>
          <Col span={1} />
                        <Col span={7} style={{color:"#655bb4"}}>
                      
                            <Select value={row.routeMulticityLocation} style={{width:'100%'}} showSearch onChange={(location) => handleRowInputChangeMulticity(index, 'routeMulticityLocation', location)}>
                            {currentLocation && currentLocation.map((loc,i)=>(
                                    <Option key={i} value={loc}>{loc}</Option>
                                    ))

                                    }
                            </Select>
                          </Col>
                          <Col span={1} />
                                        <Col span={7} style={{color:"#655bb4"}}>
                            <Select
                              value={row.routeMulticitySpeed}
                              onChange={(value) => handleRowInputChangeMulticity(index, 'routeMulticitySpeed', value)}
                              style={{width:'100%'}}
                            >
                              <Select.Option value="stop">stop</Select.Option>
                              <Select.Option value="Urban">Urban</Select.Option>
                              <Select.Option value="Highway">Highway</Select.Option>
                            </Select>
                          </Col>
                        </Row>
                        </>
                      ))}
                      <Row span={24}>
                       <Col span={1} />
                        <Col span={7} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="route_multicity_time_end"
                          >
                          {/* <TimePicker  value={end_route_time} defaultValue={end_route_time} format={'HH:mm'} onChange={handleChangeEndTime} disabled/> */}
                          <InputNumber   style={{width:'100%'}} value={end_route_multicity_time} defaultValue={end_route_time} onChange={handleChangeMulticityEndTime}/>
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        <Col span={7} style={{color:"#655bb4"}}>
                        <Form.Item
                            // form={Form}
                            name="route_multicity_location_end"
                          >
                            <Select value={end_route_multicity_location} style={{width:'100%'}} showSearch onChange={handleChangeRouteMulticityEndLocation}>
                            {currentLocation && currentLocation.map((loc,i)=>(
                                    <Option key={i} value={loc}>{loc}</Option>
                                    ))

                                    }
                            </Select>
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        <Col span={7} style={{color:"#655bb4"}}>
                        <Form.Item
                            // form={Form}
                            name="route_multicity_vehicle_speed_end"
                          >
                             <Input 
                                disabled
                                defaultValue='Stop'
                                value={end_route_multicity_speed} showSearch onChange={handleChangeRouteMulticityEndSpeed}
                              />
                          </Form.Item>
                        </Col>
                      </Row> 
                        </>
                      )}
                      {value_route_profile =="Transient Profile"  &&(
                        <>
                        <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                        <Form.Item form={Form} name="total_stops" label="Number of stops" >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  min ={0}
                                  value={value_total_stops}
                                  onChange={handleChangeTotalStops}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                       <Row span={24}>
                       <Col span={1} />
                        <Col span={5} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="route_transient_time"
                            label='Time (hr)'
                            style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                          >
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        <Col span={5} style={{color:"#655bb4"}}>
                        <Form.Item
                            // form={Form}
                            name="route_transient_vehicle_speed"
                            tooltip='Urban = 30 mph, Highway = 60 mph'
                            label='Vehicle Speed'
                            style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                          >
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        {/* <Col span={4} style={{color:"#655bb4"}}>
                        <Form.Item
                            // form={Form}
                            name="route_transient_road_grade"
                            tooltip='Positive is uphill,negative is downhill'
                            label='Road Grade'
                               style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                          >
                          </Form.Item>
                        </Col>
                         <Col span={1} /> */}
                        <Col span={5} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="route_transient_product_fixed"
                            label='Product Fixed'
                            tooltip="Fully loaded = 1.0, Empty = 0.0, Partial = ratios between 0 and 1"
                               style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                          >
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        <Col span={4} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="route_transient_door_fixed"
                            label='Door Fixed'
                            style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                         
                          >
                          </Form.Item>
                        </Col>
                      </Row> 
                       <Row span={24}>
                       <Col span={1} />
                        <Col span={5} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="route_transient_time_start"
                          >
                          {/* <TimePicker value={start_route_time} defaultValue={start_route_time} format={'HH:mm'} disabled onChange={handleChangeStartTime}/> */}
                          <InputNumber defaultValue={start_route_time} style={{width:'100%'}} value={start_route_time} disabled onChange={handleChangeStartTime}/>
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        <Col span={5} style={{color:"#655bb4"}}>
                        <Form.Item
                            // form={Form}
                            name="route_transient_vehicle_speed_start"
                          >
                            <Select value={start_route_speed} showSearch onChange={handleChangeRoutestartSpeed}>
                              <Option value="Urban">Urban</Option>
                              <Option value="Highway">Highway</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        {/* <Col span={4} style={{color:"#655bb4"}}>
                        <Form.Item
                            // form={Form}
                            name="route_transient_road_grade_start"
                           
                          >
                                  <InputNumber
                                 style={{width:'100%'}}
                                  value={start_route_road}
                                  onChange={handleChangeRouteStartRoad}
                                />
                          </Form.Item>
                        </Col>
                         <Col span={1} /> */}
                        <Col span={5} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="route_transient_product_fixed_start"
                          
                          >
                                  <InputNumber
                                   style={{width:'100%'}}
                                 display
                                  value={start_route_product}
                                  onChange={handleChangeRouteStartProduct}
                                />
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        <Col span={4} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="route_transient_door_fixed_start"
                          
                          >
                              <Input 
                                disabled
                                defaultValue='Closed'
                                value={start_route_door}
                                  onChange={handleChangeRouteStartdoor}
                              />
                          </Form.Item>
                        </Col>
                      </Row> 
                      {routeStartRows.map((row, index) => (
                        <>
        <Row key={index} style={{marginBottom:"24px"}}>
        <Col span={1} />
                        <Col span={5} style={{color:"#655bb4"}}>
            <InputNumber
              defaultValue={row.routeStartTime}
              min={0}
            max={value_route_time}
            style={{width:'100%'}}
              onChange={(time) => handleRowInputChange(index, 'routeStartTime', time)}
            />
          </Col>
          <Col span={1} />
                        <Col span={5} style={{color:"#655bb4"}}>
            {/* <Select
              value={row.routeStartSpeed}
              onChange={(value) => handleRowInputChange(index, 'routeStartSpeed', value)}
              style={{width:'100%'}}
            >
              <Select.Option value="Urban">Urban</Select.Option>
              <Select.Option value="Highway">Highway</Select.Option>
            </Select> */}
            <Input 
              style={{width:'100%'}}
                                disabled
                                value={row.routeStartSpeed}
              onChange={(value) => handleRowInputChange(index, 'routeStartSpeed', value)}
                              />
          </Col>
          {/* <Col span={1} />
                        <Col span={4} style={{color:"#655bb4"}}>
            <InputNumber
             style={{width:'100%'}}
              value={row.routeStartRoad}
              onChange={(value) => handleRowInputChange(index, 'routeStartRoad', value)}
            />
          </Col> */}
          <Col span={1} />
                        <Col span={5} style={{color:"#655bb4"}}>
            <InputNumber
             style={{width:'100%'}}
              value={row.routeStartProduct}
              onChange={(value) => handleRowInputChange(index, 'routeStartProduct', value)}
            />
          </Col>
          <Col span={1} />
          <Col span={4} style={{color:"#655bb4"}}>
            <Input
            style={{width:'100%'}}
              disabled
              value={row.routeStartDoor}
            />
          </Col>
        </Row>
        <Row key={index} style={{marginBottom:"24px"}}>
        <Col span={1} />
                        <Col span={5} style={{color:"#655bb4"}}>
            <InputNumber
              defaultValue={row.routeEndTime}
              min={0}
            max={value_route_time}
            style={{width:'100%'}}
              onChange={(time) => handleRowInputChange(index, 'routeEndTime', time)}
            />
          </Col>
          <Col span={1} />
                        <Col span={5} style={{color:"#655bb4"}}>
            <Select
              value={row.routeEndSpeed}
              onChange={(value) => handleRowInputChange(index, 'routeEndSpeed', value)}
              style={{width:'100%'}}
            >
              <Select.Option value="Urban">Urban</Select.Option>
              <Select.Option value="Highway">Highway</Select.Option>
            </Select>
          </Col>
          {/* <Col span={1} />
                        <Col span={4} style={{color:"#655bb4"}}>
            <InputNumber
             style={{width:'100%'}}
              value={row.routeEndRoad}
              onChange={(value) => handleRowInputChange(index, 'routeEndRoad', value)}
            />
          </Col> */}
          <Col span={1} />
                        <Col span={5} style={{color:"#655bb4"}}>
            <InputNumber
             style={{width:'100%'}}
             disabled
              value={row.routeEndProduct}
              onChange={(value) => handleRowInputChange(index, 'routeEndProduct', value)}
            />
          </Col>
          <Col span={1} />
          <Col span={4} style={{color:"#655bb4"}}>
            <Input
            style={{width:'100%'}}
              disabled
              value={row.routeEndDoor}
            />
          </Col>
        </Row>
        </>
      ))}
                       <Row span={24}>
                       <Col span={1} />
                        <Col span={5} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="route_transient_time_end"
                          >
                          {/* <TimePicker  value={end_route_time} defaultValue={end_route_time} format={'HH:mm'} onChange={handleChangeEndTime} disabled/> */}
                          <InputNumber   style={{width:'100%'}} value={end_route_time} defaultValue={end_route_time} onChange={handleChangeEndTime} disabled/>
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        <Col span={5} style={{color:"#655bb4"}}>
                        <Form.Item
                            // form={Form}
                            name="route_transient_vehicle_speed_end"
                          >
                             <Input 
                                disabled
                                defaultValue='Stop'
                                value={end_route_speed} showSearch onChange={handleChangeRouteEndSpeed}
                              />
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        {/* <Col span={4} style={{color:"#655bb4"}}>
                        <Form.Item
                            // form={Form}
                            name="route_transient_road_grade_end"
                           
                          >
                                  <InputNumber
                                  style={{width:'100%'}}

                                  value={end_route_road}
                                  onChange={handleChangeRouteEndRoad}
                                />
                          </Form.Item>
                        </Col>
                         <Col span={1} /> */}
                        <Col span={5} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="route_transient_product_fixed_end"
                          
                          >
                                  <InputNumber
                                  style={{width:'100%'}}
                                 disabled
                                 value={end_route_product}
                                  onChange={handleChangeRouteEndProduct}
                                />
                          </Form.Item>
                        </Col>
                         <Col span={1} />
                        <Col span={4} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="route_transient_door_fixed_end"
                          
                          >
                              <Input 
                                disabled
                                defaultValue='Open'
                                value={end_route_door}
                                  onChange={handleChangeRouteEndDoor}
                              />
                          </Form.Item>
                        </Col>
                      </Row> 

                      {/* <Button onClick={handleClick}>Submit</Button> */}
                      {/* <Row span={24}>
                      <Col span={1} />
                      <Col span={7} style={{color:"#655bb4"}}>
                          <div>Roof</div>
                        </Col>
                      <Col span={8}>
                       <Form.Item form={Form} name="roof">
                          <Select placeholder="Roof" showSearch value={value_roofselect} onChange={handleChangeRoofSelect}>
                            <Option value="Polyurethane">Polyurethane</Option>
                            <Option value="Styrofoam">Styrofoam</Option>
                            <Option value="Fiberglass">Fiberglass</Option>
                            <Option value="Plywood">Plywood</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={2} />
                      <Col span={6}>
                        <Form.Item form={Form} name="roof_size">
                          <div style={{ display: "flex" }} className = "InputContainer">
                            <div>
                              <InputNumber
                                
                                value={value_roofsize}
                                onChange={handleChangeRoofSize}
                              />
                            </div>
                            <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.inch}</div>
                          </div>
                        </Form.Item>
                      </Col>
                    </Row> */}
                        </>
                      )}
                      {(value_route_profile !=="Transient Profile" && value_route_profile !=='Multi City Long Haul') &&(
                        <>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="vehicle_speed" label="Vehicle Speed" tooltip={fieldInfo[5]?.children[4]?.tooltip}>
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_vehicle_speed}
                                  onChange={handleChangeVehicleSpeed}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.mperSec}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      {/* <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="road_grade" label="Road Grade" tooltip=' Fixed road grade (positive is uphill, negative is downhill)'>
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  // 
                                  value={value_road_grade}
                                  onChange={handleChangeRoadGrade}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row> */}
                      {value_route_profile == 'Daily Distribution' && (
                        <>


                          <Row span={24}>
                            <Col span={1} />
                            <Col span={23}>
                              <Form.Item form={Form} name="door_opening_frequency" label="Door Opening Frequency" tooltip={fieldInfo[5]?.children[5]?.tooltip}>
                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <InputNumber
                                      
                                      value={value_door_opening_frequency}
                                      onChange={handleChangeDoorOpeningFrequency}
                                    />
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.oneperhr}</div>
                                </div>
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row span={24}>
                            <Col span={1} />
                            <Col span={23}>
                              <Form.Item form={Form} name="door_open_time" label="Door Opening Time" tooltip={fieldInfo[5]?.children[6]?.tooltip}>
                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <InputNumber
                                      
                                      value={value_door_open_time}
                                      onChange={handleChangeDoorOpenTime}
                                    />
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.min}</div>
                                </div>
                              </Form.Item>
                            </Col>
                          </Row>
                          {/* <Row span={24}>
                          <Col span={1} />
                          <Col span={23}>
                            <Form.Item form={Form} name="time_to_load_product" label="Time to Load Product">
                              <div style={{ display: "flex" }} className="InputContainer">
                                <div>
                                  <InputNumber
                                    
                                    value={value_time_to_load}
                                    onChange={handleChangeTimeToLoad}
                                  />
                                </div>
                                <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.min}</div>
                              </div>

                            </Form.Item>
                          </Col>
                        </Row> */}
                        </>
                      )}
                      {value_route_profile == 'Constant Profile' && (
                        <>
                          <Row span={24}>
                            <Col span={1} />
                            <Col span={23}>
                              <Form.Item form={Form} name="product_fixed" label="Product Fixed" tooltip=' Fixed product loading fraction (1=fully loaded, 0 = empty)'>
                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <InputNumber
                                      
                                      value={value_product_fixed}
                                      onChange={handleChangeProductFixed}
                                    />
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                                </div>

                              </Form.Item>
                            </Col>
                          </Row>
                          <Row span={24}>
                            <Col span={1} />
                            <Col span={23}>
                              <Form.Item form={Form} name="door_fixed" label="Door Fixed" tooltip=' Door Opening Fraction (1 = open, 0 = closed)'>
                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <InputNumber
                                      
                                      value={value_door_fixed}
                                      onChange={handleChangeDoorFixed}
                                    />
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{''}</div>
                                </div>

                              </Form.Item>
                            </Col>
                          </Row>
                        </>
                      )}
                      </>
                      )}

                    </Col>
                  </Row>
                </Card>
                <Card className="custom-card">
                  <Row span={24}>
                    <Col span={7} className="card-title">
                      <h3>
                        Weather Condition - Please specify your Weather conditions
                      </h3>
                    </Col>
                    <Col span={17} style={{ padding: '1rem' }}>
                      <Row>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="weather_profile" label="Weather Profile" tooltip={fieldInfo[6]?.children[0]?.tooltip}>
                          <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                            <Select value={value_weather_profile} showSearch onChange={handleChangeWeatherProfile}>
                              <Option value="Constant Profile">Constant</Option>
                              {/* <Option value="TMY Data">TMY Data</Option> */}
                              <Option value="Transient Profile">Transient</Option>
                              <Option value="TMY3">TMY3</Option>
                            </Select>
                            </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                            </div>
                          </Form.Item>
                        </Col>
                        {/* <Col span={1} /> */}
                        {/* <Col span={23}>
                    <Form.Item form={Form} name="altitude" label="Altitude">
                      <div style={{ display: "flex" }} className="InputContainer">
                        <div>
                          <InputNumber
                            
                            value={value_altitude}
                            onChange={handleChangeAltitude}
                          />
                        </div>
                        <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.feet}</div>
                      </div>
                    </Form.Item>
                  </Col> */}
                      </Row>
                      {value_weather_profile === 'Transient Profile' && (
                        <>

                        <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                        <Form.Item form={Form} name="total_rows" label="Number of rows" >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  min ={2}
                                  value={value_total_rows}
                                  onChange={handleChangeTotalRows}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24} className="weatherAlign">
                       <Col span={1} />
                        <Col span={3} style={{color:"#655bb4", textAlign:'center'}}>
                        <Form.Item
                            name="weather_transient_time"
                            label='Trip Time hr'
                            labelAlign="center"
                            style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                          >
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4", textAlign:'center'}}>
                        <Form.Item
                            name="weather_transient_temperature"
                        
                            label={`Temperature ${value_Unit.temp}`}
                            style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                          >
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4", textAlign:'center'}}>
                        <Form.Item
                            name="weather_transient_solar_flux"
                            label= {`Solar Flux ${value_Unit.flux}`}
                               style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                          >
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4", textAlign:'center'}}>
                        <Form.Item
                            name="weather_transient_pressure"
                            label={`Pressure ${value_Unit.pressure}`}
                               style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                          >
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4", textAlign:'center'}}>
                        <Form.Item
                            name="weather_transient_water_vapor_mass_fraction"
                            label='Water Vapor Mass Fraction'
                            style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                         
                          >
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4", textAlign:'center'}}>
                        <Form.Item
                            name="weather_transient_wind_speed"
                            label={`Wind Speed  ${value_Unit.mperSec}`}
                            style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                         
                          >
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4", textAlign:'center'}}>
                        <Form.Item
                            name="weather_transient_sky_emissivity"
                            label='Sky Emissivity'
                            style={{textAlign:"center", display:'flex', justifyContent:'center', margin:0}}
                         
                          >
                          </Form.Item>
                        </Col>
                      </Row> 
                        <Row span={24}>
                         <Col span={1} />
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_time_start"
                            style={{textAlign:'center'}}
                          >
                          <InputNumber
                                  disabled
                                 value={value_weather_transient_time_start}
                                  />
                          </Form.Item>
                        </Col>
                         <Col span={0.5} />
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_Temperature_start"
                            style={{textAlign:'center'}}
                          >
                            <InputNumber
                                 value={value_weather_transient_temp_start}
                                  onChange={handleChangeWeatherTransientTempStart}/>
                          </Form.Item>
                        </Col>
                         <Col span={0.5} />
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_solar_flux_start"
                            style={{textAlign:'center'}}
                          >
                                  <InputNumber
                                  value={value_weather_transient_flux_start}
                                  onChange={handleChangeWeatherTransientFluxStart}
                                />
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_pressure_start"
                            style={{textAlign:'center'}}
                          >
                                  <InputNumber
                                 value={value_weather_transient_pressure_start_decimal}
                                  onChange={handleChangeWeatherTransientPressureStart}
                                />
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_relative_humidity_start"
                            style={{textAlign:'center'}}
                          >
                              <InputNumber
                                value={value_weather_transient_relative_humidity_start}
                                  onChange={handleChangeWeatherTransientMassFractionStart}
                              />
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_wind_speed_start"
                            style={{textAlign:'center'}}
                          >
                              <InputNumber
                                value={value_weather_transient_wind_speed_start}
                                  onChange={handleChangeWeatherTransientWindSpeedStart}
                              />
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_sky_emissivity_start"
                            style={{textAlign:'center'}}
                          >
                              <InputNumber 
                                value={value_weather_transient_sky_emissivity_start}
                                onChange={handleChangeWeatherTransientSkyEmissivityStart}
                              />
                          </Form.Item>
                        </Col>
                      </Row> 
                      {weatherStartRows.map((row, index) => (
                        <>
                        <Row span={24} key={index} style={{marginBottom:"24px"}}>
                       <Col span={1} />
                        <Col span={3} style={{color:"#655bb4",textAlign:'center'}}>
                   
                          <InputNumber
                              defaultValue={row.weatherTripTime}
                            value={row.weatherTripTime}
                              min={value_weather_transient_time_start}
                              max={value_weather_transient_time_end}
                              onChange={(time) => handleWeatherRowInputChange(index, 'weatherTripTime', time)}
                            />
                        </Col>
                         <Col span={0.5} />
                        <Col span={3} style={{color:"#655bb4",textAlign:'center'}} >
                       
                          <InputNumber
                              defaultValue={row.weatherTemperature}
                            value={row.weatherTemperature}
                            
                              onChange={(value) => handleWeatherRowInputChange(index, 'weatherTemperature', value)}
                            />
                        </Col>
                         <Col span={0.5} />
                        <Col span={3} style={{color:"#655bb4",textAlign:'center'}}>
                 
                          <InputNumber
                              defaultValue={row.weatherSolarFlux}
                            value={row.weatherSolarFlux}
                           
                              onChange={(value) => handleWeatherRowInputChange(index, 'weatherSolarFlux', value)}
                            />
                        </Col>
                        <Col span={3} style={{color:"#655bb4",textAlign:'center'}}>
                   
                          <InputNumber
                              defaultValue={row.weatherPressure}
                            value={row.weatherPressure}
                           
                              onChange={(value) => handleWeatherRowInputChange(index, 'weatherPressure', value)}
                            />
                        </Col>
                        <Col span={3} style={{color:"#655bb4",textAlign:'center'}}>
                    
                          <InputNumber
                              defaultValue={row.weatherRelativeHumidity}
                            value={row.weatherRelativeHumidity}
                           
                              onChange={(value) => handleWeatherRowInputChange(index, 'weatherRelativeHumidity', value)}
                            />
                        </Col>
                        <Col span={3} style={{color:"#655bb4",textAlign:'center'}}>
                    
                          <InputNumber
                              defaultValue={row.weatherWindSpeed}
                            value={row.weatherWindSpeed}
                           
                              onChange={(value) => handleWeatherRowInputChange(index, 'weatherWindSpeed', value)}
                            />
                        </Col>
                        <Col span={3} style={{color:"#655bb4",textAlign:'center'}}>
                   
                          <InputNumber
                              defaultValue={row.weatherSkyEmissivity}
                            value={row.weatherSkyEmissivity}
                           
                              onChange={(value) => handleWeatherRowInputChange(index, 'weatherSkyEmissivity', value)}
                            />
                        </Col>
                      </Row> 
                        </>
                      ))}
                        <Row span={24}>
                       <Col span={1} />
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_time_end"
                            style={{textAlign:'center'}}
                          >
                          <InputNumber
                                  disabled
                                 value={value_weather_transient_time_end}
                                  />
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_Temperature_end"
                            style={{textAlign:'center'}}
                          >
                            <InputNumber
                                 value={value_weather_transient_temp_end}
                                  onChange={handleChangeWeatherTransientTempEnd}/>
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_solar_flux_end"
                            style={{textAlign:'center'}}
                          >
                                  <InputNumber
                                  value={value_weather_transient_flux_end}
                                  onChange={handleChangeWeatherTransientFluxEnd}
                                />
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_pressure_end"
                            style={{textAlign:'center'}}
                          >
                                  <InputNumber
                                 value={value_weather_transient_pressure_end_decimal}
                                  onChange={handleChangeWeatherTransientPressureEnd}
                                />
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_relative_humidity_end"
                            style={{textAlign:'center'}}
                          >
                              <InputNumber 
                                
                                value={value_weather_transient_relative_humidity_end}
                                  onChange={handleChangeWeatherTransientMassFractionEnd}
                              />
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_wind_speed_end"
                            style={{textAlign:'center'}}
                          >
                              <InputNumber 
                                value={value_weather_transient_wind_speed_end}
                                  onChange={handleChangeWeatherTransientWindSpeedEnd}
                              />
                          </Form.Item>
                        </Col>
                        <Col span={3} style={{color:"#655bb4"}}>
                        <Form.Item
                            name="weather_transient_sky_emissivity_end"
                            style={{textAlign:'center'}}
                          >
                              <InputNumber 
                                value={value_weather_transient_sky_emissivity_end}
                                onChange={handleChangeWeatherTransientSkyEmissivityEnd}
                              />
                          </Form.Item>
                        </Col>
                      </Row> 
                        </>
                      )}
                      {value_weather_profile !== 'Transient Profile' && value_weather_profile !== 'TMY3' && (
                        <>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="temp_amb" label="Temperature" tooltip={fieldInfo[6]?.children[1]?.tooltip}>
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  ref={ampTemp}
                                  value={value_temp_amb}
                                  onChange={handleChangeTempAmb}
                                  id='testData'
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.temp}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        {/* <Col span={23}>
                    <Form.Item
                      form={Form}
                      name="relative_humidity"
                      label="Relative Humidity"
                    >
                      <div style={{ display: "flex" }} className="InputContainer">
                        <div>
                          <InputNumber
                            
                            value={value_relative_humidity}
                            onChange={handleChangeRelativeHumidity}
                          />
                        </div>
                        <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.percent}</div>
                      </div>
                    </Form.Item>
                  </Col> */}
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="solar_flux"
                            label="Solar Flux"
                            tooltip={fieldInfo[6]?.children[2]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_solar_flux}
                                  onChange={handleChangeSolarFlux}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.flux}</div>
                            </div>
                          </Form.Item>
                        </Col>


                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item
                            form={Form}
                            name="ambient_pressure"
                            label="Pressure"
                            tooltip={fieldInfo[6]?.children[3]?.tooltip}
                          >
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_ambient_pressure}
                                  onChange={handleChangeAmbiantPressure}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.pressure}</div>
                            </div>
                          </Form.Item>
                        </Col>


                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="RH_amb" label="Ambient Relative Humidity" tooltip={fieldInfo[6]?.children[4]?.tooltip}>
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  min={0}
                                  max={1}
                                  step={0.1}
                                  value={value_RH_amb}
                                  onChange={handleChangeVaporMassFraction}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{''}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="wind_speed" label="Effective Wind Speed" tooltip={fieldInfo[6]?.children[5]?.tooltip}>
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_wind_speed}
                                  onChange={handleChangeWindSpeed}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.mperSec}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        {/* <Col span={23}>
                    <Form.Item
                      form={Form}
                      name="sun_cloud_condition"
                      label="Sun/Cloud Condition"
                    >
                      <Select placeholder="Sun/Cloud Condition" showSearch>
                        <Option value="Sunny">Sunny</Option>
                      </Select>
                    </Form.Item>
                  </Col> */}
                        <Col span={23}>
                          <Form.Item form={Form} name="sky_emissivity" label="Sky Emissivity" tooltip={fieldInfo[6]?.children[6]?.tooltip}>
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                                <InputNumber
                                  
                                  value={value_sky_emissivity}
                                  onChange={handleChangeSkyEmissivity}
                                />
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{''}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                        </>
                      )}
                      {value_weather_profile === 'TMY3' && (
                        <>
                        <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="landmass" label="Landmass">
                          <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                            <Select value={value_landmass} showSearch onChange={handleChangeLandmass}>
                              <Option value="North America">North America</Option>
                              {/* <Option value="Europe">Europe</Option>
                              <Option value="ASIA">ASIA</Option> */}
                            </Select>
                            </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                        <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="location" label="Starting Location">
                          <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                            <Select value={value_location} showSearch onChange={handleChangeLocation}>
                            {currentLocation && currentLocation.map((loc,i)=>(
                                    <Option key={i} value={loc}>{loc}</Option>
                                    ))

                                    }
                            </Select>
                            </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{""}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item form={Form} name="date_and_time" label="Date & Time">
                            <div style={{ display: "flex" }} className="InputContainer">
                              <div>
                              <Input
        value={inputValue}
        readOnly
        onClick={showModal}
        suffix={<Button icon="&#11167;" onClick={showModal} />}
      />
      <Modal
        title="Select Date and Time"
        visible={visibleModal}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="today" onClick={handleToday}>
            Today
          </Button>,
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="ok" type="primary" onClick={handleOk}>
            OK
          </Button>,
        ]}
      >
        <div style={{display:'flex', gap:'1rem' ,alignItems:'center',  marginBottom: 16}}>
        <label> Date: </label>
        <Select
          value={selectedMonth}
          onChange={handleMonthChange}
          style={{ width: '100%' }}
        >
          {months.map((month, index) => (
            <Option key={index} value={index}>
              {month}
            </Option>
          ))}
        </Select>
        <Select
          value={selectedDate}
          onChange={handleDateChange}
          style={{ width: '100%' }}
        >
          {dates.map((date) => (
            <Option key={date} value={date}>
              {date}
            </Option>
          ))}
        </Select>
        </div>
        <div style={{display:'flex', gap:'1rem', alignItems:'center'}}>
        <label> Time: </label>
        <Select
          value={selectedHour}
          onChange={handleHourChange}
          style={{ width: '100%', }}
        >
          {hours.map((hour) => (
            <Option key={hour} value={hour}>
              {hour}
            </Option>
          ))}
        </Select>
        <Select
          value={selectedPeriod}
          onChange={handlePeriodChange}
          style={{ width: '100%' }}
        >
          {periods.map((period) => (
            <Option key={period} value={period}>
              {period}
            </Option>
          ))}
        </Select>
        </div>
        {/* <TimePicker
          value={selectedTime}
          onChange={handleTimeChange}
          use12Hours
          format="h A"
          style={{ width: '100%' }}
          minuteStep={60} // Only allow hour selection
        /> */}
      </Modal>
                              </div>
                              <div className="units" style={{ marginLeft: "20px" }}>{" "}</div>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                        </>
                      )}
                    </Col>
                  </Row>
                </Card>
                <Card className="custom-card">
                  <Row span={24}>
                    <Col span={7} className="card-title">
                      <h3>Emission Estimator - Please specify your typical Emission</h3>
                    </Col>
                    <Col span={17} style={{ padding: '1rem' }}>
                      <Row span={24}>
                        <Col span={1} />
                        <Col span={23}>
                          <Form.Item layout='horizontal' form={Form} name="include_emission" label="Include Emission">
                            {/* <Select placeholder="Product Type and Recom'd Set Point" value={value_include_product} showSearch onChange={handleChangeIncludeProduct}>
                          <Option value="Yes">Yes</Option>
                          <Option value="No">No</Option>
                        </Select> */}
                            <Radio.Group onChange={handleChangeIncludeEmission} value={value_include_emission} defaultValue={value_include_emission}>
                              <Radio value="Yes">Yes</Radio>
                              <Radio value="No">No</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                      </Row>
                      {value_include_emission === 'Yes' && (
                        <>
                        <Row span={24}>
                            <Col span={1} />
                            <Col span={23}>
                              <Form.Item form={Form} name="unit_electric_efficiency" label="Unit Electric Efficiency" tooltip={fieldInfo[7]?.children[0]?.tooltip}>
                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <InputNumber  value={value_unit_electric_efficiency} onChange={handleChangeUnitElectricEfficiency}/>
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{ }</div>
                                </div>
                              </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                        <Col span={1} />
                        <Col span={8}>
                          <Form.Item form={Form} name="electric_grid_profile_option" label="Electric Grid Profile">
                          <div style={{display:"flex"}}>
                            <Select value={value_electric_grid_profile_option} showSearch onChange={handleElectricGridProfileOption}>
                              <Option value="Europe Avg">Europe Avg</Option>
                              <Option value="USA Avg">USA Avg</Option>
                              <Option value="Manual">Manual</Option>
                            </Select>
                            <div className="emissionLookup" style={value_electric_grid_profile_option == 'Manual' ? {opacity:"0.5",pointerEvents:'none'} : {}}>
                            <Tooltip title="Lookup Data">
                            <FileSearchOutlined className="emissionluIcon" onClick={() => setShowEmissionModal(true)} style={{cursor: 'pointer', padding:'0.3rem' }}  />
                            </Tooltip>
                            {/* <div }>button</div> */}
                            {showEmissionModal && (
                              <>

                              {/* <EmissionMapModal
                                onClose={() => setShowEmissionModal(false)}
                                onSelect={(value) => handleEmissionlookup(value)}
                                geoJson={value_electric_grid_profile_option == 'Europe Avg' ? europeGeoJson : usangeo}
                                geoData={value_electric_grid_profile_option == 'Europe Avg' ? europeData : usandata}
                                currentCon={value_electric_grid_profile_option == 'Europe Avg' ?'Europe':"USA"}
                              /> */}
                              <MapComponent
                                onClose={() => setShowEmissionModal(false)}
                                onSelect={(value) => handleEmissionlookup(value)}
                                // geoJson={value_electric_grid_profile_option == 'Europe Avg' ? conversionlb(europegeo, currUnit) : conversionlb(usangeo, currUnit)}
                                geoJson={value_electric_grid_profile_option == 'Europe Avg' ? europegeo : usangeo}
                                geoData={value_electric_grid_profile_option == 'Europe Avg' ? conversionlb(europedata, currUnit) : conversionlb(usandata,currUnit)}
                                currentCon={value_electric_grid_profile_option == 'Europe Avg' ?'Europe':"USA"}
                                standardUnit={currUnit}
                              />
                              {/* <europegeo 
                                 onClose={() => setShowEmissionModal(false)}
                                onSelect={(value) => handleEmissionlookup(value)}
                                geoJson={value_electric_grid_profile_option == 'Europe Avg' ? europeGeoJson : usangeo}
                                geoData={value_electric_grid_profile_option == 'Europe Avg' ? europeData : usandata}
                                currentCon={value_electric_grid_profile_option == 'Europe Avg' ?'Europe':"USA"}
                              /> */}
                              </>
                             
                            )}
                            {/* {selectedEmissionValue && <p>Selected Value: {selectedEmissionValue}</p>} */}
                          </div>
                          </div>
                          </Form.Item>
                        </Col>
                        <Col span={1} />
                            <Col span={12}>
                              <Form.Item form={Form} name="electric_grid_profile" label=' '>
                                <div style={{ display: "flex" }} className="InputContainer">
                                  <div>
                                    <InputNumber  value={value_electric_grid_profile} onChange={handleElectricGridProfile} disabled= {(value_electric_grid_profile_option !== 'Manual') ? true : false}/>
                                  </div>
                                  <div className="units" style={{ marginLeft: "20px" }}>{value_Unit.co2einlb}</div>
                                </div>
                              </Form.Item>
                            </Col>
                      </Row>
                        </>
                      )}
                    </Col>
                  </Row>
                </Card>

                <div className="btnContainer">
                  <Row span={24} justify="space-around" align="middle"  ref={btnRef}>
                    <Col span={6} >
                      <Form.Item style={{ margin: "0", padding: '20px' }}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          block
                          size="large"
                          loading={buttonloading}
                        >
                          Submit
                        </Button>

                      </Form.Item>
                      {loader && (
                        <Form.Item style={{ marginTop: "50px", marginBottom: "50px" }}>
                          <Spin tip="Loading Results" size="large">
                            <div className="content" />
                          </Spin>
                        </Form.Item>
                      )}
                    </Col>
                  </Row>
                </div>
              </Form>
              {(FCMT_RESULT && columnsData && resultData) && (
                <div className="resultTab page">
                <Table 
                columns={columnsData} 
                dataSource={resultData} 
                pagination={false} 
                style={{ width: "100%" }} 
                />
                <Card className="custom_graph">
                  <Row span={24}>
                    <Col span={23} className="">
                      <Plot 
                      data={tempData} 
                      layout={tempLayout} 
                      />
                      <div id="graph" style={{ display: "none" }}></div>
                    </Col>
                  </Row>
                </Card>
                <Card className="custom_graph">
                  <Row span={24}>
                    <Col span={23} className="">
                      <Plot 
                      data={engineRunData} 
                      layout={engineRunLayout} 
                      //onInitialized={handleGetChartImage1}
                      />
                      <div id="graph1" style={{ display: "none" }}></div>
                    </Col>
                  </Row>
                </Card>
              </div>
              )}
            </div>
        {/* <Tabs type="card" className='fcmtTabs' defaultActiveKey="1"> */}
          {/* <TabPane tab="Input" key="1">
          </TabPane> */}
          {/* <TabPane tab="Result" className="resultTab" key="2">
            No results
          </TabPane> */}

        {/* </Tabs> */}
        {(FCMT_RESULT && columnsData && resultData) && (
          <div className="btnDownload">
            <Row span={24} justify="space-around" align="middle">
              <Col span={24} style={{display:'flex',gap:'1rem'}}>
                <Button
                  type="primary"
                  block
                  size="large"
                  // loading={downloadLoading}
                  onClick={() => {
                    setVisible(true);
                    }}
                // onClick={handlePDF}
                >
                  Download PDF
                </Button>
                
                <ExportFile payload={payloadData} response={FCMT_RESULT} unit ={isSIIP} ProductIncluded={value_include_product}/>
                <Modal
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  footer={null} // Remove default footer
                  style={{ width: "44px" }}
                >
                
                  <div>
                    <label
                      htmlFor="fileNameInput"
                      style={{ fontWeight: "bold" }}
                    >
                      Enter a file name:
                    </label>
                    <br />
                    <Input
                      placeholder="Enter filename"
                      value={fileName}
                      onChange={(event) =>
                        setFileName(event.target.value.trim())
                      }
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="CustomerNameInput"
                      style={{ fontWeight: "bold" }}
                    >
                      Enter Customer name:
                    </label>
                    <br />
                   
                    <Input
                      placeholder="Enter Customer"
                      value={Customer_name}
                      onChange={handleChangeInputCustomer}
                    />
                  </div>
                  <div>
                    <label htmlFor="Comments" style={{ fontWeight: "bold" }}>
                      Comments:
                    </label>
                    <br />
                    <textarea
                      placeholder="Enter Comment"
                      value={Comments}
                      maxLength={250}
                      onChange={handleChangeInputComment}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Button
                      type="primary"
                      style={{ alignItems: "center", marginTop: "10px" }}
                      onClick={() => {
                        setVisible1(true);
                        // console.log(fileName);
                      }}
                    >
                      Next
                    </Button>
                  </div>
                </Modal>

                {visible1 && (
                  <Modal
                    visible={visible1}
                    onCancel={() => setVisible1(false)}
                    footer={null} // Remove default footer
                    // style={{ width: "100%" }}
                    className="visible1"
                  >
                    {columnsData !== undefined &&
                      resultData !== undefined &&
                      inputtable !== undefined &&
                      fileName !== undefined &&
                      datasource1 !== undefined &&
                      columns1 !== undefined && (
                        <div ref={targetRef}>
                          <PDFMakerFCMT

                            columns={columnsData}
                            resultData={resultData}
                            inputtable={inputtable}
                            Customer_name={Customer_name}
                            Comments={Comments}
                            datasource1={datasource1}
                            columns1={columns1}
                            engineRunLayout= {engineRunLayout}
                            engineRunData= {engineRunData}
                            tempLayout= {tempLayout}
                            tempData= {tempData}
                            includeEmission={value_include_emission}
                          />
                          
                        </div>
                      )}
                      
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}

                    >

                              <Button
                        type="primary"
                        //loading={isLoading}
                        onClick={handleClick}
                    
                        style={{maxWidth : '200px'}}
                      >
                        {isLoading ? (
                           <div className="loader"></div>
                          
                        ) : (
                          "Download")}
                       
                      </Button>
                    </div>
                  </Modal>
                )}
                {downloadLoading && (
                  <div style={{ marginTop: "50px", marginBottom: "50px" }}>
                    <Spin tip="Loading Results" size="large">
                      <div className="content" />
                    </Spin>
                  </div>
                )}
                {/* </Form.Item> */}
              </Col>
            </Row>
          </div>
        )}
        <FieldInfoModal
        visible={isModalVisible}
        onClose={handleCloseInfoModal}
        fieldInfo={fieldInfo}
      />
      </Sidebar>
    </div>
  );
}